// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/shape-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/shape-3.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/shape-4.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/shape-3-1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/shape-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27white%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

html,
body,
* {
  font-family: "Inter", sans-serif;
}

.error-text, .error-feedback {
  color: red;
  font-size: 14px;
}

.profile_user_main .user_info img {
  object-fit: scale-down;
}

html,
body {
  background-color: #ffffff !important;
}

.img_data_collapse {
  height: 440px;
  width: 440px;
}

.mission_img_width {
  height: 509px !important;
}
@media only screen and (max-width: 1199.98px) {
  .mission_img_width {
    height: 409px !important;
  }
}

body {
  overflow-x: hidden;
}

@media only screen and (max-width: 991.98px) {
  html {
    overflow-x: hidden;
  }
}

.btn-outline-primary {
  background: #ffffff !important;
  border: 1px solid #3c5b8a !important;
  color: #3c5b8a !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
}
.btn-outline-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-outline-primary {
    font-size: 14px !important;
  }
}
.btn-outline-primary:hover {
  opacity: 0.75;
  color: #3c5b8a !important;
}

.btn-primary {
  background: #3c5b8a !important;
  border-color: #3c5b8a !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: #ffffff !important;
}
.btn-primary.btn-sm {
  height: 40px;
  font-size: 14px !important;
}
.btn-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-primary {
    font-size: 14px !important;
  }
  .btn-primary svg {
    font-size: 16px;
  }
}
.btn-primary:hover {
  opacity: 0.75;
  color: #ffffff !important;
}

.btn-lt-primary {
  background: rgba(60, 91, 138, 0.13) !important;
  border-color: rgba(60, 91, 138, 0.13) !important;
  height: 50px;
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 50px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  color: #3c5b8a !important;
}
.btn-lt-primary.btn-sm {
  height: 40px;
  font-size: 14px !important;
}
.btn-lt-primary svg {
  font-size: 20px;
  margin-right: 10px;
}
@media only screen and (max-width: 991.98px) {
  .btn-lt-primary {
    font-size: 14px !important;
  }
  .btn-lt-primary svg {
    font-size: 16px;
  }
}
.btn-lt-primary:hover {
  opacity: 0.75;
  color: #3c5b8a !important;
}

@media only screen and (min-width: 1220px) and (max-width: 1440px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm {
    max-width: 1220px !important;
  }
}
.account_show_tax .form-check-input[type=checkbox] {
  border: 2px solid #ccc;
}

.custom_expansion {
  position: relative;
}

.expansion_tag {
  width: 20px;
  height: 20px;
  background: #f31e3d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  position: absolute;
  right: -7px;
  top: -7px;
}

.expansion_tag_manage {
  width: 20px;
  height: 20px;
  background: #f31e3d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
}

/*Header Css Start*/
.header {
  z-index: 1030 !important;
}
.header .navbar {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  background: #ffffff;
  padding-top: 7px;
  padding-bottom: 7px;
}
@media only screen and (max-width: 991.98px) {
  .header .navbar {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
.header .navbar .navbar-brand img {
  height: 72px;
}
@media only screen and (max-width: 991.98px) {
  .header .navbar .navbar-brand img {
    height: 55px;
  }
}
@media only screen and (max-width: 991.98px) {
  .header .navbar .navbar-collapse {
    padding-bottom: 20px !important;
  }
}
.header .navbar .navbar-collapse .navbar-nav .nav-link {
  padding-left: 15px;
  padding-right: 15px;
  color: #6C6A72;
  font-size: 16px;
  font-weight: 500;
}
@media only screen and (max-width: 991.98px) {
  .header .navbar .navbar-collapse .navbar-nav .nav-link {
    padding: 10px 0px !important;
  }
}
.header .navbar .navbar-collapse .navbar-nav .nav-link:hover, .header .navbar .navbar-collapse .navbar-nav .nav-link.active {
  color: #3c5b8a;
}
.header .navbar .navbar-collapse .dropdown .dropdown-toggle::after {
  display: none;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu {
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 10px 0px;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item {
  color: #6C6A72;
  padding: 5px 15px;
  background: transparent;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item:hover, .header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item.active {
  color: #3c5b8a;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item:hover img, .header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item.active img {
  filter: brightness(1) invert(0);
  opacity: 1;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item svg {
  font-size: 20px;
  min-width: 20px;
  margin-right: 5px;
}
.header .navbar .navbar-collapse .dropdown .dropdown-menu a.dropdown-item img {
  margin-right: 5px;
  min-width: 16px;
  filter: brightness(0) invert(0);
  opacity: 0.5;
}
.header .form-switch {
  position: relative;
}
@media only screen and (max-width: 991.98px) {
  .header .form-switch {
    margin: 10px 0px !important;
  }
}
.header .form-switch .form-check-input {
  width: 49px;
  height: 25px;
  border: 1px solid #000000;
  --bs-form-check-bg: #000;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.header .form-switch .form-check-input:checked {
  background-color: #000000;
}
.header .form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: none;
  outline: 0;
  box-shadow: none;
}
.header .form-switch svg {
  position: absolute;
  top: 8px;
  font-size: 18px;
  color: #ffffff;
}
.header .form-switch svg.light-icon {
  right: 5px;
}
.header .form-switch svg.dark-icon {
  left: 5px;
}
.header .right-menu .nav-link.header-search {
  position: relative;
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .nav-link.header-search {
    max-width: 250px;
  }
}
.header .right-menu .nav-link.header-search .form-control {
  font-size: 14px;
  width: 250px;
  max-width: 0;
  padding: 5px;
  transition: all 0.5s ease;
  position: absolute;
  right: 0px;
  box-sizing: border-box;
  opacity: 0;
  outline: none;
  top: 0;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  height: 40px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  padding-left: 12px;
  padding-right: 34px;
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .nav-link.header-search .form-control {
    left: 0;
    right: initial;
    padding-right: 34px;
  }
}
.header .right-menu .nav-link.header-search.search-expanded {
  justify-content: flex-end;
  display: flex;
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .nav-link.header-search.search-expanded {
    padding-right: 10px !important;
  }
}
.header .right-menu .nav-link.header-search.search-expanded .form-control {
  max-width: 250px;
  opacity: 1;
}
.header .right-menu .nav-link svg {
  font-size: 24px;
  opacity: 0.75;
  position: relative;
  z-index: 1;
}
.header .right-menu .dropdown {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .dropdown {
    border: none;
  }
}
.header .right-menu .dropdown .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.header .right-menu .dropdown .nav-link svg {
  font-size: 20px;
  margin-left: 10px;
}
.header .right-menu .btn-get-quote {
  display: inline-flex;
  align-items: center;
  min-width: 180px;
  color: #ffffff;
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .btn-get-quote {
    max-width: 180px;
  }
}
.header .right-menu .btn-get-quote svg {
  font-size: 24px;
  margin-right: 5px;
  opacity: 1;
}
.header .right-menu .btn-login {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0.7rem 1.75rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.95rem;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: #3e6ba3;
  color: #ffffff !important;
  box-shadow: 0 6px 18px rgba(12, 31, 58, 0.12);
  transition: all 0.2s ease;
  margin-right: 1rem;
}
.header .right-menu .btn-login svg {
  font-size: 20px;
  opacity: 0.85;
}
.header .right-menu .btn-login span {
  line-height: 1;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}
.header .right-menu .btn-login:hover, .header .right-menu .btn-login:focus {
  border-color: rgba(0, 201, 255, 0.6);
  background: rgba(0, 201, 255, 0.18);
  color: #ffffff;
  box-shadow: 0 10px 22px rgba(0, 201, 255, 0.26);
  text-decoration: none;
}
@media only screen and (max-width: 991.98px) {
  .header .right-menu .btn-login {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.5rem 1.2rem;
    font-size: 0.85rem;
    max-width: 150px;
    width: 100%;
    justify-content: center;
  }
  .header .right-menu .btn-login svg {
    font-size: 18px;
  }
}
.header .right-menu .btn-account {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0.7rem 1.55rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.95rem;
  background: rgba(255, 255, 255, 0.9);
  color: #10203b;
  border: 1px solid rgba(16, 32, 59, 0.15);
  box-shadow: 0 6px 18px rgba(12, 31, 58, 0.12);
  transition: all 0.2s ease;
}
.header .right-menu .btn-account svg {
  font-size: 20px;
  opacity: 0.85;
}
.header .right-menu .btn-account:hover, .header .right-menu .btn-account:focus {
  color: #ffffff;
  border-color: rgba(0, 201, 255, 0.6);
  background: rgba(0, 201, 255, 0.25);
  box-shadow: 0 10px 22px rgba(0, 201, 255, 0.26);
  text-decoration: none;
}

/*Header Css Ends*/
/*Footer Css Start*/
footer .copyright-area {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  padding-top: 30px;
  padding-bottom: 30px;
}
footer .copyright-area p {
  margin-bottom: 0;
  font-size: 16px;
  color: #6C6A72;
}
@media only screen and (max-width: 767.98px) {
  footer .copyright-area p {
    font-size: 14px;
  }
}
footer .footer-bottom {
  padding: 60px 0px 50px;
}
@media only screen and (max-width: 991.98px) {
  footer .footer-bottom {
    padding: 40px 0px 40px;
  }
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom {
    padding: 25px 0px 25px;
  }
}
@media only screen and (max-width: 991.98px) {
  footer .footer-bottom .footer-column {
    margin-bottom: 25px;
  }
}
footer .footer-bottom .footer-column .footer-heading {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 15px;
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom .footer-column .footer-heading {
    font-size: 20px;
    margin-bottom: 10px;
  }
}
footer .footer-bottom .footer-column ul {
  margin-bottom: 0px;
}
footer .footer-bottom .footer-column ul.help-support li {
  padding: 7px 0px;
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom .footer-column ul.help-support li {
    padding: 5px 0px;
  }
}
footer .footer-bottom .footer-column ul.help-support li a {
  text-decoration: none;
  color: #6C6A72;
  font-size: 16px;
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom .footer-column ul.help-support li a {
    font-size: 14px;
  }
}
footer .footer-bottom .footer-column ul.footer-menu li {
  padding: 7px 0px;
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom .footer-column ul.footer-menu li {
    padding: 5px 0px;
  }
}
footer .footer-bottom .footer-column ul.footer-menu li a {
  text-decoration: none;
  color: #6C6A72;
  font-size: 16px;
}
@media only screen and (max-width: 767.98px) {
  footer .footer-bottom .footer-column ul.footer-menu li a {
    font-size: 14px;
  }
}
footer .footer-bottom .footer-column ul.footer-menu li:hover a {
  color: #3c5b8a;
}
footer .footer-top-area {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area {
    border-bottom: none;
  }
}
footer .footer-top-area .footer-top-one-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area .footer-top-one-wrapper {
    flex-direction: column;
    align-items: flex-start;
    padding-top: 25px;
  }
}
footer .footer-top-area .footer-top-one-wrapper .right-area {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area {
    flex-direction: column;
    align-items: flex-start;
  }
}
footer .footer-top-area .footer-top-one-wrapper .right-area .mailtext {
  font-size: 40px;
  font-weight: 700;
  color: #000000;
  text-decoration: none;
  margin-left: 30px;
}
@media only screen and (max-width: 1199.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .mailtext {
    font-size: 30px;
  }
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .mailtext {
    margin-left: 0px;
  }
}
@media only screen and (max-width: 767.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .mailtext {
    font-size: 20px;
  }
}
footer .footer-top-area .footer-top-one-wrapper .right-area .social-area {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .social-area {
    margin: 20px 0px;
  }
}
footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a {
  height: 120px;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 991.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a {
    height: 80px;
    width: 80px;
  }
}
@media only screen and (max-width: 1199.98px) {
  footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a {
    width: 90px;
  }
}
footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a:hover svg {
  color: #3c5b8a;
}
footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a svg {
  font-size: 30px;
  color: #000000;
}
footer .footer-top-area .footer-top-one-wrapper .right-area .social-area a:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

/*Footer Css Ends*/
/*Loader Css Start*/
.loaderdiv {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 111;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loaderdiv img {
  height: 100px;
  animation: zoom 3s infinite;
}
@keyframes zoom {
  0%, 100% {
    transform: scale(1);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/*Loader Css Ends*/
/*Auth Css Start*/
.login-main {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 120px;
}
.login-main.signup-main {
  padding-top: 90px;
  padding-bottom: 90px;
}
.login-main .loginbg {
  height: 452px;
  width: 100%;
  position: absolute;
  z-index: -1;
  top: 0px;
  background: #000000;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 0% 100%);
}
.login-main .loginbg img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  opacity: 0.41;
}
.login-main .loginform {
  background: #ffffff;
  padding: 70px;
  border-radius: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
}
@media only screen and (max-width: 991.98px) {
  .login-main .loginform {
    padding: 30px;
  }
}
@media only screen and (max-width: 767.98px) {
  .login-main .loginform .btn-primary {
    font-size: 16px !important;
  }
}
.login-main .loginform .headlogin_div h2 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
.login-main .loginform .headlogin_div p {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.5;
  max-width: 320px;
  margin: 0 auto;
}
.login-main .loginform .forgotpassword a {
  color: #000000;
  font-weight: 600;
  text-decoration: none;
  font-size: 16px;
}
.login-main .loginform .formfooter {
  font-size: 16px;
  color: #000000;
}
.login-main .loginform .formfooter a {
  color: #3c5b8a;
  font-weight: 700;
  text-decoration: none;
}
.login-main .loginform .form-group .form-label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
.login-main .loginform .form-group .form-label span {
  opacity: 0.3;
}
.login-main .loginform .form-group .password-input-group svg {
  position: absolute;
  top: 17px;
  right: 20px;
  opacity: 0.3;
}
.login-main .loginform .form-group .form-control {
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.7);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
}
.login-main .loginform .form-group .form-control[type=password] {
  padding-right: 50px;
}
.login-main .loginform .form-group .form-control:focus {
  box-shadow: none;
}
.login-main .loginform .form-group .form-control::placeholder {
  opacity: 0.5;
}

.reset-success .modal-dialog {
  max-width: 437px;
}
.reset-success .modal-dialog .modal-content {
  border-radius: 30px;
}
.reset-success .modal-dialog .modal-content .modal-body {
  text-align: center;
  padding: 40px;
}
.reset-success .modal-dialog .modal-content .modal-body h2 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
.reset-success .modal-dialog .modal-content .modal-body p {
  font-size: 16px;
  color: #6C6A72;
  font-weight: 400;
  line-height: 1.5;
}
.reset-success .modal-dialog .modal-content .modal-body .btn {
  min-width: 177px;
}

/*Auth Css Ends*/
/*Home Css Start*/
.metalFinish_banner {
  padding-top: 60px;
  padding-bottom: 60px;
}
.metalFinish_banner .banner-content h1 {
  font-size: 70px;
  color: #000000;
  margin-bottom: 20px;
  font-weight: 600;
}
@media only screen and (max-width: 1199.98px) {
  .metalFinish_banner .banner-content h1 {
    font-size: 52px;
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 767.98px) {
  .metalFinish_banner .banner-content h1 {
    font-size: 36px;
  }
}
.metalFinish_banner .banner-content h1 span {
  font-weight: 900;
  display: inline-flex;
  position: relative;
  z-index: 1;
  line-height: 1.45;
}
.metalFinish_banner .banner-content h1 span img {
  position: absolute;
  left: 0px;
  bottom: -22px;
}
.metalFinish_banner .banner-content p {
  color: #000000;
  font-size: 22px;
  line-height: 1.75;
  margin-bottom: 0px;
}
@media only screen and (max-width: 1199.98px) {
  .metalFinish_banner .banner-content p {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767.98px) {
  .metalFinish_banner .banner-content p {
    font-size: 16px;
  }
}

.banner-home {
  padding-top: 60px;
  padding-bottom: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.banner-home.banner-about {
  padding-top: 75px;
  padding-bottom: 0;
  min-height: 236px;
}
@media only screen and (max-width: 767.98px) {
  .banner-home.banner-about {
    min-height: 200px;
  }
}
@media only screen and (max-width: 991.98px) {
  .banner-home {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.banner-home .banner-content {
  text-align: center;
  max-width: 880px;
  margin: 0 auto;
}
.banner-home .banner-content ul {
  margin-top: 25px;
  margin-bottom: 25px;
}
@media only screen and (max-width: 767.98px) {
  .banner-home .banner-content ul {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
.banner-home .banner-content ul li {
  display: inline-flex;
  margin: 0px 18px 15px;
  align-items: center;
  justify-content: center;
  padding: 0px 17px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  height: 46px;
  border-radius: 30px;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}
@media only screen and (max-width: 767.98px) {
  .banner-home .banner-content ul li {
    font-size: 14px;
  }
}
.banner-home .banner-content ul li svg {
  font-size: 24px;
  color: #3c5b8a;
  margin-right: 10px;
}
.banner-home .banner-content h1 {
  font-size: 40px;
  color: #000000;
  margin-bottom: 10px;
  font-weight: 700;
}
@media only screen and (max-width: 1199.98px) {
  .banner-home .banner-content h1 {
    font-size: 36px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-home .banner-content h1 {
    font-size: 30px;
  }
}
.banner-home .banner-content h1 span {
  font-weight: 900;
  display: inline-flex;
  position: relative;
  z-index: 1;
  line-height: 1.45;
}
.banner-home .banner-content h1 span img {
  position: absolute;
  left: 0px;
  bottom: -15px;
}
.banner-home .banner-content h4 {
  font-weight: 400;
  color: #000000;
}
.banner-home .banner-content h4 b {
  font-weight: 700;
}
.banner-home .banner-content p {
  color: #000000;
  font-size: 22px;
  line-height: 1.75;
}
.banner-home .banner-content p.bannersubpara {
  font-size: 16px;
  color: #bebdbe;
}
@media only screen and (max-width: 1199.98px) {
  .banner-home .banner-content p {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-home .banner-content p {
    font-size: 16px;
  }
}
.banner-home .banner-content p.banner-sm-text {
  font-size: 18px;
}
@media only screen and (max-width: 1199.98px) {
  .banner-home .banner-content p.banner-sm-text {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-home .banner-content p.banner-sm-text {
    font-size: 14px;
  }
}

.homereviews {
  background-color: #f7f7f7;
  padding-top: 60px;
  padding-bottom: 60px;
}
.homereviews .reviewslist {
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 25px;
}
.homereviews .reviewslist .reviewsleftcontent .reviewuser {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 14px;
}
.homereviews .reviewslist .reviewsleftcontent .reviewuser img {
  width: 100px;
  height: 100px;
}
.homereviews .reviewslist .reviewsleftcontent .reviewuser h5 {
  font-size: 16px;
  color: #000000;
  font-weight: 700;
  margin-top: 10px;
}
.homereviews .reviewslist .reviewsleftcontent h3 {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
}
.homereviews .reviewslist .reviewsleftcontent p {
  color: #000000;
  font-size: 16px;
  line-height: 1.75;
  margin-bottom: 0;
  text-align: start;
}
.homereviews .reviewslist .reviewsleftcontent .reviewrate .iconify {
  color: #ffda3f;
  font-size: 40px;
}
.homereviews .reviewslist .reviewsrightcontent h2 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge h4 {
  font-size: 18px;
  color: #000000;
  font-weight: 400;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .aluminiumbadge {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  padding: 3px 10px;
  background: rgba(79, 140, 202, 0.2);
  border-radius: 20px !important;
  text-decoration: none;
  display: inline-block;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .aluminiumbadge .iconify {
  color: #4F8CCA;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .brassbadge {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  padding: 3px 10px;
  background: rgba(239, 144, 0, 0.2);
  border-radius: 20px !important;
  display: inline-block;
  text-decoration: none;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .brassbadge .iconify {
  color: #ef9000;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .steelbadge {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  padding: 3px 10px;
  background: rgba(225, 31, 38, 0.2);
  border-radius: 20px !important;
  text-decoration: none;
  display: inline-block;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .steelbadge .iconify {
  color: #E11F26;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge p {
  line-height: normal;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge p a {
  font-size: 12px;
  color: #c4bdbe;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge p a:hover {
  opacity: 0.75;
}
.homereviews .reviewslist .reviewsrightcontent .reviewbadge .lasercuttingbadge {
  font-size: 14px;
  display: inline-block;
  color: #000000;
  font-weight: 600;
  padding: 3px 8px;
  text-decoration: none;
  background: rgba(79, 140, 202, 0.2);
  border-radius: 20px !important;
}
.homereviews .reviewslist .reviewsrightcontent .imgreviewhome {
  max-width: 350px;
  margin-bottom: 40px;
}
@media only screen and (max-width: 11997.98px) {
  .homereviews .reviewslist .reviewsrightcontent .imgreviewhome {
    margin-top: 0px;
  }
}
@media only screen and (max-width: 767.98px) {
  .homereviews .reviewslist .reviewsrightcontent .imgreviewhome {
    max-width: 100%;
  }
}

.faq-home {
  background-color: #f7f7f7;
  padding-top: 80px;
  padding-bottom: 80px;
}
.faq-home .faqsubhead {
  font-size: 22px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: capitalize;
}
.faq-home .accordion .accordion-item {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  border-radius: 12px !important;
}
.faq-home .accordion .accordion-item .accordion-header {
  margin-bottom: 0 !important;
}
.faq-home .accordion .accordion-item .accordion-header button.accordion-button {
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 12px !important;
  color: #000000;
  padding: 15px;
  background: #ffffff;
  box-shadow: none;
}
.faq-home .accordion .accordion-item .accordion-header button.accordion-button:after {
  transform: rotate(-90deg);
  width: 24px;
  height: 24px;
  border: 1px solid #000000;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-size: 13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  opacity: 0.4;
}
.faq-home .accordion .accordion-item .accordion-header button.accordion-button:not(.collapsed) {
  color: #000000;
}
.faq-home .accordion .accordion-item .accordion-header button.accordion-button:not(.collapsed):after {
  transform: rotate(-180deg);
}
.faq-home .accordion .accordion-item .accordion-body {
  padding-left: 16px;
  padding-top: 0;
  font-size: 14px;
  line-height: 1.75;
  color: #6C6A72;
}

.american-manufacturing {
  padding-top: 70px;
  padding-bottom: 80px;
}
.american-manufacturing img {
  max-width: 350px;
}
.american-manufacturing h4 {
  color: #000000;
  font-weight: 500;
}

.our-services {
  padding-top: 165px;
  padding-bottom: 240px;
  position: relative;
  overflow: hidden;
}
@media only screen and (max-width: 991.98px) {
  .our-services {
    padding-bottom: 80px;
    padding-top: 100px;
  }
}
.our-services .services-img {
  position: relative;
  z-index: 1;
}
.our-services .services-img img {
  object-fit: cover;
}
@media only screen and (max-width: 991.98px) {
  .our-services .services-img {
    margin-bottom: 30px;
  }
}
.our-services .services-img:before {
  content: "";
  width: 772px;
  height: 772px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 772px 772px;
  background-repeat: no-repeat;
  position: absolute;
  top: -161px;
  left: -195px;
  opacity: 0.22;
  z-index: -1;
}
@media only screen and (max-width: 991.98px) {
  .our-services .services-img:before {
    width: 572px;
    height: 572px;
    background-size: 572px 572px;
    top: -70px;
    left: -86px;
  }
}
.our-services .services-grid {
  position: relative;
  z-index: 1;
  background: #ffffff;
  padding: 45px 15px;
  text-align: center;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  display: block;
  text-decoration: none;
}
@media only screen and (max-width: 1199.98px) {
  .our-services .services-grid {
    padding: 25px 15px;
  }
}
@media only screen and (max-width: 767.98px) {
  .our-services .services-grid {
    margin-bottom: 20px;
  }
}
.our-services .services-grid h2 {
  font-size: 22px;
  color: #000000;
  font-weight: 700;
}
@media only screen and (max-width: 1199.98px) {
  .our-services .services-grid h2 {
    font-size: 18px;
  }
}
.our-services .services-grid p {
  font-size: 16px;
  color: #6C6A72;
}
@media only screen and (max-width: 1199.98px) {
  .our-services .services-grid p {
    font-size: 14px;
  }
}
.our-services .services-grid .single-item-thumbs {
  position: relative;
  z-index: 0;
  width: 132px;
  height: 100px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  margin: 0 auto 22px;
}
.our-services .services-grid:after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 52px;
  height: 75px;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0;
}
.our-services .services-grid:hover {
  background: #3c5b8a;
  cursor: pointer;
}
.our-services .services-grid:hover h2,
.our-services .services-grid:hover p {
  color: #ffffff;
}
.our-services .services-grid:hover .single-item-thumbs {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.our-services .services-grid:hover .single-item-thumbs img {
  filter: brightness(0) invert(1);
}
.our-services .services-grid:hover:after {
  opacity: 1;
}

.max-width-470 {
  max-width: 470px;
}

.max-width-810 {
  max-width: 810px;
}

.heading h2 {
  font-size: 48px;
  color: #000000;
  font-weight: 800;
  text-transform: capitalize;
}
@media only screen and (max-width: 1199.98px) {
  .heading h2 {
    font-size: 36px;
  }
}
.heading p {
  font-size: 18px;
  color: #6C6A72;
  line-height: 1.6;
}
@media only screen and (max-width: 1199.98px) {
  .heading p {
    font-size: 16px;
  }
}

.materials-grid {
  background: #ffffff;
  border: 2px solid #ffffff;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  height: 100%;
  min-height: 316px;
  display: block;
  text-decoration: none;
}
.materials-grid.hover-aluminum:hover {
  border: 2px solid #3c5b8a;
}
.materials-grid.hover-steel:hover {
  border: 2px solid #E11F26;
}
.materials-grid.hover-stainless-steel:hover {
  border: 2px solid #2A5C17;
}
.materials-grid.hover-brass:hover {
  border: 2px solid #FFBA16;
}
.materials-grid.hover-custom:hover {
  border: 2px solid #7367F0;
}
.materials-grid:hover {
  cursor: pointer;
}
.materials-grid .materials-info {
  display: flex;
  align-items: center;
}
.materials-grid .materials-info .material-img {
  width: 92px;
  min-width: 92px;
  height: 92px;
  display: inline-block;
  border-radius: 10px;
  margin-right: 20px;
  overflow: hidden;
}
@media only screen and (max-width: 1199.98px) {
  .materials-grid .materials-info .material-img {
    width: 72px;
    min-width: 72px;
    height: 72px;
    margin-right: 10px;
  }
}
.materials-grid .materials-info h2 {
  font-size: 27px;
  color: #000;
  font-weight: 700;
  margin-bottom: 0px;
}
@media only screen and (max-width: 1199.98px) {
  .materials-grid .materials-info h2 {
    font-size: 22px;
  }
}
.materials-grid .material-grade.material-grade2 span {
  opacity: 0.6;
  min-width: 71px;
}
.materials-grid .material-grade span {
  height: 29px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0px 15px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #000000;
  border-radius: 30px;
}

.min-width-84 {
  min-width: 84px;
}

.bgprimary {
  background: #3c5b8a !important;
}

.bgdanger {
  background: #E11F26 !important;
}

.bgsuccess {
  background: #2A5C17 !important;
}

.bgyellow {
  background: #FFBA16 !important;
}

.bgpurple {
  background: #7367F0 !important;
}

.get-instant-quote {
  padding-top: 100px;
  padding-bottom: 100px;
}
@media only screen and (max-width: 991.98px) {
  .get-instant-quote {
    padding-bottom: 80px;
    padding-top: 80px;
  }
}
.get-instant-quote.get-parts {
  padding-top: 0px;
}
.get-instant-quote.get-parts .get-parts-img {
  position: relative;
  z-index: 1;
  text-align: end;
}
@media only screen and (max-width: 991.98px) {
  .get-instant-quote.get-parts .get-parts-img {
    margin-top: 25px;
  }
}
.get-instant-quote.get-parts .get-parts-img:after {
  content: "";
  width: 772px;
  height: 772px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: 772px 772px;
  background-repeat: no-repeat;
  position: absolute;
  top: -161px;
  right: -195px;
  opacity: 0.22;
  z-index: -1;
  transform: rotate(-12deg);
}
@media only screen and (max-width: 991.98px) {
  .get-instant-quote.get-parts .get-parts-img:after {
    width: 572px;
    height: 572px;
    background-size: 572px 572px;
    top: -66px;
    right: -84px;
  }
}
@media only screen and (max-width: 991.98px) {
  .get-instant-quote .get-quote-img {
    margin-bottom: 25px;
  }
}
.get-instant-quote .get-quote-img .portal-inner {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.get-instant-quote .get-quote-img .portal-inner:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.04);
  z-index: 1;
  border-radius: 15px;
}
.get-instant-quote .get-quote-img .portal-inner .top-portal {
  position: absolute;
  width: 100%;
  top: 0px;
  padding: 10px 20px;
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1;
}
.get-instant-quote .get-quote-img .portal-inner .bottom-img {
  animation: moveUpDown 12s infinite;
  margin-top: 41px;
}
@keyframes moveUpDown {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-100px);
  }
}
.get-instant-quote .get-quote-content {
  position: relative;
  z-index: 11;
}
.get-instant-quote .get-quote-content .features-content-box {
  background: #ffffff;
  padding: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  display: flex;
  align-items: center;
  border-left: 3px solid #ffffff;
}
.get-instant-quote .get-quote-content .features-content-box:hover {
  border-left: 3px solid #3c5b8a;
  cursor: pointer;
}
.get-instant-quote .get-quote-content .features-content-box:not(:last-child) {
  margin-bottom: 17px;
}
.get-instant-quote .get-quote-content .features-content-box .feature-icon {
  width: 91px;
  min-width: 91px;
  height: 91px;
  border-radius: 50%;
  background: rgba(60, 91, 138, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}
@media only screen and (max-width: 1199.98px) {
  .get-instant-quote .get-quote-content .features-content-box .feature-icon {
    width: 75px;
    min-width: 75px;
    height: 75px;
  }
}
.get-instant-quote .get-quote-content .features-content-box .feature-icon svg {
  font-size: 36px;
  color: #3c5b8a;
}
.get-instant-quote .get-quote-content .features-content-box .content h3 {
  font-size: 22px;
  color: #000000;
  font-weight: 600;
}
@media only screen and (max-width: 1199.98px) {
  .get-instant-quote .get-quote-content .features-content-box .content h3 {
    font-size: 18px;
  }
}
.get-instant-quote .get-quote-content .features-content-box .content p {
  font-size: 16px;
  color: #6C6A72;
  margin-bottom: 0px;
}
@media only screen and (max-width: 1199.98px) {
  .get-instant-quote .get-quote-content .features-content-box .content p {
    font-size: 14px;
  }
}

.our-testimonials .testimonial-shape {
  position: absolute;
  top: -60px;
  width: 100%;
}
.our-testimonials .our-testimonials {
  margin-top: 60px;
}
.our-testimonials .slick-slide {
  padding: 0px 10px;
}
.our-testimonials .testimonials-grid {
  background: #ffffff;
  padding: 0px 30px 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  margin: 50px 0px 10px;
  border-radius: 12px;
}
@media only screen and (max-width: 1199.98px) {
  .our-testimonials .testimonials-grid {
    padding: 0px 20px 20px;
  }
}
.our-testimonials .testimonials-grid .userinfo {
  text-align: center;
}
.our-testimonials .testimonials-grid .userinfo img {
  width: 101px;
  min-width: 101px;
  height: 101px;
  margin-top: -50px;
}
.our-testimonials .testimonials-grid .userinfo h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 3px;
  margin-top: 15px;
}
@media only screen and (max-width: 1199.98px) {
  .our-testimonials .testimonials-grid .userinfo h3 {
    font-size: 18px;
  }
}
.our-testimonials .testimonials-grid .userinfo p {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
}
@media only screen and (max-width: 1199.98px) {
  .our-testimonials .testimonials-grid .userinfo p {
    font-size: 14px;
  }
}
.our-testimonials .testimonials-grid .userinfo .testimonial-rating svg {
  color: #FFBA16;
}
.our-testimonials .testimonials-grid .testimonial-quote {
  opacity: 0.05;
}
@media only screen and (max-width: 1199.98px) {
  .our-testimonials .testimonials-grid .testimonial-quote img {
    height: 40px;
  }
}
.our-testimonials .testimonials-grid .testimonials-content {
  margin-top: 20px;
}
.our-testimonials .testimonials-grid .testimonials-content p {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 400;
  color: #6C6A72;
  line-height: 1.75;
  text-align: center;
}
@media only screen and (max-width: 1199.98px) {
  .our-testimonials .testimonials-grid .testimonials-content p {
    font-size: 14px;
  }
}

.cta {
  padding-top: 100px;
  padding-bottom: 100px;
}
@media only screen and (max-width: 991.98px) {
  .cta {
    padding-top: 70px;
    padding-bottom: 80px;
  }
}

.maincontent_div {
  padding-top: 98px;
}
@media only screen and (max-width: 991.98px) {
  .maincontent_div {
    padding-top: 73px;
  }
}
.maincontent_div .banner-upload-file {
  background: rgba(0, 0, 0, 0.03);
  border: 1px dashed rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 30px;
  cursor: pointer;
}
.maincontent_div .banner-upload-file.processing-added {
  position: relative;
  z-index: 1;
  overflow: hidden;
  pointer-events: none;
}
.maincontent_div .banner-upload-file.processing-added:before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.5);
}
.maincontent_div .banner-upload-file.processing-added .loader {
  position: absolute;
  z-index: 2;
  color: #ffffff;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.maincontent_div .banner-upload-file.processing-added .loader svg {
  animation: rotate 2s linear infinite;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.maincontent_div .banner-upload-file svg {
  font-size: 60px;
}
.maincontent_div .banner-upload-file small {
  font-size: 17px;
  font-weight: 300;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .maincontent_div .banner-upload-file small {
    font-size: 14px;
  }
}
.maincontent_div .banner-upload-file p {
  font-size: 20px;
  opacity: 1;
  margin: 10px 0px 5px;
}
@media only screen and (max-width: 1199.98px) {
  .maincontent_div .banner-upload-file p {
    font-size: 18px;
  }
}
.maincontent_div .banner-upload-file p label {
  color: #3c5b8a;
  font-weight: 500;
  border-bottom: 1px solid #3c5b8a;
  line-height: normal;
  cursor: pointer;
}
.maincontent_div .invalid-dxf-files__panel {
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: rgba(255, 186, 22, 0.06);
  border-radius: var(--bs-border-radius);
  overflow: visible;
}
.maincontent_div .invalid-dxf-files__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.9375rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background-color: rgba(255, 186, 22, 0.12);
}
.maincontent_div .invalid-dxf-files__icon {
  color: #b38200;
  flex-shrink: 0;
}
.maincontent_div .invalid-dxf-files__message {
  line-height: 1.35;
}
.maincontent_div .invalid-dxf-files__row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.maincontent_div .invalid-dxf-files__filename {
  font-size: 0.875rem;
  word-break: break-all;
}
.maincontent_div .invalid-dxf-files__dropdown {
  flex-shrink: 0;
  min-width: 120px;
}
.maincontent_div .invalid-dxf-files__footer {
  padding: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.maincontent_div .pagination_order {
  list-style: none;
  padding: 0px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  flex-wrap: wrap;
}
.maincontent_div .pagination_order li.page-item {
  display: inline-block;
}
.maincontent_div .pagination_order li.page-item button.page-link {
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 12px;
  font-size: 14px;
  border: 1px solid color(srgb 0 0 0 / 0.09);
  font-weight: 500;
  color: #3b3b3b;
}
.maincontent_div .pagination_order li.page-item span {
  color: #000000;
}
.maincontent_div .pagination_order li.page-item.active button.page-link {
  background: #3c5b8a;
  color: #ffffff;
}

/*Home Css Ends*/
/*About Us Css Ends*/
.our-history {
  padding-top: 90px;
  padding-bottom: 30px;
}
@media only screen and (max-width: 991.98px) {
  .our-history {
    padding-top: 80px;
    padding-bottom: 20px;
  }
}
.our-history .history-grid {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px;
}
.our-history .history-grid h3 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}
.our-history .history-grid h3:before {
  content: "";
  position: absolute;
  left: -20px;
  width: 4px;
  height: 100%;
  background: #3c5b8a;
}
.our-history .history-grid img {
  border-radius: 12px;
  height: 150px;
  object-fit: cover;
  width: 100%;
  margin-bottom: 20px;
}
.our-history .history-grid p {
  font-size: 12px;
  color: #6C6A72;
  line-height: 1.75;
  text-align: center;
}
@media only screen and (max-width: 991.98px) {
  .our-history .history-grid p {
    margin-bottom: 0;
  }
}

.slick-slider .slick-dots li {
  width: auto;
  height: auto;
}
.slick-slider .slick-dots li button {
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background: #3c5b8a;
}
.slick-slider .slick-dots li button::before {
  display: none !important;
}
.slick-slider .slick-dots li.slick-active button {
  width: 25px;
}

.our-mission .mission-img {
  display: inline-block;
  position: relative;
  z-index: 1;
}
.our-mission .mission-img img {
  border-radius: 50px;
}
.our-mission .mission-img:after {
  content: "";
  background: #F3F4F6;
  position: absolute;
  left: 30px;
  top: -30px;
  right: -30px;
  bottom: 30px;
  z-index: -1;
  border-radius: 50px;
}
@media only screen and (max-width: 991.98px) {
  .our-mission .mission-content {
    margin-top: 25px;
  }
}
.our-mission .mission-content h4 {
  font-size: 22px;
  font-weight: 600;
  margin: 20px 0px;
}
@media only screen and (max-width: 1199.98px) {
  .our-mission .mission-content h4 {
    font-size: 18px;
  }
}
.our-mission .mission-content p {
  font-size: 18px;
  line-height: 1.75;
  color: #6C6A72;
}
@media only screen and (max-width: 1199.98px) {
  .our-mission .mission-content p {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767.98px) {
  .our-mission .mission-content p {
    font-size: 14px;
  }
}

.core-values {
  padding-top: 100px;
  padding-bottom: 100px;
}
@media only screen and (max-width: 991.98px) {
  .core-values {
    padding-top: 60px;
    padding-bottom: 70px;
  }
}
.core-values .values-grid {
  text-align: center;
  border: 2px solid #ffffff;
  height: 100%;
  min-height: 350px;
  padding: 30px 20px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
}
.core-values .values-grid:hover {
  border: 2px solid #3c5b8a;
}
.core-values .values-grid .single-item-thumbs {
  position: relative;
  z-index: 0;
  width: 132px;
  height: 100px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  margin: 0 auto 22px;
}
.core-values .values-grid .single-item-thumbs svg {
  font-size: 35px;
  color: #3c5b8a;
}
.core-values .values-grid h3 {
  font-size: 24px;
  color: #000000;
  font-weight: 700;
}
@media only screen and (max-width: 1199.98px) {
  .core-values .values-grid h3 {
    font-size: 20px;
  }
}
.core-values .values-grid p {
  font-size: 14px;
  line-height: 1.75;
  color: #6C6A72;
  margin-bottom: 0px;
}

/*About Us Css Ends*/
/*Services Css Start*/
.loginUploadInfo_text {
  display: block;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #bfbfbf;
}

.banner-services .banner-service-img {
  display: inline-block;
  position: relative;
  z-index: 1;
}
@media only screen and (max-width: 991.98px) {
  .banner-services .banner-service-img {
    margin-top: 25px;
  }
}
.banner-services .banner-service-img img {
  border-radius: 0px 150px 0px 150px;
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-service-img img {
    border-radius: 0px 100px 0px 100px;
  }
}
.banner-services .banner-service-img:after {
  content: "";
  border-radius: 0px 150px 0px 150px;
  position: absolute;
  left: 20px;
  right: -20px;
  top: -20px;
  bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  z-index: -1;
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-service-img:after {
    border-radius: 0px 100px 0px 100px;
  }
}
.banner-services .banner-content h1 {
  font-size: 70px;
}
@media only screen and (max-width: 1199.98px) {
  .banner-services .banner-content h1 {
    font-size: 50px;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-content h1 {
    font-size: 36px;
  }
}
.banner-services .banner-content .bannerservice_btns {
  text-align: center;
}
.banner-services .banner-content .banner-btns {
  display: flex;
  gap: 25px;
}
@media only screen and (max-width: 1199.98px) {
  .banner-services .banner-content .banner-btns {
    gap: 10px;
    flex-direction: column;
  }
}
@media only screen and (max-width: 991.98px) {
  .banner-services .banner-content .banner-btns {
    flex-direction: row;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-content .banner-btns {
    flex-direction: column;
  }
}
.banner-services .banner-content .banner-btns .btn {
  flex: 1 1;
}
@media only screen and (max-width: 1199.98px) {
  .banner-services .banner-content .banner-btns .btn {
    flex: initial;
  }
}
.banner-services .banner-content .banner-btns .btn svg {
  font-size: 24px;
}
.banner-services .banner-content .banner-upload-file p {
  font-size: 18px;
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-content .banner-upload-file p {
    font-size: 16px;
  }
}
.banner-services .banner-content .banner-upload-file small {
  font-size: 16px;
}
@media only screen and (max-width: 1199.98px) {
  .banner-services .banner-content .banner-upload-file small {
    font-size: 14px;
  }
}
.banner-services .banner-content h1 {
  margin-bottom: 25px;
}
.banner-services .banner-content p {
  font-size: 20px;
}
@media only screen and (max-width: 1199.98px) {
  .banner-services .banner-content p {
    font-size: 18px;
  }
}
@media only screen and (max-width: 767.98px) {
  .banner-services .banner-content p {
    font-size: 16px;
  }
}

.maxWidth_680 {
  max-width: 680px;
  margin: 0px auto;
}

.pb_70 {
  padding-bottom: 70px;
}

.lasercuttingmaterial {
  padding-top: 80px;
  padding-bottom: 80px;
}

.lasercuttingbreakdown {
  background-color: #f7f7f7;
}

.laserCuttingInfo_sec {
  padding-top: 80px;
  padding-bottom: 70px;
  background-color: #f7f7f7;
}
.laserCuttingInfo_sec .laserCuttingInfo_div h3 {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}
.laserCuttingInfo_sec .laserCuttingInfo_div h4 {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 10px;
}
.laserCuttingInfo_sec .laserCuttingInfo_div p {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 10px;
}
.laserCuttingInfo_sec .laserCuttingInfo_div p b {
  font-weight: 600;
}
.laserCuttingInfo_sec .laserCuttingInfo_div ul {
  list-style: auto;
  margin: 0px;
  padding-left: 20px;
}
.laserCuttingInfo_sec .laserCuttingInfo_div ul.listcustom {
  list-style: disc;
  margin-top: 10px;
  margin-bottom: 12px;
}
.laserCuttingInfo_sec .laserCuttingInfo_div ul li {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 6px;
}

.metalfinish_sec {
  padding-bottom: 60px;
}
.metalfinish_sec .metalfinish_sec_inner {
  background-color: #f7f7f7;
  padding-top: 40px;
  padding-bottom: 30px;
}
.metalfinish_sec .metalfinish_div {
  margin-bottom: 20px;
}
.metalfinish_sec .metalfinish_div h4 {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 10px;
}
.metalfinish_sec .metalfinish_div p {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 10px;
}
.metalfinish_sec .metalfinish_div ul {
  list-style: disc;
  margin: 0px 0px 10px;
}
.metalfinish_sec .metalfinish_div ul li {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
}
.metalfinish_sec .metalfinish_div .metalfinish_box {
  text-align: center;
}
.metalfinish_sec .metalfinish_div .metalfinish_box img {
  width: 100%;
  height: 350px;
  border-radius: 15px;
  object-fit: cover;
  margin-bottom: 10px;
  object-position: bottom center;
}
@media only screen and (max-width: 767.98px) {
  .metalfinish_sec .metalfinish_div .metalfinish_box img {
    height: auto;
  }
}
.metalfinish_sec .metalfinish_div .metalfinish_box h5 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0px;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.steelColor img {
  border: 2px solid #e01f26;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.steelColor h5 {
  color: #e01f26;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.stainlessColor img {
  border: 2px solid #00bf63;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.stainlessColor h5 {
  color: #00bf63;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.aluminumColor img {
  border: 2px solid #4e8ac8;
}
.metalfinish_sec .metalfinish_div .metalfinish_box.aluminumColor h5 {
  color: #4e8ac8;
}

.HowITWorksmain_div {
  padding-top: 80px;
  padding-bottom: 80px;
}
.HowITWorksmain_div .worksMain_head {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 20px;
}
.HowITWorksmain_div .worksStep_head {
  font-size: 24px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 15px;
}
.HowITWorksmain_div .HowITWorksteps_box {
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 25px;
}
.HowITWorksmain_div .HowITWorksteps_box video {
  border-radius: 12px;
  width: 100%;
  height: auto;
}
.HowITWorksmain_div .HowITWorksteps_box .StepIcon_img {
  flex-shrink: 0;
  max-width: 50px;
}
.HowITWorksmain_div .HowITWorksteps_box .Worksteps_cont {
  flex-grow: 1;
}
.HowITWorksmain_div .HowITWorksteps_box .Worksteps_cont h4 {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 5px;
}
.HowITWorksmain_div .HowITWorksteps_box .Worksteps_cont p {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 5px;
}

.laserProduct_sec {
  padding: 70px 0px;
  transition: ease-in-out 0.7s;
}
.laserProduct_sec .Productmain_box {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.07);
  padding: 15px;
  text-align: center;
  cursor: pointer;
  height: 100%;
}
.laserProduct_sec .Productmain_box:hover .Product_img img.img_default {
  opacity: 0;
  transition: ease-in-out 0.7s;
}
.laserProduct_sec .Productmain_box:hover .Product_img img.img_hover {
  opacity: 1;
  transition: ease-in-out 0.7s;
}
.laserProduct_sec .Productmain_box .Product_img {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  height: 270px;
  margin-bottom: 10px;
}
@media only screen and (min-width: 1400px) {
  .laserProduct_sec .Productmain_box .Product_img {
    height: 290px;
  }
}
@media only screen and (max-width: 575.98px) {
  .laserProduct_sec .Productmain_box .Product_img {
    height: 290px;
  }
}
.laserProduct_sec .Productmain_box .Product_img img {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
}
@media only screen and (max-width: 575.98px) {
  .laserProduct_sec .Productmain_box .Product_img img {
    object-fit: contain;
  }
}
.laserProduct_sec .Productmain_box .Product_img img.img_default {
  opacity: 1;
  transition: ease-in-out 0.7s;
}
.laserProduct_sec .Productmain_box .Product_img img.img_hover {
  opacity: 0;
  transition: ease-in-out 0.7s;
}
.laserProduct_sec .Productmain_box h4 {
  margin-bottom: 10px;
  text-align: center;
}
.laserProduct_sec .Productmain_box h4 a {
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
}
.laserProduct_sec .Productmain_box h4 a:hover {
  color: #3c5b8a;
}
.laserProduct_sec .Productmain_box p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 400;
  color: #6C6A72;
  text-align: center;
}
.laserProduct_sec .Productmain_box p a {
  color: #6C6A72;
  text-decoration: none;
}
.laserProduct_sec .Productmain_box p a:hover {
  color: #3c5b8a;
}

.promotion_modal .modal-content .modal-body {
  text-align: center;
  padding: 40px 30px;
}
.promotion_modal .modal-content .modal-body h4 {
  font-size: 26px;
  color: #000000;
}
.promotion_modal .modal-content .modal-body p {
  font-size: 16px;
  color: #bebdbe;
  margin-bottom: 0;
  margin-top: 5px;
}

.product_modal .modal-content .modal-body .main_heading {
  font-size: 24px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 15px;
}
.product_modal .modal-content .modal-body p {
  font-size: 16px;
  font-weight: 400;
  color: #6C6A72;
  margin-bottom: 10px;
}
.product_modal .modal-content .modal-body ul {
  list-style: disc;
  margin: 0px 0px 10px;
}
.product_modal .modal-content .modal-body ul li {
  font-size: 16px;
  font-weight: 400;
  color: #6C6A72;
}
.product_modal .modal-content .modal-body ol {
  margin: 0px 0px 10px;
}
.product_modal .modal-content .modal-body ol li {
  font-size: 16px;
  font-weight: 400;
  color: #6C6A72;
}

/*Services Css Ends*/
/*Resources Css Start*/
.resources-main {
  padding: 50px 0px;
}
.resources-main .custom-table .rdt_TableBody .rdt_TableRow .rdt_TableCell div {
  width: 100%;
}
.resources-main .resources-search-field .form-control {
  padding: 10px 20px 10px 45px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  height: 50px;
  color: rgba(0, 0, 0, 0.7);
}
.resources-main .resources-search-field svg {
  position: absolute;
  top: 15px;
  left: 15px;
  opacity: 0.5;
  font-size: 18px;
  min-width: 18px;
}
.resources-main .resources-right {
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  position: sticky;
  top: 100px;
}
.resources-main .resources-right h2 {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 12px;
}
.resources-main .resources-right a {
  display: block;
  padding-bottom: 10px;
  text-decoration: none;
  color: #6C6A72;
  font-size: 15px;
  line-height: 1.75;
}
.resources-main .resources-right a:hover {
  color: #3c5b8a;
}
.resources-main .resources-body .accordion .accordion-item {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
  border-radius: 12px !important;
}
.resources-main .resources-body .accordion .accordion-item .accordion-header {
  margin-bottom: 0 !important;
}
.resources-main .resources-body .accordion .accordion-item .accordion-header button.accordion-button {
  font-size: 16px !important;
  font-weight: 500 !important;
  border-radius: 12px !important;
}
.resources-main .resources-body .accordion .accordion-item .accordion-header button.accordion-button:after {
  width: 24px;
  height: 24px;
  border: 1px solid #000000;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-position: center;
  background-size: 13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  opacity: 0.4;
}
.resources-main .resources-body .accordion .accordion-item .accordion-body {
  padding-left: 16px;
  font-size: 14px;
  line-height: 1.75;
  color: #6C6A72;
}
.resources-main .resources-body .resources-pagination {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
}
.resources-main .resources-body .resources-pagination a {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  color: #3c5b8a;
  font-weight: 600;
  text-decoration: none;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-pagination a {
    font-size: 14px;
  }
}
.resources-main .resources-body .resources-pagination a.pagination-prev span {
  transform: rotate(-180deg);
}
.resources-main .resources-body .resources-pagination a.pagination-next {
  align-items: flex-end;
}
.resources-main .resources-body .resources-pagination a span {
  width: 38px;
  height: 38px;
  background: #3c5b8a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 5px;
}
.resources-main .resources-body .resources-pagination a span svg {
  color: #ffffff;
}
.resources-main .resources-body .resources-pagination a:hover {
  opacity: 0.5;
}
.resources-main .resources-body hr {
  opacity: 0.1;
  margin-bottom: 25px;
}
.resources-main .resources-body .searchfield svg {
  position: absolute;
  top: 12px;
  left: 12px;
  opacity: 0.5;
}
.resources-main .resources-body .searchfield .form-control {
  height: 40px;
  padding-left: 35px;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.7);
}
.resources-main .resources-body .dropdown button {
  background: transparent;
  height: 40px;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  color: rgba(0, 0, 0, 0.5);
  padding: 0px 12px;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.resources-main .resources-body .dropdown button:after {
  display: none;
}
@media only screen and (max-width: 991.98px) {
  .resources-main .resources-body .resources-heading {
    margin-bottom: 1rem !important;
  }
}
.resources-main .resources-body .resources-heading span {
  height: 34px;
  background: rgba(60, 91, 138, 0.1);
  color: #3c5b8a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 118px;
  padding: 0px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-heading span {
    font-size: 14px;
  }
}
.resources-main .resources-body .resources-heading h1 {
  font-size: 32px;
  color: #000000;
  font-weight: 700;
}
@media only screen and (max-width: 991.98px) {
  .resources-main .resources-body .resources-heading h1 {
    font-size: 28px;
  }
}
.resources-main .resources-body .resources-content .table-less-format li {
  padding-left: 0px !important;
  padding-bottom: 0px !important;
}
.resources-main .resources-body .resources-content .map-resources {
  text-align: center;
  padding: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  border-radius: 14px;
}
.resources-main .resources-body .resources-content .searchfaq svg {
  position: absolute;
  top: 15px;
  left: 15px;
  opacity: 0.5;
}
.resources-main .resources-body .resources-content .searchfaq .form-control {
  height: 45px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding-left: 40px;
}
.resources-main .resources-body .resources-content h2 {
  font-size: 22px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 15px;
  text-transform: capitalize;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-content h2 {
    font-size: 18px;
  }
}
.resources-main .resources-body .resources-content p {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.75;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-content p {
    font-size: 14px;
  }
}
.resources-main .resources-body .resources-content p a {
  color: #3c5b8a;
  text-decoration: none;
  font-weight: 600;
}
.resources-main .resources-body .resources-content li {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.75;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-content li {
    font-size: 14px;
  }
}
.resources-main .resources-body .resources-content li a {
  color: #3c5b8a;
  text-decoration: none;
  font-weight: 600;
}
.resources-main .resources-body .resources-content .resources-alerts {
  background: rgba(60, 91, 138, 0.07);
  padding: 11px 15px;
  border-radius: 6px;
}
.resources-main .resources-body .resources-content .resources-alerts p {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}
.resources-main .resources-body .resources-content .resources-alerts p svg {
  color: #3c5b8a;
  font-size: 16px;
  min-width: 16px;
  display: inline-flex;
  align-items: flex-start;
  margin-right: 10px;
}
.resources-main .resources-body .resources-content .resources-alerts p span {
  color: #000000;
}
.resources-main .resources-body .resources-content ul li {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.75;
  padding-left: 25px;
  position: relative;
}
@media only screen and (max-width: 1199.98px) {
  .resources-main .resources-body .resources-content ul li {
    font-size: 14px;
  }
}
.resources-main .resources-body .resources-content ul li svg {
  color: #3c5b8a;
  font-size: 18px;
  min-width: 18px;
  margin-right: 10px;
  position: absolute;
  left: 0px;
  top: 5px;
}
.resources-main .resources-body .resources-content ul li b {
  margin-right: 5px;
}
.resources-main .resources-body .resources-content ul li:not(:last-child) {
  padding-bottom: 10px;
}
.resources-main .accordion .accordion-item {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  margin-bottom: 15px;
}
.resources-main .accordion .accordion-item .accordion-header button.accordion-button {
  padding: 15px;
  background: #ffffff;
  box-shadow: none;
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  --bs-accordion-btn-icon-width: 1rem;
}
.resources-main .accordion .accordion-item .accordion-header button.accordion-button::after {
  transform: rotate(-90deg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.resources-main .accordion .accordion-item .accordion-header button.accordion-button:not(.collapsed):after {
  transform: rotate(0);
}
.resources-main .accordion .accordion-item .accordion-header button.accordion-button .accordion-icon {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(60, 91, 138, 0.06);
  border: 1px solid rgba(60, 91, 138, 0.13);
  margin-right: 11px;
}
.resources-main .accordion .accordion-item .accordion-header button.accordion-button .accordion-icon svg {
  color: #3c5b8a;
  font-size: 18px;
}
.resources-main .accordion .accordion-item .accordion-body {
  padding-left: 65px;
  padding-top: 0px;
}
.resources-main .accordion .accordion-item .accordion-body a {
  display: flex;
  padding-bottom: 12px;
  text-decoration: none;
  font-size: 15px;
  color: #6C6A72;
  align-items: center;
}
.resources-main .accordion .accordion-item .accordion-body a .maticon {
  width: 17px;
  height: 17px;
  border-radius: 4px;
  margin-right: 10px;
}
.resources-main .accordion .accordion-item .accordion-body a img {
  margin-right: 10px;
  min-width: 17px;
}
.resources-main .accordion .accordion-item .accordion-body a svg {
  margin-right: 10px;
  font-size: 18px;
  min-width: 18px;
}
.resources-main .accordion .accordion-item .accordion-body a.active {
  font-weight: 500;
}
.resources-main .accordion .accordion-item .accordion-body a.active, .resources-main .accordion .accordion-item .accordion-body a:hover {
  color: #3c5b8a;
}
.resources-main .accordion .accordion-item .accordion-body a.active img.defaulticon, .resources-main .accordion .accordion-item .accordion-body a:hover img.defaulticon {
  display: none;
}
.resources-main .accordion .accordion-item .accordion-body a.active img.activeicon, .resources-main .accordion .accordion-item .accordion-body a:hover img.activeicon {
  display: inline-flex !important;
}

.custom-table::-webkit-scrollbar {
  height: 5px;
}
.custom-table::-webkit-scrollbar-thumb {
  background: #c5c4c4;
}
.custom-table .rdt_TableHead .rdt_TableHeadRow {
  background: #FAFAFA;
  border-radius: 10px;
  margin: 5px 0;
  padding-bottom: 10px;
  padding-top: 10px;
  min-height: 60px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.custom-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  padding: 0px 12px;
  font-weight: 500;
  color: #000000;
}
.custom-table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol [role=columnheader] div {
  white-space: normal;
}
.custom-table .rdt_TableBody .rdt_TableRow {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 5px 0;
  min-height: 60px;
}
.custom-table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  padding: 10px 12px;
  color: #6C6A72;
}
.custom-table .rdt_TableBody .rdt_TableRow .rdt_TableCell div {
  white-space: normal;
}
.custom-table.custom-table2 .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
}
.custom-table.custom-table2 .rdt_TableBody .rdt_TableRow .rdt_TableCell div .badgestatus {
  font-weight: 600;
  min-width: 95px;
  border-radius: 4px;
  text-align: center;
}
.custom-table.custom-table2 .rdt_TableBody .rdt_TableRow .rdt_TableCell div .custom_badgess .badgestatus {
  font-size: 10px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
}
.custom-table.custom-table2 .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child div {
  display: inline-flex;
  align-items: center;
}
.custom-table.custom-table2 .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child div .btnpay {
  height: 35px;
  display: inline-flex;
  background: transparent;
  width: 50px;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  color: #3c5b8a;
  text-decoration: none;
  margin: 3px;
  border: 1px solid #3c5b8a;
}
.custom-table.custom-table2 .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child div .btnpay:hover {
  background: #3c5b8a;
  color: #ffffff;
}
.custom-table.custom-table2 .btnview {
  width: 35px;
  height: 35px;
  background: #3c5b8a;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 18px;
  margin: 3px;
}
.custom-table.custom-table2 .btnview:hover {
  opacity: 0.75;
}
.custom-table.custom-table2 .btnreorder {
  width: 35px;
  height: 35px;
  background: #1F2E60;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 18px;
  margin: 3px;
}
.custom-table.custom-table2 .btnreorder:hover {
  opacity: 0.75;
}

.badgematerials span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-flex;
  margin-right: 7px;
}

/*Rescources Css Ends*/
/*Orders Css Start*/
.ptb-50 {
  padding-top: 50px;
  padding-bottom: 50px;
}

.card {
  background: #ffffff;
  border-radius: 14px !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  border: none !important;
}
.card .card-header {
  background: #ffffff !important;
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px 14px 0px 0px !important;
}
.card .card-header h5 {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 22px;
  color: #000000;
}
.card .card-body .tablelist li {
  color: #6C6A72;
  display: inline-flex;
  font-size: 14px;
  justify-content: space-between;
}
.card .card-body .tablelist li:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  margin-right: 15px;
  padding-right: 15px;
}
.card .card-body .tablelist li span {
  font-weight: 600;
  margin-left: 15px;
}
@media only screen and (max-width: 1199.98px) {
  .card .card-body .tablelist li {
    font-size: 12px;
  }
}
.card .card-body .tablelist .badge-status {
  background-color: rgba(1, 148, 60, 0.1);
  color: #01943C;
  padding: 2px 6px 0;
  font-weight: 500;
  min-width: 80px;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
}
.card .card-body .table-responsive::-webkit-scrollbar {
  height: 5px;
}
.card .card-body .table-responsive::-webkit-scrollbar-thumb {
  background: #c5c4c4;
}

.rdt_Pagination {
  border: none !important;
}

.no-cart img {
  height: 124px;
}
.no-cart h3 {
  font-size: 28px;
  color: #000000;
  font-weight: bold;
  margin-top: 15px;
}

.orders-upload-file {
  max-width: 830px;
  margin: 0 auto;
  width: 100%;
}
.orders-upload-file h5 {
  color: #6C6A72;
  font-size: 18px;
  font-weight: 600;
}

.table.tablecustom {
  border-collapse: initial;
  border-spacing: 0 0.75em;
  margin-bottom: 0;
}
.table.tablecustom thead tr th {
  background-color: #FAFAFA;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-left: none;
  border-right: none;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  height: 60px;
  padding: 15px 15px;
  vertical-align: middle;
}
.table.tablecustom thead tr th:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px 0 0 16px;
}
.table.tablecustom thead tr th .form-check-input {
  width: 22px;
  height: 22px;
  border-color: rgba(0, 0, 0, 0.3);
  box-shadow: none;
}
.table.tablecustom thead tr th .form-check-input:checked {
  background-color: #000000;
  border-color: #000000;
}
.table.tablecustom thead tr th:last-child {
  border-radius: 0 16px 16px 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 1199.98px) {
  .table.tablecustom thead tr th {
    font-size: 12px;
  }
}
.table.tablecustom tbody tr td {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-left: none;
  border-right: none;
  color: #6C6A72;
  font-size: 14px;
  font-weight: 400;
  height: 60px;
  padding: 15px 15px;
  vertical-align: middle;
}
.table.tablecustom tbody tr td:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 16px 0 0 16px;
}
.table.tablecustom tbody tr td:last-child {
  border-radius: 0 16px 16px 0;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 1199.98px) {
  .table.tablecustom tbody tr td {
    font-size: 12px;
  }
}

.totaltable p {
  color: #6C6A72;
  display: flex;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
}
@media only screen and (max-width: 1199.98px) {
  .totaltable p {
    font-size: 14px;
  }
}
.totaltable p.grandtotal {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  padding-top: 15px;
}
@media only screen and (max-width: 1199.98px) {
  .totaltable p.grandtotal {
    font-size: 16px;
  }
}

/*Orders Css Ends*/
/*My Profile Css Start*/
.min-width-159 {
  min-width: 159px;
  max-width: 159px;
}

textarea.form-control {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.7);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  font-size: 14px;
  font-weight: 400;
  resize: none;
}

.accountform .form-group .form-label {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
.accountform .form-group .form-label span {
  opacity: 0.3;
}
.accountform .form-group .paymentCard_border {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 20px;
}
.accountform .form-group .react-tel-input .form-control {
  padding-left: 50px !important;
}
.accountform .form-group .react-tel-input .flag-dropdown {
  border: none;
  background: transparent;
  border-radius: 0px;
}
.accountform .form-group .react-tel-input .flag-dropdown .selected-flag {
  padding: 0 0 0 15px;
  border-radius: 0px;
}
.accountform .form-group .password-input-group svg {
  position: absolute;
  top: 12px;
  right: 10px;
  opacity: 0.3;
  color: #000000;
}
.accountform .form-group .form-control,
.accountform .form-group .form-select {
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.7);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  font-weight: 400;
}
.accountform .form-group .form-control[type=password],
.accountform .form-group .form-select[type=password] {
  padding-right: 50px;
}
.accountform .form-group .form-control:focus,
.accountform .form-group .form-select:focus {
  box-shadow: none;
}
.accountform .form-group .form-control::placeholder,
.accountform .form-group .form-select::placeholder {
  opacity: 0.5;
}

.profile_user_main {
  border-radius: 15px;
  background: #ffffff;
  padding: 30px 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
}
.profile_user_main .user_info {
  display: inline-block;
  margin-bottom: 15px;
}
.profile_user_main .user_info img {
  width: 124px;
  height: 124px;
  object-fit: scale-down;
  border: 5px solid #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
}
.profile_user_main .user_info .form-label {
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  background: #3c5b8a;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  right: 8px;
}
.profile_user_main h4 {
  font-size: 20px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 4px;
}
.profile_user_main p {
  margin-bottom: 0;
  font-size: 16px;
  color: #6C6A72;
}

/*My Profile Css Ends*/
/*Change Password Css Start*/
.modal-custom.max-width-574 .modal-dialog {
  max-width: 574px;
}
.modal-custom .notesmain {
  max-height: 370px;
  overflow-y: auto;
}
.modal-custom .notesmain::-webkit-scrollbar {
  width: 6px;
}
.modal-custom .notesmain::-webkit-scrollbar-thumb {
  background: #ccc;
}
.modal-custom .notesmain .notescont {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  padding: 16px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  margin-bottom: 14px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.modal-custom .notesmain .notescont a {
  color: #000000;
  font-size: 14px;
  min-width: 23px;
  text-align: end;
}
.modal-custom .modal-dialog .modal-content {
  border-radius: 20px;
}
.modal-custom .modal-dialog .modal-content .modal-header .modal-title {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}
.modal-custom .modal-dialog .modal-content .modal-header .btn-close {
  width: 28px;
  height: 28px;
  background-color: #3c5b8a;
  border-radius: 50%;
  padding: 0 !important;
  background-size: 10px;
  background-position: center;
  opacity: 1;
  position: absolute;
  top: -4px;
  right: -2px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

/*Change Password Css Ends*/
/*My Addresses Css Start*/
.addresses-grid {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
  min-height: 237px;
}
.addresses-grid h2 {
  font-size: 20px;
  color: #000000;
  font-weight: 600;
}
.addresses-grid span.statusdefault {
  min-width: 80px;
  height: 35px;
  padding: 0px 10px;
  background: #000000;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 35px;
  border-radius: 30px;
}
.addresses-grid p {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.75;
}
.addresses-grid .btn-bottom {
  display: flex;
  align-items: center;
  gap: 10px;
}
.addresses-grid .btn-bottom a {
  width: 36px;
  height: 36px;
  border: 1px solid #000000;
  color: #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.addresses-grid .btn-bottom a.btn-set-default {
  min-width: 121px;
  padding: 0px 10px;
  font-size: 14px;
}
.addresses-grid .btn-bottom a:hover {
  background: #000000;
  color: #ffffff;
}
.addresses-grid.payment-grids .card-no {
  font-size: 20px;
  margin: 15px 0px 15px;
  letter-spacing: 3px;
}
@media only screen and (max-width: 991.98px) {
  .addresses-grid.payment-grids .card-no {
    letter-spacing: 0;
  }
}
.addresses-grid.payment-grids .card-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.addresses-grid.payment-grids .card-actions .card-info {
  color: #6C6A72;
  font-size: 14px;
}
.addresses-grid.payment-grids .card-actions .card-info strong {
  display: block;
  font-weight: 500;
  color: #000000;
}

.scroll_cards {
  max-height: 255px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll_cards::-webkit-scrollbar {
  display: none;
}

#saveCardCheckbox {
  border: 1px solid #000;
}

.paymentSelectCard {
  cursor: pointer;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.paymentSelectCard input:checked ~ .paymentSelectbox {
  border: 1px solid #3c5b8a;
}
.paymentSelectCard .paymentSelectbox {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 8px 15px;
  flex-grow: 1;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.paymentSelectCard .paymentSelectbox p {
  font-size: 14px;
  color: #6C6A72;
  line-height: 1.75;
  margin-bottom: 0px;
}
.paymentSelectCard .paymentSelectbox .card-info {
  color: #6C6A72;
  font-size: 14px;
}

.addresses-grids {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.08);
  height: 100%;
}
.addresses-grids h2 {
  font-size: 20px;
  color: #000000;
  font-weight: 600;
}
.addresses-grids span.statusdefault {
  min-width: 80px;
  height: 35px;
  padding: 0px 10px;
  background: #000000;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 35px;
  border-radius: 30px;
}
.addresses-grids p {
  font-size: 16px;
  color: #6C6A72;
  line-height: 1.75;
}
.addresses-grids .btn-bottom {
  display: flex;
  align-items: center;
  gap: 10px;
}
.addresses-grids .btn-bottom a {
  width: 36px;
  height: 36px;
  border: 1px solid #000000;
  color: #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.addresses-grids .btn-bottom a.btn-set-default {
  min-width: 121px;
  padding: 0px 10px;
  font-size: 14px;
}
.addresses-grids .btn-bottom a:hover {
  background: #000000;
  color: #ffffff;
}
.addresses-grids.payment-grids .card-no {
  font-size: 20px;
  margin: 15px 0px 15px;
  letter-spacing: 3px;
}
@media only screen and (max-width: 991.98px) {
  .addresses-grids.payment-grids .card-no {
    letter-spacing: 0;
  }
}
.addresses-grids.payment-grids .card-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.addresses-grids.payment-grids .card-actions .card-info {
  color: #6C6A72;
  font-size: 14px;
}
.addresses-grids.payment-grids .card-actions .card-info strong {
  display: block;
  font-weight: 500;
  color: #000000;
}

/*My Addresses Css Ends*/
/*Quotes Css Start*/
.quotes-head {
  margin-bottom: 0;
  font-weight: bold;
  font-size: 34px;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .quotes-head {
    font-size: 28px;
  }
}

.quotes-list {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 25px;
  margin-bottom: 25px;
}
.quotes-list .quotes-img {
  width: 154px;
  height: 160px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.quotes-list .quotes-img img {
  object-fit: contain;
  max-width: 100px;
  height: 120px;
}
.quotes-list .quotes-content {
  flex-grow: 1;
}
.quotes-list .quotes-content h2 {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin-right: 9px;
}
.quotes-list .quotes-content .quotes-date {
  font-size: 16px;
  color: #000000;
}
.quotes-list .quotes-content p {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
}
.quotes-list .quotes-content p span {
  color: #000000;
}

/*Quotes Css Ends*/
/*Quotes Detail Css Start*/
.list-quotes-main {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 20px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}
.list-quotes-main.part-focused {
  background-color: rgba(13, 110, 253, 0.1) !important;
  border: 2px solid #0d6efd !important;
  border-radius: 8px;
  padding: 18px;
  margin: 18px 0;
  box-shadow: 0 0 10px rgba(13, 110, 253, 0.2);
}
.list-quotes-main .quanityCount_btn b {
  font-size: 14px;
  align-self: center;
  margin-top: 0px !important;
}
.list-quotes-main .input-group {
  max-width: 110px;
}
.list-quotes-main .input-group .form-control {
  border: none;
  font-size: 14px;
  font-weight: bold;
  padding: 0px;
}
@media only screen and (max-width: 767.98px) {
  .list-quotes-main .input-group .form-control {
    font-size: 14px;
  }
}
.list-quotes-main .input-group button {
  width: 32px;
  height: 32px;
  border: 1px solid #000000;
  border-radius: 6px !important;
  padding: 0px !important;
}
.list-quotes-main .input-group button svg {
  font-size: 18px;
  color: #000000;
}
@media only screen and (max-width: 767.98px) {
  .list-quotes-main .input-group button svg {
    font-size: 18px;
  }
}
.list-quotes-main .input-group button:hover {
  background: #000000;
}
.list-quotes-main .input-group button:hover svg {
  color: #ffffff;
}
.list-quotes-main .list-quotes .img-quote {
  flex-shrink: 0;
  width: 154px;
  height: 160px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  justify-content: center;
}
.list-quotes-main .list-quotes .img-quote .bublenumber {
  position: absolute;
  top: -10px;
  left: -14px;
  background: #98c1eb;
  display: inline-block;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  padding: 2px 7px;
}
.list-quotes-main .list-quotes .img-quote img {
  width: 154px;
  height: 160px;
  object-fit: scale-down;
  padding: 10px;
}
.list-quotes-main .list-quotes .right-quote .quote-off {
  border: 1px solid #E6E6E6;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.5);
  min-width: 63px;
  height: 33px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 10px;
  padding: 0px 7px;
  background-color: rgba(1, 148, 60, 0.1);
  color: rgb(1, 148, 60);
}
.list-quotes-main .list-quotes .right-quote p {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .right-quote p {
    font-size: 11px;
  }
}
.list-quotes-main .list-quotes .right-quote p.quotes-date {
  font-size: 13px;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .right-quote p.quotes-date {
    font-size: 11px;
  }
}
.list-quotes-main .list-quotes .right-quote p .quotes-price {
  color: #3c5b8a;
  font-size: 14px;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .right-quote p .quotes-price {
    font-size: 13px;
  }
}
.list-quotes-main .list-quotes .content-quotes {
  flex-grow: 1;
}
.list-quotes-main .list-quotes .content-quotes .DragItemPost_div {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.list-quotes-main .list-quotes .content-quotes .DragItemPost_div .DragItemPostOps_btn {
  background: #ff8cd3;
  color: #000;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 12px;
  line-height: normal;
  border-radius: 10px;
  margin-bottom: 10px;
}
.list-quotes-main .list-quotes .content-quotes .DragItemPost_div .DragItemPostPlus_btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #000;
  border: 1px solid #000;
  padding: 0px;
  font-size: 20px;
}
.list-quotes-main .list-quotes .content-quotes .DragItemPost_div .DragItemPost_box button.DragItemPostClose_btn.btn {
  position: absolute;
  top: -8px;
  right: -5px;
  padding: 0;
  border: 0;
  font-size: 14px;
  color: #000;
}
.list-quotes-main .list-quotes .content-quotes h2 {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .content-quotes h2 {
    font-size: 18px;
  }
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .content-quotes .selectdropdown > div {
    font-size: 11px;
  }
}
.list-quotes-main .list-quotes .content-quotes .num-dim-main {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .content-quotes .num-dim-main {
    font-size: 11px;
  }
}
.list-quotes-main .list-quotes .content-quotes .num-dim-main .num-dim-indicator {
  color: rgba(0, 0, 0, 0.5);
}
.list-quotes-main .list-quotes .content-quotes .num-dim-main .num-dim {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}
.list-quotes-main .list-quotes .content-quotes .num-dim-main .num-dim span {
  color: rgba(0, 0, 0, 0.5);
  margin-right: 5px;
}
.list-quotes-main .list-quotes .content-quotes .quotes-dropdown {
  gap: 8px;
  flex-wrap: wrap;
}
@media only screen and (max-width: 767.98px) {
  .list-quotes-main .list-quotes .content-quotes .quotes-services {
    margin-bottom: 10px;
  }
}
.list-quotes-main .list-quotes .content-quotes .quotes-services label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}
.list-quotes-main .list-quotes .content-quotes .quotes-services h4 {
  font-size: 14px;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .content-quotes .quotes-services h4 {
    font-size: 13px;
  }
}
.list-quotes-main .list-quotes .content-quotes .quotes-services .form-check {
  padding-left: 0;
}
.list-quotes-main .list-quotes .content-quotes .quotes-services .form-check .form-check-input {
  margin: 0 5px 0 0;
  border: 0.9px solid #000;
}
.list-quotes-main .list-quotes .content-quotes .quotes-services .form-check .form-check-input:checked {
  background-color: #3c5b8a;
  border-color: #3c5b8a;
}
.list-quotes-main .list-quotes .content-quotes .quotes-services .form-check label {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}
@media only screen and (max-width: 1199.98px) {
  .list-quotes-main .list-quotes .content-quotes .quotes-services .form-check label {
    font-size: 11px;
  }
}

.btnsavelater {
  height: 36px;
  min-width: 121px;
  border: 1px solid #000000;
  background: #000000;
  color: #ffffff;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}
.btnsavelater:hover {
  background: transparent;
  color: #000000;
}

.btnshare {
  height: 36px;
  min-width: 121px;
  border: 1px solid #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}
.btnshare:hover {
  background: #000000;
  color: #ffffff;
}

.btnicons {
  font-size: 14px;
  color: #000;
  cursor: pointer;
}

.btnicon {
  width: 36px;
  height: 36px;
  border: 1px solid #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btnicon svg {
  font-size: 20px;
  color: #000000;
}
@media only screen and (max-width: 767.98px) {
  .btnicon svg {
    font-size: 16px;
  }
}
.btnicon:hover {
  background: #000000;
}
.btnicon:hover svg {
  color: #ffffff;
}

.quotes-sidebar .order-cont-btm {
  font-size: 13px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 0;
  font-weight: 500;
}
.quotes-sidebar .order-cont-btm b {
  color: #3c5b8a;
  font-weight: bold;
}
.quotes-sidebar .quotes-inner {
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  padding: 20px;
}
.quotes-sidebar .quotes-inner .quotes-login p {
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.quotes-sidebar .quotes-inner .order-cont {
  font-size: 13px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 0;
}
.quotes-sidebar .quotes-inner .order-cont b {
  color: #000000;
}
.quotes-sidebar .quotes-inner .head-quotes {
  margin-bottom: 20px;
}
.quotes-sidebar .quotes-inner .head-quotes h2 {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}
@media only screen and (max-width: 1199.98px) {
  .quotes-sidebar .quotes-inner .head-quotes h2 {
    font-size: 20px;
  }
}
.quotes-sidebar .quotes-inner .quotesitem {
  font-size: 16px;
  color: #6C6A72;
  font-weight: 600;
}
@media only screen and (max-width: 1199.98px) {
  .quotes-sidebar .quotes-inner .quotesitem {
    font-size: 14px;
  }
}
.quotes-sidebar .quotes-inner .quotesitem.quotesright {
  font-weight: 400;
}
.quotes-sidebar .quotes-inner .quotessubtotal {
  font-size: 20px;
  color: #6C6A72;
  font-weight: 600;
}
@media only screen and (max-width: 1199.98px) {
  .quotes-sidebar .quotes-inner .quotessubtotal {
    font-size: 16px;
  }
}
.quotes-sidebar .quotes-inner .quotes-separator {
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  opacity: 1;
}
.quotes-sidebar .quotes-inner .quotesprice {
  font-size: 20px;
  color: #3c5b8a;
  font-weight: 700;
}
@media only screen and (max-width: 767.98px) {
  .quotes-sidebar .quotes-inner .quotesprice {
    font-size: 16px;
  }
}
.quotes-sidebar .quotes-inner .accountform .form-group .form-label {
  font-size: 13px;
  margin-bottom: 3px;
}
.quotes-sidebar .quotes-inner .accountform .form-group .form-control,
.quotes-sidebar .quotes-inner .accountform .form-group .form-select {
  font-size: 13px;
  height: 40px;
  border-radius: 8px;
  padding-left: 15px;
  padding-right: 15px;
}
.quotes-sidebar .accountform small {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
.quotes-sidebar .accountform .freeshipping {
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
}
.quotes-sidebar .accountform .freeshipping b {
  font-weight: 500;
  color: #000000;
  font-size: 13px;
}
.quotes-sidebar .accountform .freeshipping span {
  color: rgba(0, 0, 0, 0.5);
  font-size: 13px;
  font-weight: 400;
}
.quotes-sidebar .accountform .freeshipping span b {
  font-weight: 500;
  color: #000000;
}
.quotes-sidebar .accountform .form-check {
  padding-left: 0;
}
.quotes-sidebar .accountform .form-check .form-check-input {
  margin: 0 5px 0 0;
}
.quotes-sidebar .accountform .form-check .form-check-input:checked {
  background-color: #3c5b8a;
  border-color: #3c5b8a;
}
.quotes-sidebar .accountform .form-check label {
  font-size: 13px;
  color: #000000;
}
.quotes-sidebar .accountform .form-check label span {
  font-weight: bold;
  color: #3c5b8a;
}
.quotes-sidebar .customtabs {
  display: flex;
  flex-direction: row;
  border: none;
  gap: 5px;
}
.quotes-sidebar .customtabs li.nav-item {
  flex: 1 1;
  width: 33.33%;
}
.quotes-sidebar .customtabs li.nav-item button.nav-link {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 11px;
  text-align: center;
  line-height: normal;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(60, 91, 138, 0.13);
  background: #ffffff;
  border-radius: 8px;
  color: #000000;
  padding: 6px;
}
.quotes-sidebar .customtabs li.nav-item button.nav-link span {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  border: 1px solid rgba(60, 91, 138, 0.13);
  background: rgba(60, 91, 138, 0.06);
  color: #3c5b8a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.quotes-sidebar .customtabs li.nav-item button.nav-link span svg {
  font-size: 17px;
}
.quotes-sidebar .customtabs li.nav-item button.nav-link.active {
  border: 1px solid #3c5b8a;
  background: #3c5b8a;
  color: #ffffff;
}
.quotes-sidebar .customtabs li.nav-item button.nav-link.active span {
  border: 1px solid rgba(255, 255, 255, 0.13);
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
}

.benddetailsmodal .modal-dialog {
  max-width: 626px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main {
  width: 154px;
}
@media only screen and (max-width: 767.98px) {
  .benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main {
    margin: 0 auto;
  }
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main .bend-img {
  width: 154px;
  height: 160px;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main .bend-img img {
  object-fit: contain;
  height: 130px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main h2 {
  text-align: center;
  font-size: 20px;
  color: #000000;
  font-weight: 700;
  white-space: normal;
  word-break: break-all;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main p {
  font-size: 11px;
  text-align: center;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  margin: 15px 0px 9px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-img-main p span {
  color: #000000;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bends-upload-file {
  background: rgba(0, 0, 0, 0.03);
  border: 1px dashed rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 10px;
  text-align: center;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bends-upload-file svg {
  font-size: 42px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bends-upload-file small {
  font-size: 12px;
  font-weight: 500;
  color: #000000;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bends-upload-file p {
  font-size: 13px;
  opacity: 1;
  margin: 10px 0px 5px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bends-upload-file p label {
  color: #3c5b8a;
  font-weight: 500;
  border-bottom: 1px solid #3c5b8a;
  line-height: normal;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity h5 {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
@media only screen and (max-width: 1199.98px) {
  .benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity h5 {
    font-size: 16px;
  }
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity .input-group {
  max-width: 109px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity .input-group .form-control {
  border: none;
  padding: 0px;
  height: 30px;
  font-weight: 700;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity .input-group button {
  width: 30px;
  height: 30px;
  border: 1px solid #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  padding: 0px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity .input-group button:hover {
  background: #000000;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-quantity .input-group button:hover svg {
  color: #ffffff;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-title .btn-close {
  width: 28px;
  height: 28px;
  background-color: #3c5b8a;
  border-radius: 50%;
  padding: 0 !important;
  background-size: 10px;
  background-position: center;
  opacity: 1;
  position: absolute;
  top: -14px;
  right: -8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-title .btn {
  height: 35px;
  line-height: 13px !important;
  min-width: 99px;
}
.benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-title h2 {
  font-size: 22px;
  color: #000000;
  font-weight: bold;
}
@media only screen and (max-width: 1199.98px) {
  .benddetailsmodal .modal-dialog .modal-content .modal-body .bend-content .bend-title h2 {
    font-size: 18px;
  }
}

/*Quotes Detail Css Ends*/
@media only screen and (min-width: 1200px) {
  .width-258 {
    width: 258px !important;
  }
  .w-calc-100-258 {
    width: calc(100% - 258px) !important;
  }
}
.custom_h2 {
  font-size: 22px;
  color: #000000;
  font-weight: bold;
}

.toggle-switch-container .container {
  text-align: center;
}

.toggle-switch-container p {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 7px;
}

.toggle-switch-container .toggle-switch {
  position: relative;
  width: 60px;
  display: inline-block;
  text-align: left;
  top: 0;
  margin-left: 5px;
}

.toggle-switch-container .checkbox {
  display: none;
}

.toggle-switch-container .label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 0 solid #bbb;
  border-radius: 20px;
}

.toggle-switch-container .inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.toggle-switch-container .inner:before,
.toggle-switch-container .inner:after {
  float: left;
  width: 50%;
  height: 28px;
  padding: 0;
  line-height: 28px;
  color: #fff;
  font-weight: bold;
  box-sizing: border-box;
}

.custom_tooltip .tooltip-inner {
  max-width: 305px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 10px 10px;
  background-color: white;
  color: #000;
}

.custom_tooltip {
  padding: 9px 0px;
  opacity: 0.99 !important;
}

.custom_tooltip .tooltip-arrow {
  top: 0px !important;
}

.custom_tooltip .tooltip-arrow:before {
  border-bottom-color: white !important;
}

.toggle-switch-container .inner:before {
  content: "in";
  padding-left: 6px;
  background-color: red;
  color: #fff;
}

.toggle-switch-container .inner:after {
  content: "mm";
  padding-right: 6px;
  background-color: #3c5b8a;
  color: #fff;
  text-align: right;
}

.toggle-switch-container .switch {
  display: block;
  width: 28px;
  margin: 0px;
  background: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 32px;
  border: 0 solid #bbb;
  border-radius: 20px;
  transition: all 0.3s ease-in 0s;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.2);
}

.toggle-switch-container .checkbox:checked + .label .inner {
  margin-left: 0;
}

.toggle-switch-container .checkbox:checked + .label .switch {
  right: 0px;
}

.submenu {
  padding-left: 20px; /* Indent for sub-menu */
}

.submenu-item {
  font-size: 14px; /* Smaller font for sub-menu items */
  color: #888;
}

.submenu-item:hover {
  color: #000;
}

.quote_div_main_sect {
  display: flex;
  align-items: flex-start;
  gap: 5px;
}

.quote_div_main_sect .main_service_clr {
  display: flex;
  align-items: flex-start;
  background-color: #ffffff;
  padding: 8px;
}

.quote_div_main_sect .main_service_clr .form-check {
  min-height: auto;
}

.quote_div_main_sect .custom_bend_div {
  margin-right: 10px;
}

.quote_div_main_sect a.btnicon {
  width: 24px;
  height: 24px;
}

.quote_div_main_sect .custom_bend_div p {
  margin-bottom: 5px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
}

.quote_div_main_sect a.btnicon svg {
  font-size: 14px;
}

.text-color-shipping {
  text-align: center;
}

.text-color-shipping span {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}

.text-color-shipping p {
  font-size: 14px;
  color: #000000;
  margin-bottom: 10px;
  font-weight: 600;
}

.text-color-shipping .rfq-reasons-table {
  text-align: left;
}

.proceedCheckout_modal .modal-content .modal-body {
  padding: 20px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .shipping_head {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #000000;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .addresses-grid {
  min-height: 200px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .addresses-grid h2 {
  font-size: 18px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .addresses-grid p {
  font-size: 14px;
  margin-bottom: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .bill_addr_name .form-check label {
  font-size: 14px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .bill_addr_name .form-select {
  height: 50px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  outline: 0px;
  box-shadow: none;
  font-size: 14px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods hr {
  display: none;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .head-quotes {
  display: none !important;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option label {
  font-size: 14px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div .Edit-price-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #000000;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: #000000;
  font-size: 18px;
  padding: 0px;
  outline: 0px;
  box-shadow: none;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div .Edit-price-btn:hover {
  background: #000000;
  border: 1px solid #000000;
  color: #ffffff;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label {
  display: inline-flex;
  align-items: center;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div input.addNumber_input {
  height: 36px;
  border-radius: 5px;
  padding: 4px 10px;
  box-sizing: border-box;
  display: inline-block;
  outline: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  width: auto;
  max-width: 110px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div .save-price-btn {
  width: 36px;
  height: 36px;
  border: 1px solid rgb(1, 148, 60);
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: rgb(1, 148, 60);
  font-size: 24px;
  padding: 0px;
  outline: 0px;
  box-shadow: none;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div .save-price-btn:hover {
  background: rgb(1, 148, 60);
  color: #ffffff;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div .cancel-price-btn {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(225, 31, 38, 0.6);
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: rgba(225, 31, 38, 0.6);
  font-size: 24px;
  padding: 0px;
  outline: 0px;
  box-shadow: none;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .ship_methods .rate-option.ShippingMethodCheckbox_div label .ShippingMethodCount_div .cancel-price-btn:hover {
  background: rgb(225, 31, 38);
  color: #ffffff;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect .payment-grids p.card-no {
  margin: 0px 0px 10px !important;
  line-height: normal;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect .payment-grids .card-actions {
  margin-bottom: 0px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .nav-tabs {
  border: 0px;
  gap: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .nav-tabs li.nav-item .nav-link {
  border: 0px !important;
  background: #e8e8e8;
  border-radius: 10px;
  font-size: 14px;
  color: #444;
  text-transform: capitalize;
  padding: 10px 20px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .nav-tabs li.nav-item .nav-link.active {
  background: #3c5b8a;
  color: #ffffff;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .tab-content .netTerms_flex {
  display: flex;
  align-items: center;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .tab-content .netTerms_flex label {
  font-size: 14px;
  flex-shrink: 0;
  margin-right: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .tab-content .netTerms_flex input {
  max-width: 170px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 14px;
  outline: 0px;
  box-shadow: none;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .tab-content .POupload_field {
  display: flex;
  align-items: center;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .cards_sect.paymentTab_div .tab-content .POupload_field label {
  font-size: 14px;
  flex-shrink: 0;
  margin-right: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .main_price {
  background: rgba(0, 0, 0, 0.04);
  padding: 10px;
  border-radius: 10px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .main_price .quotesitem {
  font-size: 14px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .main_price .quotessubtotal, .proceedCheckout_modal .modal-content .modal-body .shipping_info .main_price .quotesprice {
  font-size: 14px;
  font-weight: 600;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .footer_btn {
  text-align: center;
  margin-top: 15px;
}
.proceedCheckout_modal .modal-content .modal-body .shipping_info .footer_btn .btn {
  min-width: 120px;
}

.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .addNumber_input {
  height: 42px;
  border-radius: 5px;
  padding: 4px 10px;
  box-sizing: border-box;
  display: inline-block;
  outline: 0px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  width: auto;
}
.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .addbend_flex {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .save-price-btn {
  width: 42px;
  height: 42px;
  border: 1px solid rgb(1, 148, 60);
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: rgb(1, 148, 60);
  font-size: 24px;
  padding: 0px;
  outline: 0px;
  box-shadow: none;
}
.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .save-price-btn:hover {
  border: 1px solid rgb(1, 148, 60);
  background-color: rgb(1, 148, 60);
  color: #ffffff;
}
.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .cancel-price-btn {
  width: 42px;
  height: 42px;
  border: 1px solid rgba(225, 31, 38, 0.6);
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: rgba(225, 31, 38, 0.6);
  font-size: 24px;
  padding: 0px;
  outline: 0px;
  box-shadow: none;
}
.AddBendDtl_Modal .modal-content .modal-body .bend-content .file-previews .cancel-price-btn:hover {
  border: 1px solid #E11F26;
  background-color: #E11F26;
  color: #ffffff;
}

.QuoteBillMain_div {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
}
.QuoteBillMain_div .QuoteBill_box {
  margin-bottom: 15px;
}
.QuoteBillMain_div .QuoteBill_box h4 {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 10px;
}
.QuoteBillMain_div .QuoteBill_box p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 0px;
}
.QuoteBillMain_div .QuoteBillInfo_box {
  margin-bottom: 15px;
}
.QuoteBillMain_div .QuoteBillInfo_box p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 5px;
}
.QuoteBillMain_div .QuoteBillInfo_box p b {
  color: #000000;
  font-weight: 600;
  display: inline-block;
}
.QuoteBillMain_div .QuoteBillInfo_box p b.minWidth_110 {
  min-width: 110px;
}
.QuoteBillMain_div .QuoteBillInfo_box p .badge_success {
  display: inline-block;
  background-color: rgba(1, 148, 60, 0.3);
  color: rgb(1, 148, 60);
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 20px;
}
.QuoteBillMain_div .QuoteBillInfo_box .QuoteBillDownload_btn {
  background: #4e8ac8;
  color: #000;
  display: inline-flex;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  border-radius: 10px;
}
.QuoteBillMain_div .ShippingLabelDownload_btn {
  background: #E97278 !important;
  color: #ffffff !important;
  display: inline-flex;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  border-radius: 10px;
  border: none !important;
  text-decoration: none !important;
}
.QuoteBillMain_div .ShippingLabelDownload_btn:hover {
  opacity: 0.85;
  color: #ffffff !important;
}
.QuoteBillMain_div .QuoteBillInfo_box .ShippingLabelDownload_btn {
  background: #E97278 !important;
  color: #ffffff !important;
}

.viewCustomerTabs_div {
  border: 0px !important;
  margin-top: 10px;
  gap: 15px;
  margin-bottom: 15px !important;
}
.viewCustomerTabs_div .nav-item .nav-link {
  border-radius: 10px;
  background: #ffffff;
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 20px;
  outline: 0px;
  box-shadow: none;
  border: 0px;
}
.viewCustomerTabs_div .nav-item .nav-link.active {
  background: #3c5b8a;
  color: #ffffff;
}

.ModalPostOPS_check {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
.ModalPostOPS_check .form-check {
  padding: 0px;
}
.ModalPostOPS_check .form-check .form-check-label {
  background: rgba(255, 140, 211, 0.4);
  padding: 10px 24px;
  line-height: normal;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
}
.ModalPostOPS_check .form-check .form-check-input {
  display: none;
}
.ModalPostOPS_check .form-check .form-check-input:checked ~ .form-check-label {
  background: #ff8cd3;
}

.postops-modal .modal-dialog {
  max-width: fit-content;
  width: auto;
  margin: 1.75rem auto;
}
.postops-modal .modal-content {
  width: fit-content;
  min-width: auto;
}
.postops-modal .modal-body {
  width: fit-content;
  padding: 1rem;
}

.postops-section {
  margin-bottom: 7px !important;
}

.postops-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 7px;
}

.postops-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 !important;
  margin: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.postops-checkbox {
  padding: 0 !important;
  margin: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.postops-checkbox.form-check {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.postops-checkbox .form-check-label {
  padding: 6px 0;
  line-height: normal;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 55px;
  text-align: center;
  display: inline-block;
}
.postops-checkbox .form-check-input {
  display: none;
}

.postops-f-series .form-check-label {
  background: rgba(255, 140, 211, 0.15);
  color: #d65ba8;
  border: 1px solid rgba(255, 140, 211, 0.3);
}
.postops-f-series .form-check-label:hover {
  background: rgba(255, 140, 211, 0.25);
}
.postops-f-series .form-check-input:checked ~ .form-check-label {
  background: #ff8cd3;
  color: #ffffff;
  border-color: #ff8cd3;
}

.postops-b-series .form-check-label {
  background: rgba(76, 175, 80, 0.15);
  color: #2e7d32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}
.postops-b-series .form-check-label:hover {
  background: rgba(76, 175, 80, 0.25);
}
.postops-b-series .form-check-input:checked ~ .form-check-label {
  background: #4caf50;
  color: #ffffff;
  border-color: #4caf50;
}

.postops-s-series .form-check-label {
  background: rgba(255, 186, 22, 0.15);
  color: #b38200;
  border: 1px solid rgba(255, 186, 22, 0.3);
}
.postops-s-series .form-check-label:hover {
  background: rgba(255, 186, 22, 0.25);
}
.postops-s-series .form-check-input:checked ~ .form-check-label {
  background: #FFBA16;
  color: #ffffff;
  border-color: #FFBA16;
}

.postops-c-series .form-check-label {
  background: rgba(239, 83, 80, 0.15);
  color: #c62828;
  border: 1px solid rgba(239, 83, 80, 0.3);
}
.postops-c-series .form-check-label:hover {
  background: rgba(239, 83, 80, 0.25);
}
.postops-c-series .form-check-input:checked ~ .form-check-label {
  background: #ef5350;
  color: #ffffff;
  border-color: #ef5350;
}

.postops-other-series .form-check-label {
  background: rgba(217, 70, 239, 0.15);
  color: #a21caf;
  border: 1px solid rgba(217, 70, 239, 0.3);
}
.postops-other-series .form-check-label:hover {
  background: rgba(217, 70, 239, 0.25);
}
.postops-other-series .form-check-input:checked ~ .form-check-label {
  background: #d946ef;
  color: #ffffff;
  border-color: #d946ef;
}

.postops-grid-container {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px;
  align-items: center;
  justify-content: start;
}

.postops-options-column {
  display: flex;
  flex-direction: column;
  width: fit-content;
}

.postops-legend-column {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 140px;
}

.postops-legend-vertical {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
}

.postops-legend-item-vertical {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-height: 28px;
}

.postops-legend-color {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid;
}

.postops-legend-column .postops-legend-code {
  width: 30px;
  padding: 0 4px;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  line-height: 20px;
}

.postops-legend-b {
  background: rgba(76, 175, 80, 0.15);
  border-color: rgba(76, 175, 80, 0.3);
}

.postops-legend-s {
  background: rgba(255, 186, 22, 0.15);
  border-color: rgba(255, 186, 22, 0.3);
}

.postops-legend-c {
  background: rgba(239, 83, 80, 0.15);
  border-color: rgba(239, 83, 80, 0.3);
}

.postops-legend-other {
  background: rgba(217, 70, 239, 0.15);
  border-color: rgba(217, 70, 239, 0.3);
}

.postops-legend-label {
  font-size: 13px;
  font-weight: 600;
  color: #212121;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.postops-three-columns {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 7px;
  justify-content: flex-start;
  align-items: flex-start;
}

.postOpsTagCheckbox_box,
.DragItemPost_box,
.tagFilter_btn {
  position: relative;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 4px 10px;
  margin-bottom: 5px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  transition: all 0.2s ease;
  min-width: 55px;
  width: 55px;
}
.postOpsTagCheckbox_box span,
.DragItemPost_box span,
.tagFilter_btn span {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  display: inline !important;
  color: inherit;
}
.postOpsTagCheckbox_box.postops-lineitem-f-series,
.DragItemPost_box.postops-lineitem-f-series,
.tagFilter_btn.postops-lineitem-f-series {
  background: rgba(255, 140, 211, 0.15) !important;
  color: #d65ba8 !important;
  border: 1px solid rgba(255, 140, 211, 0.3) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-f-series:hover,
.DragItemPost_box.postops-lineitem-f-series:hover,
.tagFilter_btn.postops-lineitem-f-series:hover {
  background: rgba(255, 140, 211, 0.25) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-f-series.active,
.DragItemPost_box.postops-lineitem-f-series.active,
.tagFilter_btn.postops-lineitem-f-series.active {
  background: #ff8cd3 !important;
  color: #ffffff !important;
  border-color: #ff8cd3 !important;
}
.postOpsTagCheckbox_box.postops-lineitem-b-series,
.DragItemPost_box.postops-lineitem-b-series,
.tagFilter_btn.postops-lineitem-b-series {
  background: rgba(76, 175, 80, 0.15) !important;
  color: #2e7d32 !important;
  border: 1px solid rgba(76, 175, 80, 0.3) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-b-series:hover,
.DragItemPost_box.postops-lineitem-b-series:hover,
.tagFilter_btn.postops-lineitem-b-series:hover {
  background: rgba(76, 175, 80, 0.25) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-b-series.active,
.DragItemPost_box.postops-lineitem-b-series.active,
.tagFilter_btn.postops-lineitem-b-series.active {
  background: #4caf50 !important;
  color: #ffffff !important;
  border-color: #4caf50 !important;
}
.postOpsTagCheckbox_box.postops-lineitem-s-series,
.DragItemPost_box.postops-lineitem-s-series,
.tagFilter_btn.postops-lineitem-s-series {
  background: rgba(255, 186, 22, 0.15) !important;
  color: #b38200 !important;
  border: 1px solid rgba(255, 186, 22, 0.3) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-s-series:hover,
.DragItemPost_box.postops-lineitem-s-series:hover,
.tagFilter_btn.postops-lineitem-s-series:hover {
  background: rgba(255, 186, 22, 0.25) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-s-series.active,
.DragItemPost_box.postops-lineitem-s-series.active,
.tagFilter_btn.postops-lineitem-s-series.active {
  background: #FFBA16 !important;
  color: #ffffff !important;
  border-color: #FFBA16 !important;
}
.postOpsTagCheckbox_box.postops-lineitem-c-series,
.DragItemPost_box.postops-lineitem-c-series,
.tagFilter_btn.postops-lineitem-c-series {
  background: rgba(239, 83, 80, 0.15) !important;
  color: #c62828 !important;
  border: 1px solid rgba(239, 83, 80, 0.3) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-c-series:hover,
.DragItemPost_box.postops-lineitem-c-series:hover,
.tagFilter_btn.postops-lineitem-c-series:hover {
  background: rgba(239, 83, 80, 0.25) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-c-series.active,
.DragItemPost_box.postops-lineitem-c-series.active,
.tagFilter_btn.postops-lineitem-c-series.active {
  background: #ef5350 !important;
  color: #ffffff !important;
  border-color: #ef5350 !important;
}
.postOpsTagCheckbox_box.postops-lineitem-other-series,
.DragItemPost_box.postops-lineitem-other-series,
.tagFilter_btn.postops-lineitem-other-series {
  background: rgba(217, 70, 239, 0.15) !important;
  color: #a21caf !important;
  border: 1px solid rgba(217, 70, 239, 0.3) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-other-series:hover,
.DragItemPost_box.postops-lineitem-other-series:hover,
.tagFilter_btn.postops-lineitem-other-series:hover {
  background: rgba(217, 70, 239, 0.25) !important;
}
.postOpsTagCheckbox_box.postops-lineitem-other-series.active,
.DragItemPost_box.postops-lineitem-other-series.active,
.tagFilter_btn.postops-lineitem-other-series.active {
  background: #d946ef !important;
  color: #ffffff !important;
  border-color: #d946ef !important;
}

.tagFilter_btn_cutting {
  position: relative;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 12px;
  margin-bottom: 5px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  border: 0px;
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
  min-width: 70px;
  width: 70px;
}
.tagFilter_btn_cutting:hover {
  filter: brightness(0.85);
  transform: translateY(-1px);
}
.tagFilter_btn_cutting.active {
  filter: brightness(0.75);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.postOpsCheckbox_div .postOpsTagCheckbox_box {
  margin-bottom: 0 !important;
}

.postOpsCheckbox_div > div.d-flex.align-items-center.gap-2 {
  margin-bottom: 5px;
}

.btncstm {
  color: #000000;
  border-bottom: none;
  border-radius: 0;
  font-size: 14px;
}
.btncstm:hover {
  opacity: 0.75;
}

.modal_header_blocking .modal-body p {
  color: #000000;
}

.smalltext {
  font-size: 12px;
  color: #6C6A72;
  display: block;
  margin-top: -5px;
}

.iconinfotext {
  top: -5px;
  right: -5px;
}

.baseratecustom {
  background-color: #F7F7F7;
  border-radius: 12px;
  padding: 12px;
  border: 1px dashed #000000;
}
.baseratecustom .react-tooltip__show {
  z-index: 1050;
  opacity: 1 !important;
}
.baseratecustom .baseratetitle {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
}
.baseratecustom .labeltitle {
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 500 !important;
  text-align: center;
  line-height: normal;
}
.baseratecustom .labeltitle small {
  display: block;
  font-size: 10px;
}
.baseratecustom .closebtn {
  border: none;
  position: absolute;
  top: 3px;
  background: transparent;
  right: 7px;
}

.badgestatus.badgeadded-Aluminium {
  display: none;
}

.badgestatus.badgeadded-Steel {
  display: none;
}

.badgestatus.badgeadded-Stainless {
  display: none;
}

.custom-table .rdt_TableRow.highlight-aluminium:first-child .badgestatus.badgeadded-Aluminium {
  display: block !important;
}

.custom-table .highlight-aluminium + .highlight-steel .badgestatus.badgeadded-Steel {
  display: block !important;
}

.custom-table .highlight-steel + .highlight-stainless .badgestatus.badgeadded-Stainless {
  display: block !important;
}

.shippingbg_box {
  background: rgba(0, 0, 0, 0.04);
  padding: 15px;
  border-radius: 15px;
}
.shippingbg_box .rate-option {
  padding-bottom: 15px;
}
.shippingbg_box .rate-option:last-child {
  padding-bottom: 0px;
}
.shippingbg_box .rate-option input[type=checkbox] {
  margin-top: 4px;
  flex-shrink: 0;
}
.shippingbg_box .rate-option label b {
  font-weight: 600;
}

.draft_default {
  font-size: 14px;
  border-radius: 30px;
  min-width: 62px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #635252;
  padding: 0 9px;
  height: 25px;
  line-height: 25px;
  margin-bottom: 0px;
  border: 1px solid #ccc;
}

.btncustom {
  background: rgba(78, 138, 200, 0.25) !important;
  padding: 4px 10px !important;
  color: #000000;
  border-radius: 30px !important;
}
.btncustom:hover {
  background: #3c5b8a !important;
  color: #ffffff !important;
}

.quote_scroll_cls {
  scrollbar-width: none;
  height: auto !important;
  overflow: visible !important;
}
.quote_scroll_cls > div {
  height: auto !important;
}
.quote_scroll_cls .quotelist {
  position: initial !important;
  height: auto !important;
}

.markup-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  margin-top: 2px;
  margin-bottom: 10px;
  background-color: #e8f5e9;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
  transition: all 0.2s ease-in-out;
}
.markup-badge svg {
  font-size: 14px;
  flex-shrink: 0;
}
.markup-badge .markup-percentage {
  white-space: nowrap;
}
.markup-badge .markup-amount {
  font-size: 11px;
  color: #388e3c;
  opacity: 0.8;
  white-space: nowrap;
}

.bulk-update-panel {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 16px 14px;
  margin-bottom: 20px;
}
.bulk-update-panel .form-check {
  margin-bottom: 0;
}
.bulk-update-panel .form-check .form-check-label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.bulk-update-panel .form-check .form-check-input {
  cursor: pointer;
  margin-top: 0.15em;
}
.bulk-update-panel .input-group {
  max-width: 110px;
}
.bulk-update-panel .input-group .form-control {
  max-width: 46px;
  padding: 0.375rem 0.25rem;
  font-size: 14px;
}
.bulk-update-panel .input-group .btn {
  padding: 0.375rem 0.5rem;
  font-size: 16px;
}
.bulk-update-panel .bulk-update-btn {
  height: 38px;
  font-size: 14px;
  font-weight: 500;
}
.bulk-update-panel .bulk-update-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
@media (max-width: 768px) {
  .bulk-update-panel {
    padding: 14px 12px;
  }
  .bulk-update-panel .bulk-update-btn {
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACI,SAAA;EACA,UAAA;AADJ;;AAIA;;;EAGI,gCCyCU;AD1Cd;;AAGA;EACI,UAAA;EACA,eAAA;AAAJ;;AAEE;EAEK,sBAAA;AACP;;AACA;;EAEI,oCAAA;AAEJ;;AAAA;EACI,aAAA;EACA,YAAA;AAGJ;;AADA;EACI,wBAAA;AAIJ;AAHI;EAFJ;IAGQ,wBAAA;EAMN;AACF;;AAJA;EACI,kBAAA;AAOJ;;AAHI;EADJ;IAEQ,kBAAA;EAON;AACF;;AAJA;EACI,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAOJ;AALI;EACI,eAAA;EACA,kBAAA;AAOR;AAJI;EAhBJ;IAiBQ,0BAAA;EAON;AACF;AALI;EACI,aAAA;EACA,yBAAA;AAOR;;AAHA;EACI,8BAAA;EACA,gCAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;AAMJ;AALA;EACI,YAAA;EACA,0BAAA;AAOJ;AALI;EACI,eAAA;EACA,kBAAA;AAOR;AAJI;EAnBJ;IAoBQ,0BAAA;EAON;EALM;IACI,eAAA;EAOV;AACF;AAJI;EACI,aAAA;EACA,yBAAA;AAMR;;AAFA;EACI,8CAAA;EACA,gDAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,8BAAA;EACA,yBAAA;AAKJ;AAJI;EACI,YAAA;EACA,0BAAA;AAMR;AAJI;EACI,eAAA;EACA,kBAAA;AAMR;AAHI;EAnBJ;IAoBQ,0BAAA;EAMN;EAJM;IACI,eAAA;EAMV;AACF;AAHI;EACI,aAAA;EACA,yBAAA;AAKR;;AADA;EAEI;;;;IAII,4BAAA;EAGN;AACF;AADA;EAEI,sBAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ;;AADA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAIJ;;AAFA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAKJ;;AAHA,mBAAA;AACA;EACI,wBAAA;AAMJ;AALI;EACI,4CAAA;EACA,mBCtIM;EDuIN,gBAAA;EACA,mBAAA;AAOR;AALQ;EANJ;IAOQ,gBAAA;IACA,mBAAA;EAQV;AACF;AALY;EACI,YAAA;AAOhB;AALgB;EAHJ;IAIQ,YAAA;EAQlB;AACF;AAHY;EADJ;IAEQ,+BAAA;EAMd;AACF;AAHgB;EACI,kBAAA;EACA,mBAAA;EACA,cCtKF;EDuKE,eAAA;EACA,gBAAA;AAKpB;AAHoB;EAPJ;IAQQ,4BAAA;EAMtB;AACF;AAJoB;EAEI,cC7MR;ADkNhB;AAGoB;EACI,aAAA;AADxB;AAKgB;EACI,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,iBAAA;AAHpB;AAMwB;EACI,cCrMV;EDsMU,iBAAA;EACA,uBAAA;AAJ5B;AAM4B;EAEI,cCxOhB;ADmOhB;AAOgC;EACI,+BAAA;EACA,UAAA;AALpC;AAS4B;EACI,eAAA;EACA,eAAA;EACA,iBAAA;AAPhC;AAU4B;EACI,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;AARhC;AAiBI;EACI,kBAAA;AAfR;AAiBQ;EAHJ;IAIQ,2BAAA;EAdV;AACF;AAgBQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,wBAAA;EACA,4DAAA;AAdZ;AAgBY;EACI,yBCnPF;ADqOd;AAiBY;EACI,4DAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAfhB;AAmBQ;EACI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cChQE;AD+Od;AAmBY;EACI,UAAA;AAjBhB;AAoBY;EACI,SAAA;AAlBhB;AA0BY;EACI,kBAAA;AAxBhB;AA0BgB;EAHJ;IAIQ,gBAAA;EAvBlB;AACF;AAyBgB;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;EACA,MAAA;EACA,qCAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAvBpB;AAyBoB;EApBJ;IAqBQ,OAAA;IACA,cAAA;IACA,mBAAA;EAtBtB;AACF;AAyBgB;EACI,yBAAA;EACA,aAAA;AAvBpB;AAyBoB;EAJJ;IAKQ,8BAAA;EAtBtB;AACF;AAyBoB;EACI,gBAAA;EACA,UAAA;AAvBxB;AA4BY;EACI,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA1BhB;AA8BQ;EACI,yCAAA;AA5BZ;AA8BY;EAHJ;IAIQ,YAAA;EA3Bd;AACF;AA6BY;EACI,cAAA;EACA,iBAAA;AA3BhB;AA6BgB;EACI,eAAA;EACA,iBAAA;AA3BpB;AAgCQ;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cC/VE;ADiUd;AAgCY;EANJ;IAOQ,gBAAA;EA7Bd;AACF;AA+BY;EACI,eAAA;EACA,iBAAA;EACA,UAAA;AA7BhB;AAiCQ;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,6CAAA;EACA,yBAAA;EACA,kBAAA;AA/BZ;AAiCY;EACI,eAAA;EACA,aAAA;AA/BhB;AAkCY;EACI,cAAA;EACA,qBAAA;EACA,yBAAA;AAhChB;AAmCY;EAEI,oCAAA;EACA,mCAAA;EACA,cC1YF;ED2YE,+CAAA;EACA,qBAAA;AAlChB;AAqCY;EAnCJ;IAoCQ,kBAAA;IACA,qBAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,uBAAA;EAlCd;EAoCc;IACI,eAAA;EAlClB;AACF;AAsCQ;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,wCAAA;EACA,6CAAA;EACA,yBAAA;AApCZ;AAsCY;EACI,eAAA;EACA,aAAA;AApChB;AAuCY;EAEI,cCnbF;EDobE,oCAAA;EACA,mCAAA;EACA,+CAAA;EACA,qBAAA;AAtChB;;AA4CA,kBAAA;AACA,mBAAA;AAEI;EACI,wCAAA;EACA,iBAAA;EACA,oBAAA;AA1CR;AA4CQ;EACI,gBAAA;EACA,eAAA;EACA,cC5cM;ADkalB;AA4CY;EALJ;IAMQ,eAAA;EAzCd;AACF;AA6CI;EACI,sBAAA;AA3CR;AA6CQ;EAHJ;IAIQ,sBAAA;EA1CV;AACF;AA4CQ;EAPJ;IAQQ,sBAAA;EAzCV;AACF;AA4CY;EADJ;IAEQ,mBAAA;EAzCd;AACF;AA2CY;EACI,eAAA;EACA,cCpeF;EDqeE,gBAAA;EACA,mBAAA;AAzChB;AA2CgB;EANJ;IAOQ,eAAA;IACA,mBAAA;EAxClB;AACF;AA2CY;EACI,kBAAA;AAzChB;AA4CoB;EACI,gBAAA;AA1CxB;AA4CwB;EAHJ;IAIQ,gBAAA;EAzC1B;AACF;AA2CwB;EACI,qBAAA;EACA,cC7fV;ED8fU,eAAA;AAzC5B;AA2C4B;EALJ;IAMQ,eAAA;EAxC9B;AACF;AA8CoB;EACI,gBAAA;AA5CxB;AA8CwB;EAHJ;IAIQ,gBAAA;EA3C1B;AACF;AA6CwB;EACI,qBAAA;EACA,cCjhBV;EDkhBU,eAAA;AA3C5B;AA6C4B;EALJ;IAMQ,eAAA;EA1C9B;AACF;AA8C4B;EACI,cCxjBhB;AD4gBhB;AAqDI;EACI,2CAAA;EACA,wCAAA;AAnDR;AAqDQ;EAJJ;IAKQ,mBAAA;EAlDV;AACF;AAoDQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAlDZ;AAoDY;EALJ;IAMQ,sBAAA;IACA,uBAAA;IACA,iBAAA;EAjDd;AACF;AAmDY;EACI,aAAA;EACA,mBAAA;AAjDhB;AAmDgB;EAJJ;IAKQ,sBAAA;IACA,uBAAA;EAhDlB;AACF;AAkDgB;EACI,eAAA;EACA,gBAAA;EACA,cCjkBN;EDkkBM,qBAAA;EACA,iBAAA;AAhDpB;AAkDoB;EAPJ;IAQQ,eAAA;EA/CtB;AACF;AAiDoB;EAXJ;IAYQ,gBAAA;EA9CtB;AACF;AAgDoB;EAfJ;IAgBQ,eAAA;EA7CtB;AACF;AAgDgB;EACI,aAAA;EACA,mBAAA;AA9CpB;AAgDoB;EAJJ;IAKQ,gBAAA;EA7CtB;AACF;AA+CoB;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AA7CxB;AA+CwB;EARJ;IASQ,YAAA;IACA,WAAA;EA5C1B;AACF;AA8CwB;EAbJ;IAcQ,WAAA;EA3C1B;AACF;AA8C4B;EACI,cC5oBhB;ADgmBhB;AAgDwB;EACI,eAAA;EACA,cCnnBd;ADqkBd;AAiDwB;EACI,yCAAA;AA/C5B;;AAwDA,kBAAA;AACA,mBAAA;AACA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBCvoBU;EDwoBV,aAAA;EACA,mBAAA;EACA,uBAAA;AArDJ;AAuDI;EACI,aAAA;EACA,2BAAA;AArDR;AAwDI;EAEI;IAEI,mBAAA;IACA,UAAA;EAxDV;EA2DM;IACI,qBAAA;IACA,UAAA;EAzDV;AACF;;AA6DA,kBAAA;AACA,iBAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;AA1DJ;AA4DI;EACI,iBAAA;EACA,oBAAA;AA1DR;AA6DI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,mBCrrBM;EDsrBN,kDAAA;AA3DR;AA6DQ;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AA3DZ;AA+DI;EACI,mBC/rBM;EDgsBN,aAAA;EACA,mBAAA;EACA,4CAAA;AA7DR;AA+DQ;EANJ;IAOQ,aAAA;EA5DV;AACF;AA8DQ;EACI;IACI,0BAAA;EA5Dd;AACF;AAgEY;EACI,eAAA;EACA,cCntBF;EDotBE,gBAAA;AA9DhB;AAiEY;EACI,eAAA;EACA,cC3tBE;ED4tBF,gBAAA;EACA,gBAAA;EACA,cAAA;AA/DhB;AAoEY;EACI,cCluBF;EDmuBE,gBAAA;EACA,qBAAA;EACA,eAAA;AAlEhB;AAsEQ;EACI,eAAA;EACA,cC3uBE;ADuqBd;AAsEY;EACI,cC7wBA;ED8wBA,gBAAA;EACA,qBAAA;AApEhB;AAyEY;EACI,eAAA;EACA,gBAAA;EACA,cCxvBF;ADirBd;AAyEgB;EACI,YAAA;AAvEpB;AA4EgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AA1EpB;AA8EY;EACI,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA5EhB;AA8EgB;EACI,mBAAA;AA5EpB;AA+EgB;EACI,gBAAA;AA7EpB;AAgFgB;EACI,YAAA;AA9EpB;;AAsFI;EACI,gBAAA;AAnFR;AAqFQ;EACI,mBAAA;AAnFZ;AAqFY;EACI,kBAAA;EACA,aAAA;AAnFhB;AAqFgB;EACI,eAAA;EACA,cC9yBN;ED+yBM,gBAAA;AAnFpB;AAsFgB;EACI,eAAA;EACA,cCtzBF;EDuzBE,gBAAA;EACA,gBAAA;AApFpB;AAuFgB;EACI,gBAAA;AArFpB;;AA4FA,gBAAA;AACA,iBAAA;AAEA;EACI,iBAAA;EACA,oBAAA;AA1FJ;AA4FQ;EACQ,eAAA;EACA,cC10BF;ED20BE,mBAAA;EACA,gBAAA;AA1FhB;AA4FgB;EANR;IAOY,eAAA;IACA,mBAAA;EAzFlB;AACF;AA2FgB;EAXR;IAYY,eAAA;EAxFlB;AACF;AA0FgB;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAxFpB;AA0FoB;EACI,kBAAA;EACA,SAAA;EACA,aAAA;AAxFxB;AA4FY;EACI,cCt2BF;EDu2BE,eAAA;EACA,iBAAA;EAEA,kBAAA;AA3FhB;AA4FgB;EANJ;IAOQ,eAAA;EAzFlB;AACF;AA2FgB;EAVJ;IAWQ,eAAA;EAxFlB;AACF;;AA4FA;EAaI,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AArGJ;AAmFI;EACI,iBAAA;EAGA,iBAAA;EACA,iBAAA;AAnFR;AAqFQ;EAPJ;IAQQ,iBAAA;EAlFV;AACF;AA6FI;EArBJ;IAsBQ,iBAAA;IACA,oBAAA;EA1FN;AACF;AA4FI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;AA1FR;AA4FQ;EACI,gBAAA;EACA,mBAAA;AA1FZ;AA4FY;EAJJ;IAKQ,gBAAA;IACA,mBAAA;EAzFd;AACF;AA2FY;EACI,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oCAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cCv6BF;EDw6BE,gBAAA;AAzFhB;AA2FgB;EAbJ;IAcQ,eAAA;EAxFlB;AACF;AA0FgB;EACI,eAAA;EACA,cC/8BJ;EDg9BI,kBAAA;AAxFpB;AA6FQ;EACI,eAAA;EACA,cCx7BE;EDy7BF,mBAAA;EACA,gBAAA;AA3FZ;AA4FY;EALJ;IAMQ,eAAA;IACA,mBAAA;EAzFd;AACF;AA2FY;EAVJ;IAWQ,eAAA;EAxFd;AACF;AA0FY;EACI,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAxFhB;AA0FgB;EACI,kBAAA;EACA,SAAA;EACA,aAAA;AAxFpB;AA4FG;EACC,gBAAA;EACA,cCp9BU;AD03Bd;AA2FI;EACI,gBAAA;AAzFR;AA4FQ;EACI,cC19BE;ED29BF,eAAA;EACA,iBAAA;AA1FZ;AA4FY;EACI,eAAA;EACA,cAAA;AA1FhB;AA4FY;EATJ;IAUQ,eAAA;EAzFd;AACF;AA2FY;EAbJ;IAcQ,eAAA;EAxFd;AACF;AA0FY;EACI,eAAA;AAxFhB;AA0FgB;EAHJ;IAIQ,eAAA;EAvFlB;AACF;AAyFgB;EAPJ;IAQQ,eAAA;EAtFlB;AACF;;AA4FA;EACI,yBAAA;EACA,iBAAA;EACA,oBAAA;AAzFJ;AA0FI;EACI,yBAAA;EACA,yBC7/BM;ED8/BN,4CAAA;EACA,mBAAA;EACA,aAAA;AAxFR;AA0FY;EACI,mBAAA;EACA,aAAA;EACI,mBAAA;EACA,SAAA;AAxFpB;AAyFgB;EACI,YAAA;EACA,aAAA;AAvFpB;AAyFgB;EACI,eAAA;EACA,cC/gCN;EDghCM,gBAAA;EACA,gBAAA;AAvFpB;AA0FY;EACI,eAAA;EACA,cCthCF;EDuhCE,gBAAA;AAxFhB;AA0FY;EACI,cC1hCF;ED2hCE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAxFhB;AA4FgB;EACI,cCxjCJ;EDyjCI,eAAA;AA1FpB;AA+FY;EACI,eAAA;EACA,cC3iCF;ED4iCE,gBAAA;AA7FhB;AA+FW;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AA7Ff;AA8Fe;EACC,eAAA;EACA,cCrjCF;EDsjCE,gBAAA;AA5FhB;AA8FY;EACI,eAAA;EACA,cC1jCF;ED2jCE,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;AA5FhB;AA6FgB;EACI,cAAA;AA3FpB;AA8FY;EACI,eAAA;EACA,cCvkCF;EDwkCE,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;AA5FhB;AA6FgB;EACI,cAAA;AA3FpB;AA8Fa;EACG,eAAA;EACA,cCplCF;EDqlCE,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;AA5FhB;AA6FgB;EACI,cCpnCL;ADyhCf;AA6Fc;EACE,mBAAA;AA3FhB;AA4Fe;EACC,eAAA;EACA,cAAA;AA1FhB;AA2FgB;EACI,aAAA;AAzFpB;AA6Fa;EACG,eAAA;EACA,qBAAA;EACA,cC3mCF;ED4mCE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mCAAA;EACA,8BAAA;AA3FhB;AA8FW;EACC,gBAAA;EACA,mBAAA;AA5FZ;AA8FY;EAJD;IAKK,eAAA;EA3Fd;AACF;AA4FY;EAPD;IAQK,eAAA;EAzFd;AACF;;AA8FA;EACI,yBAAA;EACA,iBAAA;EACA,oBAAA;AA3FJ;AA4FI;EACI,eAAA;EACA,cCvoCM;EDwoCN,gBAAA;EACA,mBAAA;EACA,0BAAA;AA1FR;AA6FQ;EACI,mBAAA;EACA,+CAAA;EACA,4CAAA;EACA,8BAAA;AA3FZ;AA6FY;EACI,2BAAA;AA3FhB;AA8FoB;EACI,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,cC3pCV;ED4pCU,aAAA;EACA,mBC3pCV;ED4pCU,gBAAA;AA5FxB;AA6FwB;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,yDAAA;EACA,YAAA;AA3F5B;AA6FwB;EACI,cC9qCd;ADmlCd;AA4F4B;EACI,0BAAA;AA1FhC;AAiGY;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cC9rCE;AD+lClB;;AAoGA;EACI,iBAAA;EACA,oBAAA;AAjGJ;AAkGI;EACI,gBAAA;AAhGR;AAkGI;EACI,cCxsCM;EDysCN,gBAAA;AAhGR;;AAmGA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAhGJ;AAkGI;EANJ;IAOQ,oBAAA;IACA,kBAAA;EA/FN;AACF;AAiGI;EACI,kBAAA;EACA,UAAA;AA/FR;AAiGQ;EACI,iBAAA;AA/FZ;AAkGQ;EARJ;IASQ,mBAAA;EA/FV;AACF;AAiGQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AA/FZ;AAiGY;EAbJ;IAcQ,YAAA;IACA,aAAA;IACA,4BAAA;IACA,UAAA;IACA,WAAA;EA9Fd;AACF;AAkGI;EACI,kBAAA;EACA,UAAA;EACA,mBC3vCM;ED4vCN,kBAAA;EACA,kBAAA;EACA,4CAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAhGR;AAkGQ;EAXJ;IAYQ,kBAAA;EA/FV;AACF;AAiGQ;EAfJ;IAgBQ,mBAAA;EA9FV;AACF;AAgGQ;EACI,eAAA;EACA,cC/wCE;EDgxCF,gBAAA;AA9FZ;AAgGY;EALJ;IAMQ,eAAA;EA7Fd;AACF;AAgGQ;EACI,eAAA;EACA,cC3xCM;AD6rClB;AAgGY;EAJJ;IAKQ,eAAA;EA7Fd;AACF;AAgGQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AA9FZ;AAiGQ;EACI,WAAA;EACA,mDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AA/FZ;AAkGQ;EACI,mBCx1CI;EDy1CJ,eAAA;AAhGZ;AAkGY;;EAEI,cC5zCF;AD4tCd;AAmGY;EACI,yDAAA;AAjGhB;AAmGgB;EACI,+BAAA;AAjGpB;AAqGY;EACI,UAAA;AAnGhB;;AAyGA;EACI,gBAAA;AAtGJ;;AAyGA;EACI,gBAAA;AAtGJ;;AA0GI;EACI,eAAA;EACA,cC31CM;ED41CN,gBAAA;EACA,0BAAA;AAvGR;AAyGQ;EANJ;IAOQ,eAAA;EAtGV;AACF;AAyGI;EACI,eAAA;EACA,cCx2CU;EDy2CV,gBAAA;AAvGR;AAyGQ;EALJ;IAMQ,eAAA;EAtGV;AACF;;AA0GA;EACI,mBC92CU;ED+2CV,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAvGJ;AAyGI;EACI,yBAAA;AAvGR;AA0GI;EACI,yBAAA;AAxGR;AA2GI;EACI,yBAAA;AAzGR;AA4GI;EACI,yBAAA;AA1GR;AA6GI;EACI,yBAAA;AA3GR;AA8GI;EACI,eAAA;AA5GR;AAgHI;EACI,aAAA;EACA,mBAAA;AA9GR;AAgHQ;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA9GZ;AAgHY;EATJ;IAUQ,WAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EA7Gd;AACF;AAgHQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA9GZ;AAgHY;EANJ;IAOQ,eAAA;EA7Gd;AACF;AAmHY;EACI,YAAA;EACA,eAAA;AAjHhB;AAqHQ;EACI,YAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cCr8CE;EDs8CF,mBAAA;AAnHZ;;AAwHA;EACI,eAAA;AArHJ;;AAwHA;EACI,8BAAA;AArHJ;;AAwHA;EACI,8BAAA;AArHJ;;AAwHA;EACI,8BAAA;AArHJ;;AAwHA;EACI,8BAAA;AArHJ;;AAwHA;EACI,8BAAA;AArHJ;;AAwHA;EACI,kBAAA;EACA,qBAAA;AArHJ;AAuHI;EAJJ;IAKQ,oBAAA;IACA,iBAAA;EApHN;AACF;AAsHI;EACI,gBAAA;AApHR;AAsHQ;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AApHZ;AAsHY;EALJ;IAMQ,gBAAA;EAnHd;AACF;AAqHY;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mDAAA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;AAnHhB;AAqHgB;EAdJ;IAeQ,YAAA;IACA,aAAA;IACA,4BAAA;IACA,UAAA;IACA,YAAA;EAlHlB;AACF;AAyHQ;EADJ;IAEQ,mBAAA;EAtHV;AACF;AAwHQ;EACI,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AAtHZ;AAwHY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;AAtHhB;AAyHY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,mBC7iDF;ED8iDE,2CAAA;EACA,UAAA;AAvHhB;AA0HY;EACI,kCAAA;EACA,gBAAA;AAxHhB;AA0HgB;EAEI;IAEI,wBAAA;EA1HtB;EA6HkB;IACI,6BAAA;EA3HtB;AACF;AAiII;EACI,kBAAA;EACA,WAAA;AA/HR;AAiIQ;EACI,mBC1kDE;ED2kDF,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA/HZ;AAiIY;EACI,8BAAA;EACA,eAAA;AA/HhB;AAkIY;EACI,mBAAA;AAhIhB;AAmIY;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAjIhB;AAmIgB;EAXJ;IAYQ,WAAA;IACA,eAAA;IACA,YAAA;EAhIlB;AACF;AAkIgB;EACI,eAAA;EACA,cC/oDJ;AD+gDhB;AAsIgB;EACI,eAAA;EACA,cCxnDN;EDynDM,gBAAA;AApIpB;AAsIoB;EALJ;IAMQ,eAAA;EAnItB;AACF;AAsIgB;EACI,eAAA;EACA,cCpoDF;EDqoDE,kBAAA;AApIpB;AAsIoB;EALJ;IAMQ,eAAA;EAnItB;AACF;;AA4II;EACI,kBAAA;EACA,UAAA;EACA,WAAA;AAzIR;AA4II;EACI,gBAAA;AA1IR;AA6II;EACI,iBAAA;AA3IR;AA+II;EACI,mBC9pDM;ED+pDN,sBAAA;EACA,4CAAA;EACA,qBAAA;EACA,mBAAA;AA7IR;AA+IQ;EAPJ;IAQQ,sBAAA;EA5IV;AACF;AA8IQ;EACI,kBAAA;AA5IZ;AA8IY;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AA5IhB;AA+IY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA7IhB;AA+IgB;EANJ;IAOQ,eAAA;EA5IlB;AACF;AA+IY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AA7IhB;AA+IgB;EALJ;IAMQ,eAAA;EA5IlB;AACF;AAgJgB;EACI,cCjuDL;ADmlDf;AAmJQ;EACI,aAAA;AAjJZ;AAmJY;EACI;IACI,YAAA;EAjJlB;AACF;AAqJQ;EACI,gBAAA;AAnJZ;AAqJY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCnuDE;EDouDF,iBAAA;EACA,kBAAA;AAnJhB;AAqJgB;EARJ;IASQ,eAAA;EAlJlB;AACF;;AAwJA;EACI,kBAAA;EACA,qBAAA;AArJJ;AAuJI;EAJJ;IAKQ,iBAAA;IACA,oBAAA;EApJN;AACF;;AAwJA;EACI,iBAAA;AArJJ;AAuJI;EAHJ;IAIQ,iBAAA;EApJN;AACF;AAsJI;EACI,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AApJR;AAqJQ;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AAnJZ;AAoJY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;AAlJhB;AAoJY;EACI,kBAAA;EACA,UAAA;EACA,cCpxDF;EDqxDE,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlJhB;AAmJgB;EACI,oCAAA;AAjJpB;AAoJA;EACI;IACI,uBAAA;EAlJN;EAoJE;IACI,yBAAA;EAlJN;AACF;AAsJQ;EACI,eAAA;AApJZ;AAuJQ;EACI,eAAA;EACA,gBAAA;EACA,cCnzDE;AD8pDd;AAuJY;EALJ;IAMQ,eAAA;EApJd;AACF;AAuJQ;EACI,eAAA;EACA,UAAA;EACA,oBAAA;AArJZ;AAuJY;EALJ;IAMQ,eAAA;EApJd;AACF;AAsJY;EACI,cCn2DA;EDo2DA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AApJhB;AA0JQ;EACI,qCAAA;EACA,0CAAA;EACA,sCAAA;EACA,iBAAA;AAxJZ;AA2JQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,4CAAA;EACA,0CAAA;AAzJZ;AA4JQ;EACI,cCp3DE;EDq3DF,cAAA;AA1JZ;AA6JQ;EACI,iBAAA;AA3JZ;AA8JQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;AA5JZ;AA+JQ;EACI,mBAAA;EACA,qBAAA;AA7JZ;AAgKQ;EACI,cAAA;EACA,gBAAA;AA9JZ;AAiKQ;EACI,eAAA;EACA,yCAAA;AA/JZ;AAmKI;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAjKR;AAkKQ;EACI,qBAAA;AAhKZ;AAiKY;EACI,WAAA;EACA,YAAA;EACA,mBC54DF;ED64DE,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,gBAAA;EACA,cAAA;AA/JhB;AAiKY;EACI,cCt5DF;ADuvDd;AAkKgB;EACI,mBCz7DJ;ED07DI,cCz5DN;ADyvDd;;AAuKA,gBAAA;AACA,oBAAA;AAEA;EACI,iBAAA;EACA,oBAAA;AArKJ;AAuKI;EAJJ;IAKQ,iBAAA;IACA,oBAAA;EApKN;AACF;AAsKI;EACI,yCAAA;EACA,aAAA;AApKR;AAsKQ;EACI,eAAA;EACA,cCp7DE;EDq7DF,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AApKZ;AAsKY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBC/9DA;AD2zDhB;AAwKQ;EACI,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAtKZ;AAyKQ;EACI,eAAA;EACA,cCh9DM;EDi9DN,iBAAA;EACA,kBAAA;AAvKZ;AAyKY;EANJ;IAOQ,gBAAA;EAtKd;AACF;;AA6KQ;EACI,WAAA;EACA,YAAA;AA1KZ;AA4KY;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBClgEA;ADw1DhB;AA4KgB;EACI,wBAAA;AA1KpB;AA+KgB;EACI,WAAA;AA7KpB;;AAqLI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;AAlLR;AAoLQ;EACI,mBAAA;AAlLZ;AAqLQ;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAnLZ;AAwLQ;EADJ;IAEQ,gBAAA;EArLV;AACF;AAuLQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AArLZ;AAuLY;EALJ;IAMQ,eAAA;EApLd;AACF;AAuLQ;EACI,eAAA;EACA,iBAAA;EACA,cC9hEM;ADy2DlB;AAuLY;EALJ;IAMQ,eAAA;EApLd;AACF;AAsLY;EATJ;IAUQ,eAAA;EAnLd;AACF;;AAwLA;EACI,kBAAA;EACA,qBAAA;AArLJ;AAuLI;EAJJ;IAKQ,iBAAA;IACA,oBAAA;EApLN;AACF;AAsLI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EAyCA,kBAAA;EACA,mBAAA;EACA,mBC/lEM;EDgmEN,4CAAA;AA5NR;AAkLQ;EACI,yBAAA;AAhLZ;AAmLQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AAjLZ;AAmLY;EACI,eAAA;EACA,cCzmEA;ADw7DhB;AAqLQ;EACI,eAAA;EACA,cChlEE;EDilEF,gBAAA;AAnLZ;AAqLY;EALJ;IAMQ,eAAA;EAlLd;AACF;AAqLQ;EACI,eAAA;EACA,iBAAA;EACA,cC7lEM;ED8lEN,kBAAA;AAnLZ;;AA6LA,oBAAA;AACA,qBAAA;AACA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cC9mEU;ADo7Dd;;AA6LI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;AA1LR;AA4LQ;EALJ;IAMQ,gBAAA;EAzLV;AACF;AA2LQ;EACI,kCAAA;AAzLZ;AA2LY;EAHJ;IAIQ,kCAAA;EAxLd;AACF;AA2LQ;EACI,WAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;AAzLZ;AA2LY;EAXJ;IAYQ,kCAAA;EAxLd;AACF;AA8LQ;EACI,eAAA;AA5LZ;AA8LY;EAHJ;IAIQ,eAAA;EA3Ld;AACF;AA6LY;EAPJ;IAQQ,eAAA;EA1Ld;AACF;AA4LQ;EACI,kBAAA;AA1LZ;AA4LQ;EACI,aAAA;EACA,SAAA;AA1LZ;AA4LY;EAJJ;IAKQ,SAAA;IACA,sBAAA;EAzLd;AACF;AA2LY;EATJ;IAUQ,mBAAA;EAxLd;AACF;AA0LY;EAbJ;IAcQ,sBAAA;EAvLd;AACF;AAyLY;EACI,SAAA;AAvLhB;AAyLgB;EAHJ;IAIQ,aAAA;EAtLlB;AACF;AAwLgB;EACI,eAAA;AAtLpB;AA4LY;EACI,eAAA;AA1LhB;AA4LgB;EAHJ;IAIQ,eAAA;EAzLlB;AACF;AA4LY;EACI,eAAA;AA1LhB;AA4LgB;EAHJ;IAIQ,eAAA;EAzLlB;AACF;AA6LQ;EACI,mBAAA;AA3LZ;AA8LQ;EACI,eAAA;AA5LZ;AA8LY;EAHJ;IAIQ,eAAA;EA3Ld;AACF;AA6LY;EAPJ;IAQQ,eAAA;EA1Ld;AACF;;AA8LA;EACI,gBAAA;EACA,gBAAA;AA3LJ;;AA6LA;EACI,oBAAA;AA1LJ;;AA4LA;EACI,iBAAA;EACA,oBAAA;AAzLJ;;AA2LA;EACI,yBAAA;AAxLJ;;AA0LA;EACI,iBAAA;EACA,oBAAA;EACA,yBAAA;AAvLJ;AAyLQ;EACI,eAAA;EACA,iBAAA;EACA,cCzvEE;ED0vEF,mBAAA;AAvLZ;AAyLQ;EACI,eAAA;EACA,iBAAA;EACA,cC/vEE;EDgwEF,mBAAA;AAvLZ;AAyLQ;EACI,eAAA;EACA,gBAAA;EACA,cCrwEE;EDswEF,mBAAA;AAvLZ;AAwLY;EACI,gBAAA;AAtLhB;AAyLQ;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;AAvLZ;AAwLY;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;AAtLhB;AAwLY;EACI,eAAA;EACA,gBAAA;EACA,cCvxEF;EDwxEE,kBAAA;AAtLhB;;AA2LA;EACI,oBAAA;AAxLJ;AAyLI;EACI,yBAAA;EACA,iBAAA;EACA,oBAAA;AAvLR;AAyLI;EACI,mBAAA;AAvLR;AAwLQ;EACI,eAAA;EACA,iBAAA;EACA,cCzyEE;ED0yEF,mBAAA;AAtLZ;AAwLQ;EACI,eAAA;EACA,gBAAA;EACA,cC/yEE;EDgzEF,mBAAA;AAtLZ;AAwLQ;EACI,gBAAA;EACA,oBAAA;AAtLZ;AAuLY;EACI,eAAA;EACA,gBAAA;EACA,cCxzEF;ADmoEd;AAwLQ;EACI,kBAAA;AAtLZ;AAuLY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AArLhB;AAsLgB;EAPJ;IASQ,YAAA;EApLlB;AACF;AAsLY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AApLhB;AAuLgB;EACI,yBAAA;AArLpB;AAuLgB;EACI,cAAA;AArLpB;AAyLgB;EACI,yBAAA;AAvLpB;AAyLgB;EACI,cAAA;AAvLpB;AA2LgB;EACI,yBAAA;AAzLpB;AA2LgB;EACI,cAAA;AAzLpB;;AA+LA;EACI,iBAAA;EACA,oBAAA;AA5LJ;AA6LI;EACI,eAAA;EACA,gBAAA;EACA,cC/2EM;EDg3EN,mBAAA;AA3LR;AA6LI;EACI,eAAA;EACA,gBAAA;EACA,cCr3EM;EDs3EN,mBAAA;AA3LR;AA6LI;EAII,yBAAA;EACA,yBC33EM;ED43EN,4CAAA;EACA,mBAAA;EACA,aAAA;AA9LR;AA+LQ;EACI,mBAAA;EACC,WAAA;EACA,YAAA;AA7Lb;AA+LQ;EACI,cAAA;EACA,eAAA;AA7LZ;AA+LQ;EACI,YAAA;AA7LZ;AA8LY;EACI,eAAA;EACA,iBAAA;EACA,cC/4EF;EDg5EE,kBAAA;AA5LhB;AA8LY;EACI,eAAA;EACA,gBAAA;EACA,cCr5EF;EDs5EE,kBAAA;AA5LhB;;AAiMA;EACI,iBAAA;EACA,4BAAA;AA9LJ;AA+LI;EACI,mBC75EM;ED85EN,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA7LR;AAiMoB;EACI,UAAA;EACA,4BAAA;AA/LxB;AAiMoB;EACI,UAAA;EACA,4BAAA;AA/LxB;AAoMQ;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAlMZ;AAmMY;EANJ;IAOQ,aAAA;EAhMd;AACF;AAiMY;EATJ;IAUQ,aAAA;EA9Ld;AACF;AA+LY;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA7LhB;AA8LgB;EAVJ;IAWQ,mBAAA;EA3LlB;AACF;AA4LgB;EACI,UAAA;EACA,4BAAA;AA1LpB;AA4LgB;EACI,UAAA;EACA,4BAAA;AA1LpB;AA8LQ;EACI,mBAAA;EACA,kBAAA;AA5LZ;AA6LY;EACI,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC/9EF;ADoyEd;AA4LgB;EACI,cChgFJ;ADs0EhB;AA8LQ;EAAK,mBAAA;EACD,eAAA;EACA,gBAAA;EACA,cC1+EM;ED2+EN,kBAAA;AA3LZ;AA6LY;EACK,cC9+EC;ED++EA,qBAAA;AA3LlB;AA4LgB;EACI,cC9gFJ;ADo1EhB;;AAkMQ;EACI,kBAAA;EACA,kBAAA;AA/LZ;AAgMY;EACI,eAAA;EACA,cC5/EF;AD8zEd;AAiMY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA/LhB;;AAuMY;EACI,eAAA;EACA,iBAAA;EACA,cC9gFF;ED+gFE,mBAAA;AApMhB;AAsMY;EACI,eAAA;EACA,gBAAA;EACA,cCthFE;EDuhFF,mBAAA;AApMhB;AAsMY;EACI,gBAAA;EACA,oBAAA;AApMhB;AAqMgB;EACI,eAAA;EACA,gBAAA;EACA,cC/hFF;AD41ElB;AAsMY;EACI,oBAAA;AApMhB;AAqMgB;EACI,eAAA;EACA,gBAAA;EACA,cCviFF;ADo2ElB;;AAyMA,oBAAA;AACA,sBAAA;AACA;EACI,iBAAA;AAtMJ;AA4MoB;EACI,WAAA;AA1MxB;AAkNQ;EACI,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,YAAA;EACA,yBAAA;AAhNZ;AAmNQ;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAjNZ;AAqNI;EACI,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,gBAAA;EACA,UAAA;AAnNR;AAqNQ;EACI,eAAA;EACA,cCzlFE;ED0lFF,gBAAA;EACA,mBAAA;AAnNZ;AAsNQ;EACI,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,cCpmFM;EDqmFN,eAAA;EACA,iBAAA;AApNZ;AAsNY;EACI,cCtoFA;ADk7EhB;AA2NY;EACI,mBAAA;EACA,+CAAA;EACA,8BAAA;AAzNhB;AA2NgB;EACI,2BAAA;AAzNpB;AA4NwB;EACI,0BAAA;EACA,2BAAA;EACA,8BAAA;AA1N5B;AA4N4B;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,yDAAA;EACA,YAAA;AA1NhC;AAgOgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCnpFF;ADq7ElB;AAmOQ;EACI,wCAAA;EACA,iBAAA;AAjOZ;AAmOY;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cC7rFA;ED8rFA,gBAAA;EACA,qBAAA;AAjOhB;AAmOgB;EARJ;IASQ,eAAA;EAhOlB;AACF;AAmOoB;EACI,0BAAA;AAjOxB;AAqOgB;EACI,qBAAA;AAnOpB;AAsOgB;EACI,WAAA;EACA,YAAA;EACA,mBCltFJ;EDmtFI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AApOpB;AAsOoB;EACI,cCzrFV;ADq9Ed;AAwOgB;EACI,YAAA;AAtOpB;AA2OQ;EACI,YAAA;EACA,mBAAA;AAzOZ;AA8OY;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA5OhB;AA+OY;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;AA7OhB;AAkPY;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAhPhB;AAkPgB;EACI,aAAA;AAhPpB;AAsPY;EADJ;IAEQ,8BAAA;EAnPd;AACF;AAqPY;EACI,YAAA;EACA,kCAAA;EACA,cCxxFA;EDyxFA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAnPhB;AAqPgB;EAdJ;IAeQ,eAAA;EAlPlB;AACF;AAqPY;EACI,eAAA;EACA,cC3wFF;ED4wFE,gBAAA;AAnPhB;AAqPgB;EALJ;IAMQ,eAAA;EAlPlB;AACF;AAyPgB;EACQ,4BAAA;EACA,8BAAA;AAvPxB;AA2PY;EACI,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,mBAAA;AAzPhB;AA6PgB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA3PpB;AA8PgB;EACI,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AA5PpB;AAgQY;EACI,eAAA;EACA,cCtzFF;EDuzFE,gBAAA;EACA,mBAAA;EACA,0BAAA;AA9PhB;AAgQgB;EAPJ;IAQQ,eAAA;EA7PlB;AACF;AAgQY;EACI,eAAA;EACA,cCp0FE;EDq0FF,iBAAA;AA9PhB;AAgQgB;EALJ;IAMQ,eAAA;EA7PlB;AACF;AA+PgB;EACI,cCz2FJ;ED02FI,qBAAA;EACA,gBAAA;AA7PpB;AAgQY;EACI,eAAA;EACA,cCn1FE;EDo1FF,iBAAA;AA9PhB;AAgQgB;EALJ;IAMQ,eAAA;EA7PlB;AACF;AA+PgB;EACI,cCx3FJ;EDy3FI,qBAAA;EACA,gBAAA;AA7PpB;AAiQY;EACI,mCAAA;EACA,kBAAA;EACA,kBAAA;AA/PhB;AAiQgB;EACI,eAAA;EACA,yBAAA;AA/PpB;AAiQoB;EACI,cCx4FR;EDy4FQ,eAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AA/PxB;AAkQoB;EACI,cCl3FV;ADknFd;AAsQgB;EACI,eAAA;EACA,cC53FF;ED63FE,iBAAA;EACA,kBAAA;EACA,kBAAA;AApQpB;AAsQoB;EAPJ;IAQQ,eAAA;EAnQtB;AACF;AAqQoB;EACI,cCn6FR;EDo6FQ,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAnQxB;AAsQoB;EACI,iBAAA;AApQxB;AAuQoB;EACI,oBAAA;AArQxB;AA6QQ;EACI,YAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;AA3QZ;AA+QoB;EACI,aAAA;EACA,mBCl6FV;EDm6FU,gBAAA;EACA,eAAA;EACA,cCv6FV;EDw6FU,gBAAA;EACA,mCAAA;AA7QxB;AA+QwB;EACI,yBAAA;EACA,yDAAA;AA7Q5B;AAiR4B;EACI,oBAAA;AA/QhC;AAmRwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,yCAAA;EACA,kBAAA;AAjR5B;AAmR4B;EACI,cCj+FhB;EDk+FgB,eAAA;AAjRhC;AAwRY;EACI,kBAAA;EACA,gBAAA;AAtRhB;AAwRgB;EACI,aAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,cCr9FF;EDs9FE,mBAAA;AAtRpB;AAwRoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAtRxB;AAyRoB;EACI,kBAAA;EACA,eAAA;AAvRxB;AA0RoB;EACI,kBAAA;EACA,eAAA;EACA,eAAA;AAxRxB;AA2RoB;EACI,gBAAA;AAzRxB;AA4RoB;EAEI,cC7gGR;ADkvFhB;AAkS4B;EACI,aAAA;AAhShC;AAmS4B;EACI,+BAAA;AAjShC;;AA+SI;EACI,WAAA;AA5SR;AA+SI;EACI,mBAAA;AA7SR;AAiTQ;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oCAAA;AA/SZ;AAiTY;EACI,iBAAA;EACA,gBAAA;EACA,cC7hGF;AD8uFd;AAkToB;EACI,mBAAA;AAhTxB;AAyTQ;EACI,mBCziGE;ED0iGF,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAvTZ;AAyTY;EACI,kBAAA;EACA,cCrjGE;AD8vFlB;AAyTgB;EACI,mBAAA;AAvTpB;AAgUgB;EACI,eAAA;EACA,gBAAA;EACA,cClkGN;ADowFd;AAwUwB;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAtU5B;AAwUwB;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCvlGd;EDwlGc,cAAA;EACA,YAAA;EACA,iBAAA;AAtU5B;AA2UwB;EACI,oBAAA;EACA,mBAAA;AAzU5B;AA2U4B;EACI,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cC5oGhB;ED6oGgB,qBAAA;EACA,WAAA;EACA,yBAAA;AAzUhC;AA2UgC;EACI,mBClpGpB;EDmpGoB,cClnGtB;ADyyFd;AAkVQ;EACI,WAAA;EACA,YAAA;EACA,mBC/pGI;EDgqGJ,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCnoGE;EDooGF,eAAA;EACA,WAAA;AAhVZ;AAkVY;EACI,aAAA;AAhVhB;AAoVQ;EACI,WAAA;EACA,YAAA;EACA,mBC/qGM;EDgrGN,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCppGE;EDqpGF,eAAA;EACA,WAAA;AAlVZ;AAoVY;EACI,aAAA;AAlVhB;;AA0VI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AAvVR;;AA2VA,sBAAA;AACA,mBAAA;AACA;EACI,iBAAA;EACA,oBAAA;AAxVJ;;AA2VA;EACI,mBClrGU;EDmrGV,8BAAA;EACA,4CAAA;EACA,uBAAA;AAxVJ;AA0VI;EACI,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,2CAAA;EACA,2CAAA;AAxVR;AA0VQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cCpsGE;AD42Fd;AA+VY;EACI,cC9sGE;ED+sGF,oBAAA;EACA,eAAA;EACA,8BAAA;AA7VhB;AA+VgB;EACI,0CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA7VpB;AAgWgB;EACI,gBAAA;EACA,iBAAA;AA9VpB;AAiWgB;EAlBJ;IAmBQ,eAAA;EA9VlB;AACF;AAiWY;EACI,uCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA/VhB;AAoWY;EACI,WAAA;AAlWhB;AAqWY;EACI,mBAAA;AAnWhB;;AA0WA;EACI,uBAAA;AAvWJ;;AA2WI;EACI,aAAA;AAxWR;AA2WI;EACI,eAAA;EACA,cCtwGM;EDuwGN,iBAAA;EACA,gBAAA;AAzWR;;AA6WA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;AA1WJ;AA4WI;EACI,cCpxGU;EDqxGV,eAAA;EACA,gBAAA;AA1WR;;AA+WI;EACI,wBAAA;EACA,wBAAA;EACA,gBAAA;AA5WR;AAgXgB;EAqBI,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCzzGN;ED0zGM,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAlYpB;AAqWoB;EACI,yCAAA;EACA,4BAAA;AAnWxB;AAsWoB;EACI,WAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;AApWxB;AAqWwB;EACI,yBC5yGd;ED6yGc,qBC7yGd;AD08Fd;AAsWoB;EACI,4BAAA;EACA,0CAAA;AApWxB;AAkXoB;EAhCJ;IAiCQ,eAAA;EA/WtB;AACF;AAsXgB;EAWI,oCAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCz1GF;ED01GE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AA9XpB;AA4WoB;EACI,yCAAA;EACA,4BAAA;AA1WxB;AA6WoB;EACI,4BAAA;EACA,0CAAA;AA3WxB;AAwXoB;EArBJ;IAsBQ,eAAA;EArXtB;AACF;;AA6XI;EACI,cC32GU;ED42GV,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;AA1XR;AA4XQ;EAPJ;IAQQ,eAAA;EAzXV;AACF;AA2XQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;AAzXZ;AA2XY;EAPJ;IAQQ,eAAA;EAxXd;AACF;;AA6XA,kBAAA;AACA,uBAAA;AAEA;EACI,gBAAA;EACA,gBAAA;AA3XJ;;AA8XA;EACI,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA3XJ;;AAgYQ;EACI,eAAA;EACA,gBAAA;EACA,cC15GE;AD6hGd;AA+XY;EACI,YAAA;AA7XhB;AAgYQ;EACI,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AA9XZ;AAiYY;EACI,6BAAA;AA/XhB;AAkYY;EACI,YAAA;EACA,uBAAA;EACA,kBAAA;AAhYhB;AAkYgB;EACI,mBAAA;EACA,kBAAA;AAhYpB;AAsYY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,cC/7GF;AD2jGd;AAwYQ;;EAEI,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtYZ;AAwYY;;EACI,mBAAA;AArYhB;AAwYY;;EACI,gBAAA;AArYhB;AAwYY;;EACI,YAAA;AArYhB;;AA6YA;EACI,mBAAA;EACA,mBC/9GU;EDg+GV,kBAAA;EACA,oCAAA;EACA,4CAAA;AA1YJ;AA4YI;EACI,qBAAA;EAUA,mBAAA;AAnZR;AA2YQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,4CAAA;AAzYZ;AA8YQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBCthHI;EDuhHJ,cCt/GE;EDu/GF,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AA5YZ;AAgZI;EACI,eAAA;EACA,cCrgHM;EDsgHN,gBAAA;EACA,kBAAA;AA9YR;AAiZI;EACI,gBAAA;EACA,eAAA;EACA,cC/gHU;ADgoGlB;;AAmZA,sBAAA;AACA,4BAAA;AAGQ;EACI,gBAAA;AAlZZ;AAqZI;EACI,iBAAA;EACA,gBAAA;AAnZR;AAoZQ;EACI,UAAA;AAlZZ;AAoZU;EACE,gBAAA;AAlZZ;AAoZQ;EACI,4CAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AAlZZ;AAmZY;EACI,cC5iHF;ED6iHE,eAAA;EACA,eAAA;EACA,eAAA;AAjZhB;AAwZQ;EACI,mBAAA;AAtZZ;AAyZgB;EACI,eAAA;EACA,cC5jHN;ED6jHM,iBAAA;AAvZpB;AA0ZgB;EACI,WAAA;EACA,YAAA;EACA,yBClmHJ;EDmmHI,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yDAAA;AAxZpB;;AA+ZA,2BAAA;AACA,yBAAA;AACA;EACI,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBCvlHU;EDwlHV,4CAAA;EACA,YAAA;EACA,iBAAA;AA5ZJ;AA8ZI;EACI,eAAA;EACA,cChmHM;EDimHN,gBAAA;AA5ZR;AAgaQ;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBCzmHE;ED0mHF,cCxmHE;EDymHF,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA9ZZ;AAmaI;EACI,eAAA;EACA,cCvnHU;EDwnHV,iBAAA;AAjaR;AAoaI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAlaR;AAoaQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cCloHE;EDmoHF,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAlaZ;AAoaY;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AAlahB;AAqaY;EACI,mBChpHF;EDipHE,cC/oHF;AD4uGd;AAyaQ;EACI,eAAA;EACA,qBAAA;EACA,mBAAA;AAvaZ;AAyaY;EALJ;IAMQ,iBAAA;EAtad;AACF;AAyaQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAvaZ;AAyaY;EACI,cCzqHE;ED0qHF,eAAA;AAvahB;AAyagB;EACI,cAAA;EACA,gBAAA;EACA,cC7qHN;ADswGd;;AA6aA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA1aJ;AA2aI;EACI,aAAA;AAzaR;;AA4aA;EACI,sBAAA;AAzaJ;;AA2aA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACJ,SAAA;AAxaA;AA2aY;EAEI,yBAAA;AA1ahB;AAkbI;EACI,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBCrtHM;EDstHN,4CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAhbR;AAibQ;EACI,eAAA;EACA,cCluHM;EDmuHN,iBAAA;EACA,kBAAA;AA/aZ;AAibQ;EACI,cCvuHM;EDwuHN,eAAA;AA/aZ;;AAmbA;EACI,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBC5uHU;ED6uHV,4CAAA;EACA,YAAA;AAhbJ;AAmbI;EACI,eAAA;EACA,cCrvHM;EDsvHN,gBAAA;AAjbR;AAqbQ;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,mBC9vHE;ED+vHF,cC7vHE;ED8vHF,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAnbZ;AAwbI;EACI,eAAA;EACA,cC5wHU;ED6wHV,iBAAA;AAtbR;AAybI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAvbR;AAybQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cCvxHE;EDwxHF,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAvbZ;AAybY;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AAvbhB;AA0bY;EACI,mBCryHF;EDsyHE,cCpyHF;AD42Gd;AA8bQ;EACI,eAAA;EACA,qBAAA;EACA,mBAAA;AA5bZ;AA8bY;EALJ;IAMQ,iBAAA;EA3bd;AACF;AA8bQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA5bZ;AA8bY;EACI,cC9zHE;ED+zHF,eAAA;AA5bhB;AA8bgB;EACI,cAAA;EACA,gBAAA;EACA,cCl0HN;ADs4Gd;;AAmcA,wBAAA;AACA,mBAAA;AACA;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,cC/0HU;AD+4Gd;AAkcI;EANJ;IAOQ,eAAA;EA/bN;AACF;;AAkcA;EACI,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,oBAAA;EACA,mBAAA;AA/bJ;AAicI;EACI,YAAA;EACA,aAAA;EACA,mBC91HM;ED+1HN,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA/bR;AAicQ;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;AA/bZ;AAmcI;EACI,YAAA;AAjcR;AAmcQ;EACI,eAAA;EACA,iBAAA;EACA,cCr3HE;EDs3HF,iBAAA;AAjcZ;AAocQ;EACI,eAAA;EACA,cC33HE;ADy7Gd;AAqcQ;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;AAncZ;AAqcY;EACI,cCp4HF;ADi8Gd;;AAycA,kBAAA;AACA,0BAAA;AACA;EACI,2CAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AAtcJ;AAwcI;EACI,oDAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,4CAAA;AAtcR;AAycI;EACI,eAAA;EACA,kBAAA;EACA,0BAAA;AAvcR;AA0cI;EACI,gBAAA;AAxcR;AA0cQ;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAxcZ;AA0cY;EANJ;IAOQ,eAAA;EAvcd;AACF;AA0cQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;AAxcZ;AA0cY;EACI,eAAA;EACA,cCx7HF;ADg/Gd;AA0cgB;EAJJ;IAKQ,eAAA;EAvclB;AACF;AA0cY;EACI,mBCh8HF;ADw/Gd;AA0cgB;EACI,cCj8HN;ADy/Gd;AA+cQ;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBC78HE;ED88HF,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7cZ;AA8cY;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AA5chB;AA8cY;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA5chB;AAkdY;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;EACA,sBAAA;AAhdhB;AAmdY;EACI,eAAA;EACA,yBAAA;EACA,mBAAA;AAjdhB;AAmdgB;EALJ;IAMQ,eAAA;EAhdlB;AACF;AAkdgB;EACI,eAAA;EACA,cCtgIN;ADsjHd;AAkdoB;EAJJ;IAKQ,eAAA;EA/ctB;AACF;AAkdgB;EACI,cC7iIJ;ED8iII,eAAA;AAhdpB;AAkdoB;EAJJ;IAKQ,eAAA;EA/ctB;AACF;AAodQ;EACI,YAAA;AAldZ;AAmdY;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;AAjdhB;AAkdgB;EACI,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAhdpB;AAkdgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AAhdpB;AAqdoB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;AAndxB;AAudY;EACI,eAAA;EACA,cCpkIF;EDqkIE,iBAAA;AArdhB;AAudgB;EALJ;IAMQ,eAAA;EApdlB;AACF;AAydoB;EADJ;IAEQ,eAAA;EAtdtB;AACF;AA0dY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAxdhB;AA0dgB;EALJ;IAMQ,eAAA;EAvdlB;AACF;AAydgB;EACI,yBAAA;AAvdpB;AA0dgB;EACI,oBAAA;EACA,mBAAA;EACA,eAAA;AAxdpB;AA0doB;EACI,yBAAA;EACA,iBAAA;AAxdxB;AA6dY;EACI,QAAA;EACA,eAAA;AA3dhB;AA+dgB;EADJ;IAEQ,mBAAA;EA5dlB;AACF;AA8dgB;EACI,eAAA;EACA,yBAAA;AA5dpB;AA+dgB;EACI,eAAA;EACA,cC9nIN;ADiqHd;AA+doB;EAJJ;IAKQ,eAAA;EA5dtB;AACF;AA+dgB;EACI,eAAA;AA7dpB;AA+doB;EACI,iBAAA;EACA,wBAAA;AA7dxB;AA+dwB;EACI,yBC5qIZ;ED6qIY,qBC7qIZ;ADgtHhB;AAieoB;EACI,eAAA;EACA,yBAAA;EACA,gBAAA;AA/dxB;AAiewB;EALJ;IAMQ,eAAA;EA9d1B;AACF;;AAseA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBCrqIU;EDsqIV,cCpqIU;EDqqIV,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAneJ;AAqeI;EACI,uBAAA;EACA,cCjrIM;AD8sHd;;AAweA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cC9rIU;ED+rIV,eAAA;EACA,gBAAA;EACA,qBAAA;AAreJ;AAueI;EACI,mBCpsIM;EDqsIN,cCnsIM;AD8tHd;;AAweA;EACI,eAAA;EACA,WAAA;EACA,eAAA;AAreJ;;AAueA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AApeJ;AAseI;EACI,eAAA;EACA,cCxtIM;ADovHd;AAseQ;EAJJ;IAKQ,eAAA;EAneV;AACF;AAseI;EACI,mBChuIM;AD4vHd;AAseQ;EACI,cCjuIE;AD6vHd;;AA0eI;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAveR;AAyeQ;EACI,cChxII;EDixIJ,iBAAA;AAveZ;AA2eI;EACI,mBAAA;EACA,mBCtvIM;EDuvIN,4CAAA;EACA,aAAA;AAzeR;AA6eY;EACI,gBAAA;EACA,eAAA;EACA,cCjwIF;ADsxHd;AA+eQ;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA7eZ;AA+eY;EACI,cC5wIF;AD+xHd;AAifQ;EACI,mBAAA;AA/eZ;AAifY;EACI,eAAA;EACA,cCrxIF;EDsxIE,iBAAA;AA/ehB;AAifgB;EALJ;IAMQ,eAAA;EA9elB;AACF;AAkfQ;EACI,eAAA;EACA,cClyIM;EDmyIN,gBAAA;AAhfZ;AAkfY;EALJ;IAMQ,eAAA;EA/ed;AACF;AAifY;EACI,gBAAA;AA/ehB;AAmfQ;EACI,eAAA;EACA,cChzIM;EDizIN,gBAAA;AAjfZ;AAmfY;EALJ;IAMQ,eAAA;EAhfd;AACF;AAmfQ;EACI,yCAAA;EACA,UAAA;AAjfZ;AAofQ;EACI,eAAA;EACA,cC51II;ED61IJ,gBAAA;AAlfZ;AAofY;EALJ;IAMQ,eAAA;EAjfd;AACF;AAsfgB;EACI,eAAA;EACA,kBAAA;AApfpB;AAufgB;;EAEI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AArfpB;AA4fQ;EACI,eAAA;EACA,yBAAA;AA1fZ;AA6fQ;EACI,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA3fZ;AA6fY;EACI,gBAAA;EACA,cCx2IF;EDy2IE,eAAA;AA3fhB;AA8fY;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;AA5fhB;AA8fgB;EACI,gBAAA;EACA,cCn3IN;ADu3Hd;AAigBQ;EACI,eAAA;AA/fZ;AAigBY;EACI,iBAAA;AA/fhB;AAigBgB;EACI,yBC95IJ;ED+5II,qBC/5IJ;ADg6HhB;AAmgBY;EACI,eAAA;EACA,cCt4IF;ADq4Hd;AAmgBgB;EACI,iBAAA;EACA,cCz6IJ;ADw6HhB;AAugBI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;AArgBR;AAwgBY;EACI,SAAA;EACA,aAAA;AAtgBhB;AAygBoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,mBCv6IV;EDw6IU,kBAAA;EACA,cC36IV;ED46IU,YAAA;AAvgBxB;AAygBwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,mCAAA;EACA,cCn9IZ;EDo9IY,oBAAA;EACA,mBAAA;EACA,uBAAA;EAMA,mBAAA;AA5gB5B;AAwgB4B;EACI,eAAA;AAtgBhC;AA4gBwB;EACI,yBAAA;EACA,mBCj+IZ;EDk+IY,cCj8Id;ADu7Hd;AA4gB4B;EACI,2CAAA;EACA,qCAAA;EACA,cCt8IlB;AD47Hd;;AAqhBI;EACI,gBAAA;AAlhBR;AAshBgB;EACI,YAAA;AAphBpB;AAshBoB;EAHJ;IAIQ,cAAA;EAnhBtB;AACF;AAqhBoB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBCj+IV;EDk+IU,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,oCAAA;AAnhBxB;AAqhBwB;EAEI,mBAAA;EACA,aAAA;AAphB5B;AAyhBoB;EACI,kBAAA;EACA,eAAA;EACA,cCt/IV;EDu/IU,gBAAA;EACA,mBAAA;EACA,qBAAA;AAvhBxB;AA0hBoB;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;AAxhBxB;AA0hBwB;EACI,cCpgJd;AD4+Hd;AA8hBoB;EACI,+BAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA5hBxB;AA8hBwB;EACI,eAAA;AA5hB5B;AA+hBwB;EACI,eAAA;EACA,gBAAA;EACA,cCxhJd;AD2/Hd;AAgiBwB;EAQI,eAAA;EACA,UAAA;EACA,oBAAA;AAriB5B;AA4hB4B;EACI,cC5jJhB;ED6jJgB,gBAAA;EACA,gCAAA;EACA,mBAAA;AA1hBhC;AAmiBoB;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAjiBxB;AAmiBwB;EACI,eAAA;EACA,gBAAA;EACA,cCjjJd;ADghId;AAmiB4B;EALJ;IAMQ,eAAA;EAhiB9B;AACF;AAmiBwB;EACI,gBAAA;AAjiB5B;AAmiB4B;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAjiBhC;AAoiB4B;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;AAliBhC;AAoiBgC;EACI,mBC9kJtB;AD4iId;AAoiBoC;EACI,cC/kJ1B;AD6iId;AAyiBoB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAviBxB;AAyiBwB;EACI,WAAA;EACA,YAAA;EACA,yBC/nJZ;EDgoJY,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yDAAA;AAviB5B;AA0iBwB;EACI,YAAA;EACA,4BAAA;EACA,eAAA;AAxiB5B;AA2iBwB;EACI,eAAA;EACA,cCpnJd;EDqnJc,iBAAA;AAziB5B;AA2iB4B;EALJ;IAMQ,eAAA;EAxiB9B;AACF;;AAijBA,yBAAA;AACA;EACI;IACI,uBAAA;EA9iBN;EAijBE;IACI,oCAAA;EA/iBN;AACF;AAijBA;EACI,eAAA;EACA,cAAA;EACA,iBAAA;AA/iBJ;;AAijBA;EACI,kBAAA;AA9iBJ;;AAgjBE;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;AA7iBJ;;AA+iBA;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;AA5iBJ;;AA8iBA;EACI,aAAA;AA3iBJ;;AA6iBA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AA1iBJ;;AA4iBE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;AAziBJ;;AA2iBC;;EAEG,WAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AAxiBJ;;AA0iBE;EACE,gBAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAviBJ;;AAyiBE;EACE,gBAAA;EACA,wBAAA;AAtiBJ;;AAwiBE;EACE,mBAAA;AAriBJ;;AAuiBE;EACE,qCAAA;AApiBJ;;AAsiBE;EACE,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,WAAA;AAniBJ;;AAqiBC;EACG,aAAA;EACA,kBAAA;EACA,yBCvvJY;EDyvJZ,WAAA;EACA,iBAAA;AAniBJ;;AAqiBC;EACG,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,+BAAA;EACA,+CAAA;AAliBJ;;AAoiBE;EACE,cAAA;AAjiBJ;;AAmiBE;EACE,UAAA;AAhiBJ;;AAmiBE;EACE,kBAAA,EAAA,wBAAA;AAhiBJ;;AAmiBE;EACE,eAAA,EAAA,oCAAA;EACA,WAAA;AAhiBJ;;AAmiBE;EACE,WAAA;AAhiBJ;;AAkiBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AA/hBJ;;AAiiBA;EACI,aAAA;EACA,uBAAA;EACA,yBCpwJU;EDqwJV,YAAA;AA9hBJ;;AAiiBA;EACI,gBAAA;AA9hBJ;;AAgiBA;EACI,kBAAA;AA7hBJ;;AA+hBA;EACI,WAAA;EACA,YAAA;AA5hBJ;;AA8hBA;EACI,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA3hBJ;;AA6hBA;EACI,eAAA;AA1hBJ;;AA6hBA;EACI,kBAAA;AA1hBJ;;AA4hBA;EACI,eAAA;EACA,yBAAA;EACA,mBAAA;AAzhBJ;;AA4hBA;EACI,eAAA;EACA,cCzyJU;ED0yJV,mBAAA;EACA,gBAAA;AAzhBJ;;AA2hBA;EACI,gBAAA;AAxhBJ;;AA4hBQ;EACI,aAAA;AAzhBZ;AA2hBgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCzzJN;ADgyId;AA2hBgB;EACI,iBAAA;AAzhBpB;AA0hBoB;EACI,eAAA;AAxhBxB;AA0hBoB;EACI,eAAA;EACA,mBAAA;AAxhBxB;AA6hBwB;EACI,eAAA;AA3hB5B;AA8hBoB;EACI,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA5hBxB;AAgiBoB;EACI,aAAA;AA9hBxB;AAgiBoB;EACI,wBAAA;AA9hBxB;AAiiBwB;EACI,eAAA;AA/hB5B;AAkiB4B;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,cCz2JlB;ED02JkB,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAhiBhC;AAiiBgC;EACI,mBC/2JtB;EDg3JsB,yBAAA;EACA,cC/2JtB;ADg1Id;AAkiB4B;EACI,oBAAA;EACA,mBAAA;AAhiBhC;AAiiBgC;EACI,oBAAA;EACA,mBAAA;EACA,SAAA;AA/hBpC;AAgiBoC;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AA9hBxC;AAgiBoC;EACI,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AA9hBxC;AA+hBwC;EACI,2BAAA;EACA,cCr5J9B;ADw3Id;AAgiBoC;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AA9hBxC;AA+hBwC;EACI,4BAAA;EACA,cCx6J9B;AD24Id;AAuiBwB;EACI,+BAAA;EACA,mBAAA;AAriB5B;AAuiBwB;EACI,kBAAA;AAriB5B;AAyiBwB;EACI,WAAA;EACA,SAAA;AAviB5B;AAyiBgC;EACI,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AAviBpC;AAwiBoC;EACI,mBCz+JxB;ED0+JwB,cCz8J1B;ADm6Id;AA4iB4B;EACI,aAAA;EACA,mBAAA;AA1iBhC;AA4iBgC;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AA1iBpC;AA4iBgC;EACI,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA1iBpC;AA6iB4B;EACI,aAAA;EACA,mBAAA;AA3iBhC;AA6iBgC;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AA3iBpC;AAijBgB;EACI,+BAAA;EACA,aAAA;EACA,mBAAA;AA/iBpB;AAgjBoB;EACI,eAAA;AA9iBxB;AAgjBoB;EACI,eAAA;EACA,gBAAA;AA9iBxB;AAijBgB;EACI,kBAAA;EACA,gBAAA;AA/iBpB;AAgjBoB;EACI,gBAAA;AA9iBxB;;AA0jBoB;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,WAAA;AAvjBxB;AA0jBoB;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAxjBxB;AA0jBoB;EACI,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAxjBxB;AAyjBwB;EACI,iCAAA;EACA,iCAAA;EACA,cC9iKd;ADu/Id;AA0jBoB;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAxjBxB;AAyjBwB;EACI,yBAAA;EACA,yBC3lKb;ED4lKa,cClkKd;AD2gJd;;AA+jBA;EACI,mBC3kKU;ED4kKV,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AA5jBJ;AA6jBI;EACI,mBAAA;AA3jBR;AA4jBQ;EACI,eAAA;EACA,gBAAA;EACA,cCvlKE;EDwlKF,mBAAA;AA1jBZ;AA4jBQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA1jBZ;AA6jBI;EACI,mBAAA;AA3jBR;AA4jBQ;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AA1jBZ;AA2jBY;EACI,cCzmKF;ED0mKE,gBAAA;EACA,qBAAA;AAzjBhB;AA0jBgB;EACI,gBAAA;AAxjBpB;AA2jBY;EACI,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAzjBhB;AA4jBQ;EACI,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA1jBZ;AA6jBI;EACI,8BAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AA3jBR;AA4jBQ;EACI,aAAA;EACA,yBAAA;AA1jBZ;AA8jBQ;EACI,8BAAA;EACA,yBAAA;AA5jBZ;;AAgkBA;EACI,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,8BAAA;AA7jBJ;AA+jBQ;EACI,mBAAA;EACA,mBCjqKE;EDkqKF,cCpqKE;EDqqKF,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AA7jBZ;AA8jBY;EACI,mBC3sKA;ED4sKA,cC3qKF;AD+mJd;;AAikBA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,SAAA;AA9jBJ;AA+jBI;EACI,YAAA;AA7jBR;AA8jBQ;EACI,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA5jBZ;AA8jBQ;EACI,aAAA;AA5jBZ;AA+jBoB;EACI,mBAAA;AA7jBxB;;AAukBI;EACI,sBAAA;EACA,WAAA;EACA,oBAAA;AApkBR;AAukBI;EACI,kBAAA;EACA,eAAA;AArkBR;AAwkBI;EACI,kBAAA;EACA,aAAA;AAtkBR;;AA0kBA;EACI,6BAAA;AAvkBJ;;AA0kBA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,QAAA;AAvkBJ;;AA0kBA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;AAvkBJ;;AA0kBA;EACI,qBAAA;EACA,oBAAA;EACA,0BAAA;EACA,yBAAA;AAvkBJ;AAykBI;EACI,0BAAA;EACA,2BAAA;AAvkBR;AA0kBI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AAxkBR;AA2kBI;EACI,aAAA;AAzkBR;;AA+kBI;EACI,qCAAA;EACA,cCtyKM;EDuyKN,0CAAA;AA5kBR;AA8kBQ;EACI,qCAAA;AA5kBZ;AAglBI;EACI,mBChzKK;EDizKL,cCjyKM;EDkyKN,qBClzKK;ADouJb;;AAolBI;EACI,mCAAA;EACA,cCvzKO;EDwzKP,wCAAA;AAjlBR;AAmlBQ;EACI,mCAAA;AAjlBZ;AAqlBI;EACI,mBCj0KM;EDk0KN,cCpzKM;EDqzKN,qBCn0KM;ADgvJd;;AAylBI;EACI,oCAAA;EACA,cCn1KM;EDo1KN,yCAAA;AAtlBR;AAwlBQ;EACI,oCAAA;AAtlBZ;AA0lBI;EACI,mBC91KO;ED+1KP,cCv0KM;EDw0KN,qBCh2KO;ADwwJf;;AA8lBI;EACI,mCAAA;EACA,cC31KK;ED41KL,wCAAA;AA3lBR;AA6lBQ;EACI,mCAAA;AA3lBZ;AA+lBI;EACI,mBCr2KI;EDs2KJ,cC11KM;ED21KN,qBCv2KI;AD0wJZ;;AAmmBI;EACI,oCAAA;EACA,cC52KS;ED62KT,yCAAA;AAhmBR;AAkmBQ;EACI,oCAAA;AAhmBZ;AAomBI;EACI,mBCt3KQ;EDu3KR,cC72KM;ED82KN,qBCx3KQ;ADsxJhB;;AAumBA;EACI,aAAA;EACA,+BAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;AApmBJ;;AAwmBA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AArmBJ;;AAymBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtmBJ;;AA0mBA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;AAvmBJ;;AA0mBA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,gBAAA;AAvmBJ;;AA0mBA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAvmBJ;;AA0mBA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAvmBJ;;AA0mBA;EACI,mCAAA;EACA,oCAAA;AAvmBJ;;AA0mBA;EACI,oCAAA;EACA,qCAAA;AAvmBJ;;AA0mBA;EACI,mCAAA;EACA,oCAAA;AAvmBJ;;AA0mBA;EACI,oCAAA;EACA,qCAAA;AAvmBJ;;AA0mBA;EACI,eAAA;EACA,gBAAA;EACA,cCp8KS;EDq8KT,yBAAA;EACA,qBAAA;AAvmBJ;;AA2mBA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;AAxmBJ;;AAknBA;;;EAGI,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;AA/mBJ;AAinBI;;;EACI,kCAAA;EACA,uBAAA;EACA,qBAAA;EACA,0BAAA;EACA,cAAA;AA7mBR;AAinBI;;;EACI,gDAAA;EACA,yBAAA;EACA,qDAAA;AA7mBR;AA+mBQ;;;EACI,gDAAA;AA3mBZ;AA8mBQ;;;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AA1mBZ;AA8mBI;;;EACI,8CAAA;EACA,yBAAA;EACA,mDAAA;AA1mBR;AA4mBQ;;;EACI,8CAAA;AAxmBZ;AA2mBQ;;;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AAvmBZ;AA2mBI;;;EACI,+CAAA;EACA,yBAAA;EACA,oDAAA;AAvmBR;AAymBQ;;;EACI,+CAAA;AArmBZ;AAwmBQ;;;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AApmBZ;AAwmBI;;;EACI,8CAAA;EACA,yBAAA;EACA,mDAAA;AApmBR;AAsmBQ;;;EACI,8CAAA;AAlmBZ;AAqmBQ;;;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AAjmBZ;AAqmBI;;;EACI,+CAAA;EACA,yBAAA;EACA,oDAAA;AAjmBR;AAmmBQ;;;EACI,+CAAA;AA/lBZ;AAkmBQ;;;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AA9lBZ;;AAomBA;EACI,kBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAjmBJ;AAmmBI;EACI,wBAAA;EACA,2BAAA;AAjmBR;AAomBI;EACI,wBAAA;EACA,wCAAA;AAlmBR;;AAumBA;EACI,2BAAA;AApmBJ;;AAwmBA;EACI,kBAAA;AArmBJ;;AAwmBA;EACI,cChnLU;EDinLV,mBAAA;EACA,gBAAA;EACA,eAAA;AArmBJ;AAsmBA;EACI,aAAA;AApmBJ;;AA0mBQ;EACI,cC5nLE;ADqhKd;;AA2mBA;EACI,eAAA;EACA,cCpoLc;EDqoLd,cAAA;EACA,gBAAA;AAxmBJ;;AAymBC;EACG,SAAA;EACA,WAAA;AAtmBJ;;AAwmBA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;AArmBJ;AAsmBI;EACI,aAAA;EACA,qBAAA;AApmBR;AAumBI;EACI,eAAA;EACA,cCrpLM;EDspLN,gBAAA;AArmBR;AAumBI;EACI,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;AArmBR;AAsmBQ;EACI,cAAA;EACA,eAAA;AApmBZ;AAumBI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,UAAA;AArmBR;;AAwmBA;EACI,aAAA;AArmBJ;;AAumBA;EACI,aAAA;AApmBJ;;AAsmBA;EACI,aAAA;AAnmBJ;;AAqmBA;EACI,yBAAA;AAlmBJ;;AAomBA;EACI,yBAAA;AAjmBJ;;AAmmBA;EACI,yBAAA;AAhmBJ;;AAkmBA;EACI,+BAAA;EACA,aAAA;EACA,mBAAA;AA/lBJ;AAgmBI;EACI,oBAAA;AA9lBR;AA+lBQ;EACI,mBAAA;AA7lBZ;AA+lBQ;EACI,eAAA;EACA,cAAA;AA7lBZ;AAgmBY;EACI,gBAAA;AA9lBhB;;AAomBA;EACI,eAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAjmBJ;;AAmmBA;EACI,+CAAA;EACA,4BAAA;EACA,cCnuLU;EDouLV,8BAAA;AAhmBJ;AAimBI;EACI,8BAAA;EACA,yBAAA;AA/lBR;;AAkmBA;EACI,qBAAA;EACI,uBAAA;EACA,4BAAA;AA/lBR;AAgmBQ;EACQ,uBAAA;AA9lBhB;AAgmBM;EACF,4BAAA;EACA,uBAAA;AA9lBJ;;AAmmBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;AAhmBF;AAkmBE;EACE,eAAA;EACA,cAAA;AAhmBJ;AAmmBE;EACE,mBAAA;AAjmBJ;AAomBE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAlmBJ;;AAumBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AApmBF;AAsmBE;EACE,gBAAA;AApmBJ;AAsmBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AApmBN;AAumBI;EACE,eAAA;EACA,kBAAA;AArmBN;AA0mBE;EACE,gBAAA;AAxmBJ;AA0mBI;EACE,eAAA;EACA,yBAAA;EACA,eAAA;AAxmBN;AA2mBI;EACE,wBAAA;EACA,eAAA;AAzmBN;AA6mBE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA3mBJ;AA6mBI;EACE,mBAAA;EACA,aAAA;AA3mBN;AA+mBE;EAnDF;IAoDI,kBAAA;EA5mBF;EA8mBE;IACE,YAAA;EA5mBJ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');\r\n@import \"../../styles/variables\";\r\n\r\n* {\r\n    margin : 0;\r\n    padding: 0;\r\n}\r\n\r\nhtml,\r\nbody,\r\n* {\r\n    font-family: $font-family;\r\n}\r\n.error-text,.error-feedback {\r\n    color: red;\r\n    font-size: 14px;\r\n  }\r\n  .profile_user_main .user_info img {\r\n    -o-object-fit: scale-down;\r\n       object-fit: scale-down;\r\n  }\r\nhtml,\r\nbody {\r\n    background-color: $white-color !important;\r\n}\r\n.img_data_collapse{\r\n    height: 440px;\r\n    width: 440px;\r\n}\r\n.mission_img_width {\r\n    height: 509px !important;\r\n    @media only screen and (max-width:1199.98px) {\r\n        height: 409px !important;\r\n    }\r\n}\r\nbody {\r\n    overflow-x: hidden;\r\n}\r\n\r\nhtml {\r\n    @media only screen and (max-width:991.98px) {\r\n        overflow-x: hidden;\r\n    }\r\n}\r\n\r\n.btn-outline-primary {\r\n    background   : $white-color !important;\r\n    border       : 1px solid $primary-color !important;\r\n    color        : $primary-color !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $primary-color !important;\r\n    }\r\n}\r\n\r\n.btn-primary {\r\n    background   : $primary-color !important;\r\n    border-color : $primary-color !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    color        : $white-color !important;\r\n&.btn-sm{\r\n    height: 40px;\r\n    font-size    : 14px !important;\r\n}\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n\r\n        svg {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $white-color !important;\r\n    }\r\n}\r\n\r\n.btn-lt-primary {\r\n    background   : rgba($primary-color, .13) !important;\r\n    border-color : rgba($primary-color, .13) !important;\r\n    height       : 50px;\r\n    font-size    : 16px !important;\r\n    font-weight  : 500 !important;\r\n    border-radius: 50px !important;\r\n    padding-left : 20px !important;\r\n    padding-right: 20px !important;\r\n    color        : $primary-color !important;\r\n    &.btn-sm{\r\n        height: 40px;\r\n        font-size    : 14px !important;\r\n    }\r\n    svg {\r\n        font-size   : 20px;\r\n        margin-right: 10px;\r\n    }\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        font-size: 14px !important;\r\n\r\n        svg {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        opacity: 0.75;\r\n        color  : $primary-color !important;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width:1220px) and (max-width:1440px) {\r\n\r\n    .container,\r\n    .container-lg,\r\n    .container-md,\r\n    .container-sm {\r\n        max-width: 1220px !important;\r\n    }\r\n}\r\n.account_show_tax .form-check-input[type=checkbox] {\r\n           \r\n    border: 2px solid #ccc;\r\n}\r\n.custom_expansion {\r\n    position: relative;\r\n}\r\n.expansion_tag {\r\n    width: 20px;\r\n    height: 20px;\r\n    background: #f31e3d;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    color: #fff;\r\n    position: absolute;\r\n    right: -7px;\r\n    top: -7px;\r\n}\r\n.expansion_tag_manage {\r\n    width: 20px;\r\n    height: 20px;\r\n    background: #f31e3d;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    color: #fff;\r\n  }\r\n/*Header Css Start*/\r\n.header {\r\n    z-index: 1030!important; \r\n    .navbar {\r\n        box-shadow    : 0px 0px 10px rgba($black-color, 0.08);\r\n        background    : $white-color;\r\n        padding-top   : 7px;\r\n        padding-bottom: 7px;\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            padding-top   : 4px;\r\n            padding-bottom: 4px;\r\n        }\r\n\r\n        .navbar-brand {\r\n            img {\r\n                height: 72px;\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    height: 55px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-collapse {\r\n            @media only screen and (max-width:991.98px) {\r\n                padding-bottom: 20px !important;\r\n            }\r\n\r\n            .navbar-nav {\r\n                .nav-link {\r\n                    padding-left : 15px;\r\n                    padding-right: 15px;\r\n                    color        : $paragraph-color;\r\n                    font-size    : 16px;\r\n                    font-weight  : 500;\r\n\r\n                    @media only screen and (max-width:991.98px) {\r\n                        padding: 10px 0px !important;\r\n                    }\r\n\r\n                    &:hover,\r\n                    &.active {\r\n                        color: $primary-color\r\n                    }\r\n                }\r\n            }\r\n\r\n            .dropdown {\r\n                .dropdown-toggle {\r\n\r\n                    &::after {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                .dropdown-menu {\r\n                    border       : none;\r\n                    box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n                    border-radius: 12px;\r\n                    padding      : 10px 0px;\r\n\r\n                    a {\r\n                        &.dropdown-item {\r\n                            color     : $paragraph-color;\r\n                            padding   : 5px 15px;\r\n                            background: transparent;\r\n\r\n                            &:hover,\r\n                            &.active {\r\n                                color: $primary-color;\r\n\r\n                                img {\r\n                                    filter : brightness(1) invert(0);\r\n                                    opacity: 1;\r\n                                }\r\n                            }\r\n\r\n                            svg {\r\n                                font-size   : 20px;\r\n                                min-width   : 20px;\r\n                                margin-right: 5px;\r\n                            }\r\n\r\n                            img {\r\n                                margin-right: 5px;\r\n                                min-width   : 16px;\r\n                                filter      : brightness(0) invert(0);\r\n                                opacity     : 0.5;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-switch {\r\n        position: relative;\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            margin: 10px 0px !important;\r\n        }\r\n\r\n        .form-check-input {\r\n            width              : 49px;\r\n            height             : 25px;\r\n            border             : 1px solid $black-color;\r\n            --bs-form-check-bg : #000;\r\n            --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n\r\n            &:checked {\r\n                background-color: $black-color;\r\n            }\r\n\r\n            &:focus {\r\n                --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n                border             : none;\r\n                outline            : 0;\r\n                box-shadow         : none;\r\n            }\r\n        }\r\n\r\n        svg {\r\n            position : absolute;\r\n            top      : 8px;\r\n            font-size: 18px;\r\n            color    : $white-color;\r\n\r\n            &.light-icon {\r\n                right: 5px;\r\n            }\r\n\r\n            &.dark-icon {\r\n                left: 5px;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .right-menu {\r\n        .nav-link {\r\n            &.header-search {\r\n                position: relative;\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    max-width: 250px;\r\n                }\r\n\r\n                .form-control {\r\n                    font-size    : 14px;\r\n                    width        : 250px;\r\n                    max-width    : 0;\r\n                    padding      : 5px;\r\n                    transition   : all 0.5s ease;\r\n                    position     : absolute;\r\n                    right        : 0px;\r\n                    box-sizing   : border-box;\r\n                    opacity      : 0;\r\n                    outline      : none;\r\n                    top          : 0;\r\n                    border       : 1px solid rgba(0, 0, 0, 0.15);\r\n                    border-radius: 12px;\r\n                    height       : 40px;\r\n                    color        : rgba($black-color, 0.70);\r\n                    font-size    : 14px;\r\n                    padding-left : 12px;\r\n                    padding-right: 34px;\r\n\r\n                    @media only screen and (max-width:991.98px) {\r\n                        left         : 0;\r\n                        right        : initial;\r\n                        padding-right: 34px;\r\n                    }\r\n                }\r\n\r\n                &.search-expanded {\r\n                    justify-content: flex-end;\r\n                    display        : flex;\r\n\r\n                    @media only screen and (max-width:991.98px) {\r\n                        padding-right: 10px !important;\r\n\r\n                    }\r\n\r\n                    .form-control {\r\n                        max-width: 250px;\r\n                        opacity  : 1;\r\n                    }\r\n                }\r\n            }\r\n\r\n            svg {\r\n                font-size: 24px;\r\n                opacity  : 0.75;\r\n                position : relative;\r\n                z-index  : 1;\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            border-left: 1px solid rgba($black-color, 0.1);\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                border: none\r\n            }\r\n\r\n            .nav-link {\r\n                padding-top   : 0;\r\n                padding-bottom: 0;\r\n\r\n                svg {\r\n                    font-size  : 20px;\r\n                    margin-left: 10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .btn-get-quote {\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            min-width      : 180px;\r\n            color          : $white-color;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                max-width : 180px;\r\n            }\r\n\r\n            svg {\r\n                font-size   : 24px;\r\n                margin-right: 5px;\r\n                opacity     : 1;\r\n            }\r\n        }\r\n\r\n        .btn-login {\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            gap            : 10px;\r\n            padding        : 0.7rem 1.75rem;\r\n            border-radius  : 999px;\r\n            font-weight    : 600;\r\n            font-size      : 0.95rem;\r\n            border         : 1px solid rgba(255, 255, 255, 0.35);\r\n            background     : #3e6ba3;\r\n            color: $white-color !important;\r\n            box-shadow     : 0 6px 18px rgba(12, 31, 58, 0.12);\r\n            transition     : all 0.2s ease;\r\n            margin-right   : 1rem;\r\n\r\n            svg {\r\n                font-size: 20px;\r\n                opacity  : 0.85;\r\n            }\r\n\r\n            span {\r\n                line-height    : 1;\r\n                letter-spacing : 0.4px;\r\n                text-transform : uppercase;\r\n            }\r\n\r\n            &:hover,\r\n            &:focus {\r\n                border-color   : rgba(0, 201, 255, 0.6);\r\n                background     : rgba(0, 201, 255, 0.18);\r\n                color          : $white-color;\r\n                box-shadow     : 0 10px 22px rgba(0, 201, 255, 0.26);\r\n                text-decoration: none;\r\n            }\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                margin-top  : 0.5rem;\r\n                margin-bottom  : 0.5rem;\r\n                padding       : 0.5rem 1.2rem;\r\n                font-size     : 0.85rem;\r\n                max-width     : 150px;\r\n                width         : 100%;\r\n                justify-content: center;\r\n                \r\n                svg {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .btn-account {\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            gap            : 10px;\r\n            padding        : 0.7rem 1.55rem;\r\n            border-radius  : 999px;\r\n            font-weight    : 600;\r\n            font-size      : 0.95rem;\r\n            background     : rgba(255, 255, 255, 0.9);\r\n            color          : #10203b;\r\n            border         : 1px solid rgba(16, 32, 59, 0.15);\r\n            box-shadow     : 0 6px 18px rgba(12, 31, 58, 0.12);\r\n            transition     : all 0.2s ease;\r\n\r\n            svg {\r\n                font-size: 20px;\r\n                opacity  : 0.85;\r\n            }\r\n\r\n            &:hover,\r\n            &:focus {\r\n                color          : $white-color;\r\n                border-color   : rgba(0, 201, 255, 0.6);\r\n                background     : rgba(0, 201, 255, 0.25);\r\n                box-shadow     : 0 10px 22px rgba(0, 201, 255, 0.26);\r\n                text-decoration: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Header Css Ends*/\r\n/*Footer Css Start*/\r\nfooter {\r\n    .copyright-area {\r\n        border-top    : 1px solid rgba($black-color, 0.2);\r\n        padding-top   : 30px;\r\n        padding-bottom: 30px;\r\n\r\n        p {\r\n            margin-bottom: 0;\r\n            font-size    : 16px;\r\n            color        : $paragraph-color;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .footer-bottom {\r\n        padding: 60px 0px 50px;\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            padding: 40px 0px 40px;\r\n        }\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            padding: 25px 0px 25px;\r\n        }\r\n\r\n        .footer-column {\r\n            @media only screen and (max-width:991.98px) {\r\n                margin-bottom: 25px;\r\n            }\r\n\r\n            .footer-heading {\r\n                font-size    : 24px;\r\n                color        : $black-color;\r\n                font-weight  : 700;\r\n                margin-bottom: 15px;\r\n\r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size    : 20px;\r\n                    margin-bottom: 10px;\r\n                }\r\n            }\r\n\r\n            ul {\r\n                margin-bottom: 0px;\r\n\r\n                &.help-support {\r\n                    li {\r\n                        padding: 7px 0px;\r\n\r\n                        @media only screen and (max-width:767.98px) {\r\n                            padding: 5px 0px;\r\n                        }\r\n\r\n                        a {\r\n                            text-decoration: none;\r\n                            color          : $paragraph-color;\r\n                            font-size      : 16px;\r\n\r\n                            @media only screen and (max-width:767.98px) {\r\n                                font-size: 14px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &.footer-menu {\r\n                    li {\r\n                        padding: 7px 0px;\r\n\r\n                        @media only screen and (max-width:767.98px) {\r\n                            padding: 5px 0px;\r\n                        }\r\n\r\n                        a {\r\n                            text-decoration: none;\r\n                            color          : $paragraph-color;\r\n                            font-size      : 16px;\r\n\r\n                            @media only screen and (max-width:767.98px) {\r\n                                font-size: 14px;\r\n                            }\r\n                        }\r\n\r\n                        &:hover {\r\n                            a {\r\n                                color: $primary-color\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .footer-top-area {\r\n        border-bottom: 1px solid rgba($black-color, 0.1);\r\n        border-top   : 1px solid rgba($black-color, 0.1);\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            border-bottom: none;\r\n        }\r\n\r\n        .footer-top-one-wrapper {\r\n            display        : flex;\r\n            align-items    : center;\r\n            justify-content: space-between;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                flex-direction: column;\r\n                align-items   : flex-start;\r\n                padding-top   : 25px;\r\n            }\r\n\r\n            .right-area {\r\n                display    : flex;\r\n                align-items: center;\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    flex-direction: column;\r\n                    align-items   : flex-start;\r\n                }\r\n\r\n                .mailtext {\r\n                    font-size      : 40px;\r\n                    font-weight    : 700;\r\n                    color          : $black-color;\r\n                    text-decoration: none;\r\n                    margin-left    : 30px;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 30px;\r\n                    }\r\n\r\n                    @media only screen and (max-width:991.98px) {\r\n                        margin-left: 0px;\r\n                    }\r\n\r\n                    @media only screen and (max-width:767.98px) {\r\n                        font-size: 20px;\r\n                    }\r\n                }\r\n\r\n                .social-area {\r\n                    display    : flex;\r\n                    align-items: center;\r\n\r\n                    @media only screen and (max-width:991.98px) {\r\n                        margin: 20px 0px;\r\n                    }\r\n\r\n                    a {\r\n                        height         : 120px;\r\n                        width          : 120px;\r\n                        display        : flex;\r\n                        align-items    : center;\r\n                        justify-content: center;\r\n                        border-right   : 1px solid rgba($black-color, 0.1);\r\n\r\n                        @media only screen and (max-width:991.98px) {\r\n                            height: 80px;\r\n                            width : 80px;\r\n                        }\r\n\r\n                        @media only screen and (max-width:1199.98px) {\r\n                            width: 90px;\r\n                        }\r\n\r\n                        &:hover {\r\n                            svg {\r\n                                color: $primary-color;\r\n                            }\r\n                        }\r\n\r\n                        svg {\r\n                            font-size: 30px;\r\n                            color    : $black-color;\r\n                        }\r\n\r\n                        &:first-child {\r\n                            border-left: 1px solid rgba($black-color, 0.1);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Footer Css Ends*/\r\n/*Loader Css Start*/\r\n.loaderdiv {\r\n    position       : fixed;\r\n    top            : 0px;\r\n    bottom         : 0px;\r\n    left           : 0px;\r\n    right          : 0px;\r\n    z-index        : 111;\r\n    background     : $white-color;\r\n    display        : flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n\r\n    img {\r\n        height   : 100px;\r\n        animation: zoom 3s infinite;\r\n    }\r\n\r\n    @keyframes zoom {\r\n\r\n        0%,\r\n        100% {\r\n            transform: scale(1);\r\n            opacity  : 0;\r\n        }\r\n\r\n        50% {\r\n            transform: scale(1.2);\r\n            opacity  : 1;\r\n        }\r\n    }\r\n}\r\n\r\n/*Loader Css Ends*/\r\n/*Auth Css Start*/\r\n.login-main {\r\n    position      : relative;\r\n    z-index       : 1;\r\n    padding-top   : 120px;\r\n    padding-bottom: 120px;\r\n\r\n    &.signup-main {\r\n        padding-top   : 90px;\r\n        padding-bottom: 90px;\r\n    }\r\n\r\n    .loginbg {\r\n        height    : 452px;\r\n        width     : 100%;\r\n        position  : absolute;\r\n        z-index   : -1;\r\n        top       : 0px;\r\n        background: $black-color;\r\n        clip-path : polygon(0 0, 100% 0, 100% 70%, 0% 100%);\r\n\r\n        img {\r\n            height    : 100%;\r\n            width     : 100%;\r\n            object-fit: cover;\r\n            opacity   : 0.41;\r\n        }\r\n    }\r\n\r\n    .loginform {\r\n        background   : $white-color;\r\n        padding      : 70px;\r\n        border-radius: 30px;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            padding: 30px;\r\n        }\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            .btn-primary {\r\n                font-size: 16px !important;\r\n            }\r\n        }\r\n\r\n        .headlogin_div {\r\n            h2 {\r\n                font-size  : 24px;\r\n                color      : $black-color;\r\n                font-weight: 700;\r\n            }\r\n\r\n            p {\r\n                font-size  : 16px;\r\n                color      : $paragraph-color;\r\n                line-height: 1.5;\r\n                max-width  : 320px;\r\n                margin     : 0 auto;\r\n            }\r\n        }\r\n\r\n        .forgotpassword {\r\n            a {\r\n                color          : $black-color;\r\n                font-weight    : 600;\r\n                text-decoration: none;\r\n                font-size      : 16px;\r\n            }\r\n        }\r\n\r\n        .formfooter {\r\n            font-size: 16px;\r\n            color    : $black-color;\r\n\r\n            a {\r\n                color          : $primary-color;\r\n                font-weight    : 700;\r\n                text-decoration: none;\r\n            }\r\n        }\r\n\r\n        .form-group {\r\n            .form-label {\r\n                font-size  : 14px;\r\n                font-weight: 500;\r\n                color      : $black-color;\r\n\r\n                span {\r\n                    opacity: 0.30;\r\n                }\r\n            }\r\n\r\n            .password-input-group {\r\n                svg {\r\n                    position: absolute;\r\n                    top     : 17px;\r\n                    right   : 20px;\r\n                    opacity : 0.30;\r\n                }\r\n            }\r\n\r\n            .form-control {\r\n                height       : 50px;\r\n                border-radius: 12px;\r\n                border       : 1px solid rgba($black-color, 0.15);\r\n                color        : rgba($black-color, 0.70);\r\n                padding-left : 20px;\r\n                padding-right: 20px;\r\n                font-size    : 14px;\r\n\r\n                &[type=\"password\"] {\r\n                    padding-right: 50px;\r\n                }\r\n\r\n                &:focus {\r\n                    box-shadow: none;\r\n                }\r\n\r\n                &::placeholder {\r\n                    opacity: 0.50;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.reset-success {\r\n    .modal-dialog {\r\n        max-width: 437px;\r\n\r\n        .modal-content {\r\n            border-radius: 30px;\r\n\r\n            .modal-body {\r\n                text-align: center;\r\n                padding   : 40px;\r\n\r\n                h2 {\r\n                    font-size  : 24px;\r\n                    color      : $black-color;\r\n                    font-weight: 700;\r\n                }\r\n\r\n                p {\r\n                    font-size  : 16px;\r\n                    color      : $paragraph-color;\r\n                    font-weight: 400;\r\n                    line-height: 1.5;\r\n                }\r\n\r\n                .btn {\r\n                    min-width: 177px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Auth Css Ends*/\r\n/*Home Css Start*/\r\n\r\n.metalFinish_banner {\r\n    padding-top: 60px;\r\n    padding-bottom: 60px;\r\n    .banner-content {\r\n        h1 {\r\n                font-size: 70px;\r\n                color: $black-color;\r\n                margin-bottom: 20px;\r\n                font-weight: 600;\r\n        \r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 52px;\r\n                    margin-bottom: 30px;\r\n                }\r\n        \r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 36px;\r\n                }\r\n        \r\n                span {\r\n                    font-weight: 900;\r\n                    display: inline-flex;\r\n                    position: relative;\r\n                    z-index: 1;\r\n                    line-height: 1.45;\r\n        \r\n                    img {\r\n                        position: absolute;\r\n                        left: 0px;\r\n                        bottom: -22px;\r\n                    }\r\n                }\r\n            }\r\n            p {\r\n                color: $black-color;\r\n                font-size: 22px;\r\n                line-height: 1.75;\r\n                // opacity: 0.75;\r\n                margin-bottom: 0px;\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 18px;\r\n                }\r\n        \r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n    }\r\n}\r\n.banner-home {\r\n    &.banner-about {\r\n        padding-top      : 75px;\r\n        // padding-bottom: 75px;\r\n        // min-height    : 336px;\r\n        padding-bottom   : 0;\r\n        min-height       : 236px;\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            min-height: 200px;\r\n        }\r\n    }\r\n\r\n    padding-top           : 60px;\r\n    padding-bottom: 60px;\r\n    width                 : 100%;\r\n    display               : flex;\r\n    align-items           : center;\r\n    position              : relative;\r\n    z-index               : 1;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-top   : 50px;\r\n        padding-bottom: 50px;\r\n    }\r\n\r\n    .banner-content {\r\n        text-align: center;\r\n        max-width : 880px;\r\n        margin    : 0 auto;\r\n\r\n        ul {\r\n            margin-top   : 25px;\r\n            margin-bottom: 25px;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                margin-top   : 15px;\r\n                margin-bottom: 15px;\r\n            }\r\n\r\n            li {\r\n                display        : inline-flex;\r\n                margin         : 0px 18px 15px;\r\n                align-items    : center;\r\n                justify-content: center;\r\n                padding        : 0px 17px;\r\n                border         : 1px solid rgba($black-color, 0.30);\r\n                height         : 46px;\r\n                border-radius  : 30px;\r\n                font-size      : 16px;\r\n                color          : $black-color;\r\n                font-weight    : 500;\r\n\r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 14px;\r\n                }\r\n\r\n                svg {\r\n                    font-size   : 24px;\r\n                    color       : $primary-color;\r\n                    margin-right: 10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        h1 {\r\n            font-size    : 40px;\r\n            color        : $black-color;\r\n            margin-bottom: 10px;\r\n            font-weight: 700;\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size    : 36px;\r\n                margin-bottom: 20px;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 30px;\r\n            }\r\n\r\n            span {\r\n                font-weight: 900;\r\n                display    : inline-flex;\r\n                position   : relative;\r\n                z-index    : 1;\r\n                line-height: 1.45;\r\n\r\n                img {\r\n                    position: absolute;\r\n                    left    : 0px;\r\n                    bottom  : -15px;\r\n                }\r\n            }\r\n        }\r\n   h4{\r\n    font-weight: 400;\r\n    color:$black-color;\r\n    b{\r\n        font-weight: 700;\r\n    }\r\n   }\r\n        p {\r\n            color      : $black-color;\r\n            font-size  : 22px;\r\n            line-height: 1.75;\r\n            // opacity    : 0.75;\r\n            &.bannersubpara{\r\n                font-size: 16px;\r\n                color:#bebdbe\r\n            }\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 16px;\r\n            }\r\n\r\n            &.banner-sm-text {\r\n                font-size: 18px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 16px;\r\n                }\r\n\r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 14px;\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n}\r\n.homereviews{\r\n    background-color: #f7f7f7;\r\n    padding-top: 60px;\r\n    padding-bottom: 60px;\r\n    .reviewslist{\r\n        border: 1px solid #ebebeb;\r\n        background-color: $white-color;\r\n        box-shadow: 0 5px 10px 0 rgba($black-color, .07);\r\n        border-radius: 12px;\r\n        padding: 25px;\r\n        .reviewsleftcontent{\r\n            .reviewuser{\r\n                margin-bottom: 10px;\r\n                display: flex;\r\n                    align-items: center;\r\n                    gap: 14px;\r\n                img{\r\n                    width: 100px;\r\n                    height: 100px;\r\n                }\r\n                h5{\r\n                    font-size: 16px;\r\n                    color: $black-color;\r\n                    font-weight: 700;\r\n                    margin-top: 10px;\r\n                }\r\n            }\r\n            h3{\r\n                font-size: 18px;\r\n                color: $black-color;\r\n                font-weight: 600;\r\n            }\r\n            p{\r\n                color:$black-color;\r\n                font-size: 16px;\r\n                line-height: 1.75;\r\n                margin-bottom: 0;\r\n                text-align: start;\r\n            }\r\n          \r\n            .reviewrate{\r\n                .iconify{\r\n                    color:$yellow-color2;\r\n                    font-size: 40px;\r\n                }\r\n            }\r\n        }\r\n        .reviewsrightcontent{\r\n            h2{\r\n                font-size: 24px;\r\n                color:$black-color;\r\n                font-weight: 700;\r\n            }\r\n           .reviewbadge{\r\n               display: flex;\r\n               align-items: center;\r\n               flex-wrap: wrap;\r\n               gap: 7px;\r\n               h4{\r\n                font-size: 18px;\r\n                color:$black-color;\r\n                font-weight: 400;\r\n               }\r\n            .aluminiumbadge{\r\n                font-size: 16px;\r\n                color:$black-color;\r\n                font-weight: 600;\r\n                padding: 3px 10px;\r\n                background: rgba(#4F8CCA, 0.2);\r\n                border-radius: 20px!important;\r\n                text-decoration: none;\r\n                display:inline-block ; \r\n                .iconify{\r\n                    color:#4F8CCA\r\n                }\r\n            }\r\n            .brassbadge{\r\n                font-size: 16px;\r\n                color:$black-color;\r\n                font-weight: 600;\r\n                padding: 3px 10px;\r\n                background: rgba(#ef9000, 0.2);\r\n                border-radius: 20px!important;\r\n                display:inline-block ; \r\n                text-decoration: none;\r\n                .iconify{\r\n                    color:#ef9000\r\n                }\r\n            }\r\n             .steelbadge{\r\n                font-size: 16px;\r\n                color:$black-color;\r\n                font-weight: 600;\r\n                padding: 3px 10px;\r\n                background: rgba($danger-color, 0.2);\r\n                border-radius: 20px!important;\r\n                text-decoration: none;\r\n                display:inline-block ;\r\n                .iconify{\r\n                    color: $danger-color;\r\n                }\r\n             }p{ \r\n                line-height: normal;\r\n               a{\r\n                font-size: 12px;\r\n                color:#c4bdbe;\r\n                &:hover{\r\n                    opacity: 0.75;\r\n                }\r\n               }\r\n             }\r\n             .lasercuttingbadge{\r\n                font-size: 14px;\r\n                display:inline-block ;\r\n                color:$black-color;\r\n                font-weight: 600;\r\n                padding:3px 8px;\r\n                text-decoration: none;\r\n                background: rgba(#4F8CCA, 0.2);\r\n                border-radius: 20px!important;\r\n             }\r\n           }\r\n           .imgreviewhome{\r\n            max-width: 350px;\r\n            margin-bottom: 40px;\r\n            // margin-top: -20px;\r\n            @media only screen and (max-width:11997.98px){\r\n                margin-top: 0px;\r\n            }\r\n            @media only screen and (max-width:767.98px){\r\n                max-width: 100%;\r\n            }\r\n           }\r\n        }\r\n    }\r\n}\r\n.faq-home{\r\n    background-color: #f7f7f7;\r\n    padding-top: 80px;\r\n    padding-bottom: 80px;\r\n    .faqsubhead{\r\n        font-size: 22px;\r\n        color: $black-color;\r\n        font-weight: 700;\r\n        margin-bottom: 15px;\r\n        text-transform: capitalize;\r\n    }\r\n    .accordion {\r\n        .accordion-item {\r\n            margin-bottom: 10px;\r\n            border       : 1px solid rgba(0, 0, 0, 0.1) !important;\r\n            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);\r\n            border-radius: 12px !important;\r\n\r\n            .accordion-header {\r\n                margin-bottom: 0 !important;\r\n\r\n                button {\r\n                    &.accordion-button {\r\n                        font-size    : 16px !important;\r\n                        font-weight  : 500 !important;\r\n                        border-radius: 12px !important;\r\n                        color:$black-color;\r\n                        padding: 15px;\r\n                        background:$white-color;\r\n                        box-shadow: none;\r\n                        &:after {\r\n                            transform: rotate(-90deg);\r\n                            width              : 24px;\r\n                            height             : 24px;\r\n                            border             : 1px solid $black-color;\r\n                            border-radius      : 50%;\r\n                            display            : inline-flex;\r\n                            align-items        : center;\r\n                            justify-content    : center;\r\n                            background-position: center;\r\n                            background-size    : 13px;\r\n                            background-image   : url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e\");\r\n                            opacity            : 0.40;\r\n                        }\r\n                        &:not(.collapsed){\r\n                            color:$black-color;\r\n                            &:after {\r\n                                transform: rotate(-180deg);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .accordion-body {\r\n                padding-left: 16px;\r\n                padding-top: 0;\r\n                font-size   : 14px;\r\n                line-height : 1.75;\r\n                color       : $paragraph-color\r\n            }\r\n        }\r\n    }\r\n}\r\n.american-manufacturing{\r\n    padding-top: 70px;\r\n    padding-bottom: 80px;\r\n    img{\r\n        max-width: 350px;\r\n    }\r\n    h4{\r\n        color:$black-color;\r\n        font-weight: 500;\r\n    }\r\n}\r\n.our-services {\r\n    padding-top   : 165px;\r\n    padding-bottom: 240px;\r\n    position      : relative;\r\n    overflow      : hidden;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-bottom: 80px;\r\n        padding-top   : 100px;\r\n    }\r\n\r\n    .services-img {\r\n        position: relative;\r\n        z-index : 1;\r\n\r\n        img {\r\n            object-fit: cover;\r\n        }\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            margin-bottom: 30px;\r\n        }\r\n\r\n        &:before {\r\n            content          : '';\r\n            width            : 772px;\r\n            height           : 772px;\r\n            background       : url('../img/shape-1.png');\r\n            background-size  : 772px 772px;\r\n            background-repeat: no-repeat;\r\n            position         : absolute;\r\n            top              : -161px;\r\n            left             : -195px;\r\n            opacity          : 0.22;\r\n            z-index          : -1;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                width          : 572px;\r\n                height         : 572px;\r\n                background-size: 572px 572px;\r\n                top            : -70px;\r\n                left           : -86px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .services-grid {\r\n        position       : relative;\r\n        z-index        : 1;\r\n        background     : $white-color;\r\n        padding        : 45px 15px;\r\n        text-align     : center;\r\n        box-shadow     : 0px 0px 10px rgba($black-color, 0.15);\r\n        border-radius  : 14px;\r\n        display        : block;\r\n        text-decoration: none;\r\n\r\n        @media only screen and (max-width:1199.98px) {\r\n            padding: 25px 15px;\r\n        }\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        h2 {\r\n            font-size  : 22px;\r\n            color      : $black-color;\r\n            font-weight: 700;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n\r\n        p {\r\n            font-size: 16px;\r\n            color    : $paragraph-color;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        .single-item-thumbs {\r\n            position         : relative;\r\n            z-index          : 0;\r\n            width            : 132px;\r\n            height           : 100px;\r\n            background-image : url('../img/shape-3.svg');\r\n            display          : flex;\r\n            justify-content  : center;\r\n            align-items      : center;\r\n            background-repeat: no-repeat;\r\n            margin           : 0 auto 22px;\r\n        }\r\n\r\n        &:after {\r\n            content   : \"\";\r\n            background: url('../img/shape-4.svg');\r\n            width     : 52px;\r\n            height    : 75px;\r\n            position  : absolute;\r\n            left      : 0;\r\n            bottom    : 0;\r\n            opacity   : 0;\r\n        }\r\n\r\n        &:hover {\r\n            background: $primary-color;\r\n            cursor    : pointer;\r\n\r\n            h2,\r\n            p {\r\n                color: $white-color;\r\n            }\r\n\r\n            .single-item-thumbs {\r\n                background-image: url('../img/shape-3-1.svg');\r\n\r\n                img {\r\n                    filter: brightness(0) invert(1);\r\n                }\r\n            }\r\n\r\n            &:after {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.max-width-470 {\r\n    max-width: 470px;\r\n}\r\n\r\n.max-width-810 {\r\n    max-width: 810px;\r\n}\r\n\r\n.heading {\r\n    h2 {\r\n        font-size     : 48px;\r\n        color         : $black-color;\r\n        font-weight   : 800;\r\n        text-transform: capitalize;\r\n\r\n        @media only screen and (max-width:1199.98px) {\r\n            font-size: 36px;\r\n        }\r\n    }\r\n\r\n    p {\r\n        font-size  : 18px;\r\n        color      : $paragraph-color;\r\n        line-height: 1.6;\r\n\r\n        @media only screen and (max-width:1199.98px) {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.materials-grid {\r\n    background     : $white-color;\r\n    border         : 2px solid $white-color;\r\n    padding        : 20px;\r\n    border-radius  : 14px;\r\n    box-shadow     : 0px 0px 10px rgba($black-color, 0.07);\r\n    height         : 100%;\r\n    min-height     : 316px;\r\n    display        : block;\r\n    text-decoration: none;\r\n\r\n    &.hover-aluminum:hover {\r\n        border: 2px solid $primary-color;\r\n    }\r\n\r\n    &.hover-steel:hover {\r\n        border: 2px solid $danger-color;\r\n    }\r\n\r\n    &.hover-stainless-steel:hover {\r\n        border: 2px solid $green-color;\r\n    }\r\n\r\n    &.hover-brass:hover {\r\n        border: 2px solid $yellow-color;\r\n    }\r\n\r\n    &.hover-custom:hover {\r\n        border: 2px solid $purple-color;\r\n    }\r\n\r\n    &:hover {\r\n        cursor   : pointer;\r\n        // border: 2px solid $primary-color;\r\n    }\r\n\r\n    .materials-info {\r\n        display    : flex;\r\n        align-items: center;\r\n\r\n        .material-img {\r\n            width        : 92px;\r\n            min-width    : 92px;\r\n            height       : 92px;\r\n            display      : inline-block;\r\n            border-radius: 10px;\r\n            margin-right : 20px;\r\n            overflow     : hidden;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                width       : 72px;\r\n                min-width   : 72px;\r\n                height      : 72px;\r\n                margin-right: 10px;\r\n            }\r\n        }\r\n\r\n        h2 {\r\n            font-size    : 27px;\r\n            color        : #000;\r\n            font-weight  : 700;\r\n            margin-bottom: 0px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 22px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .material-grade {\r\n        &.material-grade2 {\r\n            span {\r\n                opacity  : 0.60;\r\n                min-width: 71px;\r\n            }\r\n        }\r\n\r\n        span {\r\n            height         : 29px;\r\n            border         : 1px solid rgba($black-color, 0.10);\r\n            padding        : 0px 15px;\r\n            text-align     : center;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            font-size      : 14px;\r\n            color          : $black-color;\r\n            border-radius  : 30px;\r\n        }\r\n    }\r\n}\r\n\r\n.min-width-84 {\r\n    min-width: 84px;\r\n}\r\n\r\n.bgprimary {\r\n    background: $primary-color !important;\r\n}\r\n\r\n.bgdanger {\r\n    background: $danger-color !important;\r\n}\r\n\r\n.bgsuccess {\r\n    background: $green-color !important;\r\n}\r\n\r\n.bgyellow {\r\n    background: $yellow-color !important;\r\n}\r\n\r\n.bgpurple {\r\n    background: $purple-color !important;\r\n}\r\n\r\n.get-instant-quote {\r\n    padding-top   : 100px;\r\n    padding-bottom: 100px;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-bottom: 80px;\r\n        padding-top   : 80px;\r\n    }\r\n\r\n    &.get-parts {\r\n        padding-top: 0px;\r\n\r\n        .get-parts-img {\r\n            position  : relative;\r\n            z-index   : 1;\r\n            text-align: end;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                margin-top: 25px;\r\n            }\r\n\r\n            &:after {\r\n                content          : \"\";\r\n                width            : 772px;\r\n                height           : 772px;\r\n                background       : url('../img/shape-2.png');\r\n                background-size  : 772px 772px;\r\n                background-repeat: no-repeat;\r\n                position         : absolute;\r\n                top              : -161px;\r\n                right            : -195px;\r\n                opacity          : 0.22;\r\n                z-index          : -1;\r\n                transform        : rotate(-12deg);\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    width          : 572px;\r\n                    height         : 572px;\r\n                    background-size: 572px 572px;\r\n                    top            : -66px;\r\n                    right          : -84px;\r\n                }\r\n\r\n            }\r\n        }\r\n    }\r\n\r\n    .get-quote-img {\r\n        @media only screen and (max-width:991.98px) {\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        .portal-inner {\r\n            border       : 1px solid rgba($black-color, 0.07);\r\n            border-radius: 15px;\r\n            overflow     : hidden;\r\n            position     : relative;\r\n            z-index      : 1;\r\n\r\n            &:after {\r\n                content      : '';\r\n                position     : absolute;\r\n                top          : 0;\r\n                left         : 0;\r\n                right        : 0;\r\n                bottom       : 0;\r\n                background   : rgba($black-color, 0.04);\r\n                z-index      : 1;\r\n                border-radius: 15px;\r\n            }\r\n\r\n            .top-portal {\r\n                position     : absolute;\r\n                width        : 100%;\r\n                top          : 0px;\r\n                padding      : 10px 20px;\r\n                background   : $white-color;\r\n                border-bottom: 1px solid rgba($black-color, 0.10);\r\n                z-index      : 1;\r\n            }\r\n\r\n            .bottom-img {\r\n                animation : moveUpDown 12s infinite;\r\n                margin-top: 41px;\r\n\r\n                @keyframes moveUpDown {\r\n\r\n                    0%,\r\n                    100% {\r\n                        transform: translateY(0);\r\n                    }\r\n\r\n                    50% {\r\n                        transform: translateY(-100px);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .get-quote-content {\r\n        position: relative;\r\n        z-index : 11;\r\n\r\n        .features-content-box {\r\n            background   : $white-color;\r\n            padding      : 20px;\r\n            box-shadow   : 0px 0px 10px rgba($black-color, 0.10);\r\n            border-radius: 14px;\r\n            display      : flex;\r\n            align-items  : center;\r\n            border-left  : 3px solid $white-color;\r\n\r\n            &:hover {\r\n                border-left: 3px solid $primary-color;\r\n                cursor     : pointer;\r\n            }\r\n\r\n            &:not(:last-child) {\r\n                margin-bottom: 17px;\r\n            }\r\n\r\n            .feature-icon {\r\n                width          : 91px;\r\n                min-width      : 91px;\r\n                height         : 91px;\r\n                border-radius  : 50%;\r\n                background     : rgba($primary-color, 0.05);\r\n                display        : inline-flex;\r\n                align-items    : center;\r\n                justify-content: center;\r\n                margin-right   : 20px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    width    : 75px;\r\n                    min-width: 75px;\r\n                    height   : 75px;\r\n                }\r\n\r\n                svg {\r\n                    font-size: 36px;\r\n                    color    : $primary-color;\r\n\r\n                }\r\n            }\r\n\r\n            .content {\r\n                h3 {\r\n                    font-size  : 22px;\r\n                    color      : $black-color;\r\n                    font-weight: 600;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 18px;\r\n                    }\r\n                }\r\n\r\n                p {\r\n                    font-size    : 16px;\r\n                    color        : $paragraph-color;\r\n                    margin-bottom: 0px;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.our-testimonials {\r\n    .testimonial-shape {\r\n        position: absolute;\r\n        top     : -60px;\r\n        width   : 100%;\r\n    }\r\n\r\n    .our-testimonials {\r\n        margin-top: 60px;\r\n    }\r\n\r\n    .slick-slide {\r\n        padding: 0px 10px;\r\n    }\r\n\r\n\r\n    .testimonials-grid {\r\n        background   : $white-color;\r\n        padding      : 0px 30px 30px;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n        margin       : 50px 0px 10px;\r\n        border-radius: 12px;\r\n\r\n        @media only screen and (max-width:1199.98px) {\r\n            padding: 0px 20px 20px;\r\n        }\r\n\r\n        .userinfo {\r\n            text-align: center;\r\n\r\n            img {\r\n                width     : 101px;\r\n                min-width : 101px;\r\n                height    : 101px;\r\n                margin-top: -50px;\r\n            }\r\n\r\n            h3 {\r\n                font-size    : 20px;\r\n                font-weight  : 700;\r\n                margin-bottom: 3px;\r\n                margin-top   : 15px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n\r\n            p {\r\n                margin-bottom: 0px;\r\n                font-size    : 16px;\r\n                font-weight  : 500;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n\r\n            .testimonial-rating {\r\n                svg {\r\n                    color: $yellow-color\r\n                }\r\n            }\r\n        }\r\n\r\n        .testimonial-quote {\r\n            opacity: 0.05;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                img {\r\n                    height: 40px\r\n                }\r\n            }\r\n        }\r\n\r\n        .testimonials-content {\r\n            margin-top: 20px;\r\n\r\n            p {\r\n                margin-bottom: 0px;\r\n                font-size    : 16px;\r\n                font-weight  : 400;\r\n                color        : $paragraph-color;\r\n                line-height  : 1.75;\r\n                text-align   : center;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.cta {\r\n    padding-top   : 100px;\r\n    padding-bottom: 100px;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-top   : 70px;\r\n        padding-bottom: 80px;\r\n    }\r\n\r\n}\r\n\r\n.maincontent_div {\r\n    padding-top: 98px;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-top: 73px;\r\n    }\r\n\r\n    .banner-upload-file {\r\n        background   : rgba($black-color, 0.03);\r\n        border       : 1px dashed rgba($black-color, 0.25);\r\n        border-radius: 20px;\r\n        padding      : 30px;\r\n        cursor: pointer;\r\n        &.processing-added {\r\n            position: relative;\r\n            z-index: 1;\r\n            overflow: hidden;\r\n            pointer-events: none;\r\n            &:before {\r\n                content: '';\r\n                position: absolute;\r\n                top: 0px;\r\n                left: 0px;\r\n                right: 0px;\r\n                bottom: 0px;\r\n                background: rgba($black-color, .5);\r\n            }\r\n            .loader{\r\n                position: absolute;\r\n                z-index: 2;\r\n                color: $white-color;\r\n                top: 0px;\r\n                left: 0px;\r\n                right: 0px;\r\n                bottom: 0px;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                svg{\r\n                    animation: rotate 2s linear infinite;\r\n                }\r\n\r\n@keyframes rotate {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n            }\r\n        }\r\n        svg {\r\n            font-size: 60px;\r\n        }\r\n\r\n        small {\r\n            font-size  : 17px;\r\n            font-weight: 300;\r\n            color      : $black-color;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        p {\r\n            font-size: 20px;\r\n            opacity  : 1;\r\n            margin   : 10px 0px 5px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            label {\r\n                color        : $primary-color;\r\n                font-weight  : 500;\r\n                border-bottom: 1px solid $primary-color;\r\n                line-height  : normal;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .invalid-dxf-files {\r\n        &__panel {\r\n            border: 1px solid rgba($black-color, 0.12);\r\n            background-color: rgba($yellow-color, 0.06);\r\n            border-radius: var(--bs-border-radius);\r\n            overflow: visible;\r\n        }\r\n\r\n        &__header {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 0.5rem;\r\n            padding: 0.25rem 0.5rem;\r\n            font-size: 0.9375rem;\r\n            border-bottom: 1px solid rgba($black-color, 0.08);\r\n            background-color: rgba($yellow-color, 0.12);\r\n        }\r\n\r\n        &__icon {\r\n            color: $yellow-dark;\r\n            flex-shrink: 0;\r\n        }\r\n\r\n        &__message {\r\n            line-height: 1.35;\r\n        }\r\n\r\n        &__row {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 0.5rem;\r\n            padding: 0.25rem 0;\r\n            border-bottom: 1px solid rgba($black-color, 0.06);\r\n        }\r\n\r\n        &__filename {\r\n            font-size: 0.875rem;\r\n            word-break: break-all;\r\n        }\r\n\r\n        &__dropdown {\r\n            flex-shrink: 0;\r\n            min-width: 120px;\r\n        }\r\n\r\n        &__footer {\r\n            padding: 0.5rem;\r\n            border-top: 1px solid rgba($black-color, 0.08);\r\n        }\r\n    }\r\n\r\n    .pagination_order {\r\n        list-style: none;\r\n        padding: 0px;\r\n        margin: 0px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        gap: 7px;\r\n        flex-wrap: wrap;\r\n        li.page-item {\r\n            display: inline-block;\r\n            button.page-link {\r\n                width: 40px;\r\n                height: 40px;\r\n                background: $white-color;\r\n                border-radius: 12px;\r\n                font-size: 14px;\r\n                border: 1px solid color(srgb 0 0 0 / 0.09);\r\n                font-weight: 500;\r\n                color: #3b3b3b;\r\n            }\r\n            span {\r\n                color: $black-color;\r\n            }\r\n            &.active {\r\n                button.page-link {\r\n                    background: $primary-color;\r\n                    color: $white-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Home Css Ends*/\r\n/*About Us Css Ends*/\r\n\r\n.our-history {\r\n    padding-top   : 90px;\r\n    padding-bottom: 30px;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-top   : 80px;\r\n        padding-bottom: 20px;\r\n    }\r\n\r\n    .history-grid {\r\n        border-left: 1px solid rgba($black-color, 0.1);\r\n        padding    : 20px;\r\n\r\n        h3 {\r\n            font-size    : 24px;\r\n            color        : $black-color;\r\n            font-weight  : 700;\r\n            margin-bottom: 20px;\r\n            position     : relative;\r\n            z-index      : 1;\r\n\r\n            &:before {\r\n                content   : '';\r\n                position  : absolute;\r\n                left      : -20px;\r\n                width     : 4px;\r\n                height    : 100%;\r\n                background: $primary-color;\r\n            }\r\n        }\r\n\r\n        img {\r\n            border-radius: 12px;\r\n            height       : 150px;\r\n            object-fit   : cover;\r\n            width        : 100%;\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        p {\r\n            font-size  : 12px;\r\n            color      : $paragraph-color;\r\n            line-height: 1.75;\r\n            text-align : center;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.slick-slider {\r\n    .slick-dots {\r\n        li {\r\n            width : auto;\r\n            height: auto;\r\n\r\n            button {\r\n                width        : 6px;\r\n                height       : 6px;\r\n                border-radius: 6px;\r\n                background   : $primary-color;\r\n\r\n                &::before {\r\n                    display: none !important;\r\n                }\r\n            }\r\n\r\n            &.slick-active {\r\n                button {\r\n                    width: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.our-mission {\r\n    .mission-img {\r\n        display : inline-block;\r\n        position: relative;\r\n        z-index : 1;\r\n\r\n        img {\r\n            border-radius: 50px;\r\n        }\r\n\r\n        &:after {\r\n            content      : '';\r\n            background   : #F3F4F6;\r\n            position     : absolute;\r\n            left         : 30px;\r\n            top          : -30px;\r\n            right        : -30px;\r\n            bottom       : 30px;\r\n            z-index      : -1;\r\n            border-radius: 50px;\r\n        }\r\n    }\r\n\r\n    .mission-content {\r\n        @media only screen and (max-width:991.98px) {\r\n            margin-top: 25px;\r\n        }\r\n\r\n        h4 {\r\n            font-size  : 22px;\r\n            font-weight: 600;\r\n            margin     : 20px 0px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n\r\n        p {\r\n            font-size  : 18px;\r\n            line-height: 1.75;\r\n            color      : $paragraph-color;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 16px;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.core-values {\r\n    padding-top   : 100px;\r\n    padding-bottom: 100px;\r\n\r\n    @media only screen and (max-width:991.98px) {\r\n        padding-top   : 60px;\r\n        padding-bottom: 70px;\r\n    }\r\n\r\n    .values-grid {\r\n        text-align: center;\r\n        border    : 2px solid $white-color;\r\n        height    : 100%;\r\n        min-height: 350px;\r\n\r\n        &:hover {\r\n            border: 2px solid $primary-color;\r\n        }\r\n\r\n        .single-item-thumbs {\r\n            position         : relative;\r\n            z-index          : 0;\r\n            width            : 132px;\r\n            height           : 100px;\r\n            background-image : url('../img/shape-3.svg');\r\n            display          : flex;\r\n            justify-content  : center;\r\n            align-items      : center;\r\n            background-repeat: no-repeat;\r\n            margin           : 0 auto 22px;\r\n\r\n            svg {\r\n                font-size: 35px;\r\n                color    : $primary-color;\r\n            }\r\n        }\r\n\r\n        h3 {\r\n            font-size  : 24px;\r\n            color      : $black-color;\r\n            font-weight: 700;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 20px;\r\n            }\r\n        }\r\n\r\n        p {\r\n            font-size    : 14px;\r\n            line-height  : 1.75;\r\n            color        : $paragraph-color;\r\n            margin-bottom: 0px;\r\n        }\r\n\r\n        padding      : 30px 20px;\r\n        border-radius: 14px;\r\n        background   : $white-color;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.08);\r\n    }\r\n}\r\n\r\n/*About Us Css Ends*/\r\n/*Services Css Start*/\r\n.loginUploadInfo_text {\r\n    display: block;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: $light-color;\r\n}\r\n.banner-services {\r\n    .banner-service-img {\r\n        display : inline-block;\r\n        position: relative;\r\n        z-index : 1;\r\n\r\n        @media only screen and (max-width:991.98px) {\r\n            margin-top: 25px;\r\n        }\r\n\r\n        img {\r\n            border-radius: 0px 150px 0px 150px;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                border-radius: 0px 100px 0px 100px;\r\n            }\r\n        }\r\n\r\n        &:after {\r\n            content      : '';\r\n            border-radius: 0px 150px 0px 150px;\r\n            position     : absolute;\r\n            left         : 20px;\r\n            right        : -20px;\r\n            top          : -20px;\r\n            bottom       : 20px;\r\n            border       : 1px solid rgba($black-color, 0.1);\r\n            z-index      : -1;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                border-radius: 0px 100px 0px 100px;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .banner-content {\r\n        h1 {\r\n            font-size: 70px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 50px;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 36px;\r\n            }\r\n        }\r\n        .bannerservice_btns {\r\n            text-align: center;\r\n        }\r\n        .banner-btns {\r\n            display: flex;\r\n            gap    : 25px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                gap           : 10px;\r\n                flex-direction: column;\r\n            }\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                flex-direction: row;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                flex-direction: column;\r\n            }\r\n\r\n            .btn {\r\n                flex: 1;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    flex: initial\r\n                }\r\n\r\n                svg {\r\n                    font-size: 24px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .banner-upload-file {\r\n            p {\r\n                font-size: 18px;\r\n\r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 16px;\r\n                }\r\n            }\r\n\r\n            small {\r\n                font-size: 16px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n\r\n        h1 {\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        p {\r\n            font-size: 20px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.maxWidth_680 {\r\n    max-width: 680px;\r\n    margin: 0px auto;\r\n}\r\n.pb_70 {\r\n    padding-bottom: 70px;\r\n}\r\n.lasercuttingmaterial{\r\n    padding-top: 80px;\r\n    padding-bottom: 80px;  \r\n}\r\n.lasercuttingbreakdown{\r\n    background-color: #f7f7f7; \r\n}\r\n.laserCuttingInfo_sec {\r\n    padding-top: 80px;\r\n    padding-bottom: 70px;\r\n    background-color: #f7f7f7;\r\n    .laserCuttingInfo_div {\r\n        h3 {\r\n            font-size: 24px;\r\n            font-weight: bold;\r\n            color: $black-color;\r\n            margin-bottom: 20px;\r\n        }\r\n        h4 {\r\n            font-size: 20px;\r\n            font-weight: bold;\r\n            color: $black-color;\r\n            margin-bottom: 10px;\r\n        }\r\n        p{\r\n            font-size: 18px;\r\n            font-weight: 400;\r\n            color: $black-color;\r\n            margin-bottom: 10px;\r\n            b{\r\n                font-weight: 600;\r\n            }\r\n        }\r\n        ul {\r\n            list-style: auto;\r\n            margin: 0px;\r\n            padding-left: 20px;\r\n            &.listcustom{\r\n                list-style: disc;\r\n                margin-top: 10px;  \r\n                margin-bottom: 12px;  \r\n            }\r\n            li {\r\n                font-size: 18px;\r\n                font-weight: 400;\r\n                color: $black-color;\r\n                margin-bottom: 6px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.metalfinish_sec {\r\n    padding-bottom: 60px;\r\n    .metalfinish_sec_inner{\r\n        background-color: #f7f7f7; \r\n        padding-top: 40px;\r\n        padding-bottom: 30px;\r\n    }\r\n    .metalfinish_div {\r\n        margin-bottom: 20px;\r\n        h4 {\r\n            font-size: 20px;\r\n            font-weight: bold;\r\n            color: $black-color;\r\n            margin-bottom: 10px;\r\n        }\r\n        p {\r\n            font-size: 18px;\r\n            font-weight: 400;\r\n            color: $black-color;\r\n            margin-bottom: 10px;\r\n        }\r\n        ul {\r\n            list-style: disc;\r\n            margin: 0px 0px 10px;\r\n            li {\r\n                font-size: 18px;\r\n                font-weight: 400;\r\n                color: $black-color;\r\n            }\r\n        }\r\n        .metalfinish_box {\r\n            text-align: center;\r\n            img {\r\n                width: 100%;\r\n                height: 350px;\r\n                border-radius: 15px;\r\n                object-fit: cover;\r\n                margin-bottom: 10px;\r\n                object-position: bottom center;\r\n                @media only screen and (max-width:767.98px)\r\n                {\r\n                    height: auto;\r\n                }\r\n            }\r\n            h5 {\r\n                font-size: 18px;\r\n                font-weight: 600;\r\n                margin-bottom: 0px;\r\n            }\r\n            &.steelColor {\r\n                img {\r\n                    border: 2px solid #e01f26;\r\n                }\r\n                h5 {\r\n                    color: #e01f26;\r\n                }\r\n            }\r\n            &.stainlessColor {\r\n                img {\r\n                    border: 2px solid #00bf63;\r\n                }\r\n                h5 {\r\n                    color: #00bf63;\r\n                }\r\n            }\r\n            &.aluminumColor {\r\n                img {\r\n                    border: 2px solid #4e8ac8;\r\n                }\r\n                h5 {\r\n                    color: #4e8ac8;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.HowITWorksmain_div {\r\n    padding-top: 80px;\r\n    padding-bottom: 80px;\r\n    .worksMain_head {\r\n        font-size: 24px;\r\n        font-weight: 600;\r\n        color: $black-color;\r\n        margin-bottom: 20px;\r\n    }\r\n    .worksStep_head {\r\n        font-size: 24px;\r\n        font-weight: 700;\r\n        color: $black-color;\r\n        margin-bottom: 15px;\r\n    }\r\n    .HowITWorksteps_box {\r\n        // display: flex;\r\n        // align-items: flex-start;\r\n        // gap: 10px;\r\n        border: 1px solid #ebebeb;\r\n        background-color: $white-color;\r\n        box-shadow: 0 5px 10px 0 rgba($black-color, 0.07);\r\n        border-radius: 12px;\r\n        padding: 25px;\r\n        video{\r\n            border-radius:12px;\r\n             width: 100%; \r\n             height: auto\r\n        }\r\n        .StepIcon_img {\r\n            flex-shrink: 0;\r\n            max-width: 50px;\r\n        }\r\n        .Worksteps_cont {\r\n            flex-grow: 1;\r\n            h4 {\r\n                font-size: 18px;\r\n                font-weight: bold;\r\n                color: $black-color;\r\n                margin-bottom: 5px;\r\n            }\r\n            p {\r\n                font-size: 18px;\r\n                font-weight: 400;\r\n                color: $black-color;\r\n                margin-bottom: 5px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.laserProduct_sec {\r\n    padding: 70px 0px;\r\n    transition: ease-in-out 0.7s;\r\n    .Productmain_box {    \r\n        background: $white-color;\r\n        border-radius: 20px;\r\n        box-shadow: 0px 0px 20px 0px rgba($black-color, 0.07);\r\n        padding: 15px;\r\n        text-align: center;\r\n        cursor: pointer;\r\n        height: 100%;\r\n        &:hover {\r\n            .Product_img {\r\n                img {\r\n                    &.img_default {\r\n                        opacity: 0;\r\n                        transition: ease-in-out 0.7s;\r\n                    }\r\n                    &.img_hover {\r\n                        opacity: 1;\r\n                        transition: ease-in-out 0.7s;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .Product_img {\r\n            border-radius: 20px;\r\n            overflow: hidden;\r\n            position: relative;\r\n            height: 270px;\r\n            margin-bottom: 10px;\r\n            @media only screen and (min-width: 1400px) {\r\n                height: 290px;\r\n            }\r\n            @media only screen and (max-width: 575.98px) {\r\n                height: 290px;\r\n            }\r\n            img {\r\n                position: absolute;\r\n                top: 0px;\r\n                bottom: 0px;\r\n                left: 0px;\r\n                right: 0px;\r\n                object-fit: cover;\r\n                width: 100%;\r\n                height: 100%;\r\n                display: block;\r\n                @media only screen and (max-width: 575.98px) {\r\n                    object-fit: contain;\r\n                }\r\n                &.img_default {\r\n                    opacity: 1;\r\n                    transition: ease-in-out 0.7s;\r\n                }\r\n                &.img_hover {\r\n                    opacity: 0;\r\n                    transition: ease-in-out 0.7s;\r\n                }\r\n            }\r\n        }\r\n        h4 {\r\n            margin-bottom: 10px;\r\n            text-align: center;\r\n            a {\r\n                text-decoration: none;\r\n                display: inline-block;\r\n                font-size: 18px;\r\n                font-weight: bold;\r\n                color: $black-color;\r\n                &:hover {\r\n                    color: $primary-color;\r\n                }\r\n            }\r\n        }\r\n        p {  margin-bottom: 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            color: $paragraph-color;\r\n            text-align: center;\r\n            // margin-bottom: 0px;\r\n            a{ \r\n                 color: $paragraph-color;\r\n                  text-decoration: none;\r\n                &:hover {\r\n                    color: $primary-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.promotion_modal{\r\n    .modal-content{\r\n        .modal-body{\r\n            text-align: center;\r\n            padding: 40px 30px;\r\n            h4{\r\n                font-size: 26px;\r\n                color:$black-color;\r\n                \r\n            }\r\n            p{\r\n                font-size: 16px;\r\n                color: #bebdbe;\r\n                margin-bottom: 0;\r\n                margin-top: 5px;\r\n            }\r\n        }\r\n    }\r\n}\r\n.product_modal {\r\n    .modal-content {\r\n        .modal-body {\r\n            .main_heading {\r\n                font-size: 24px;\r\n                font-weight: bold;\r\n                color: $black-color;\r\n                margin-bottom: 15px;\r\n            }\r\n            p {\r\n                font-size: 16px;\r\n                font-weight: 400;\r\n                color: $paragraph-color;\r\n                margin-bottom: 10px;\r\n            }\r\n            ul {\r\n                list-style: disc;\r\n                margin: 0px 0px 10px;\r\n                li {\r\n                    font-size: 16px;\r\n                    font-weight: 400;\r\n                    color: $paragraph-color;\r\n                }\r\n            }\r\n            ol {\r\n                margin: 0px 0px 10px;\r\n                li {\r\n                    font-size: 16px;\r\n                    font-weight: 400;\r\n                    color: $paragraph-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n/*Services Css Ends*/\r\n/*Resources Css Start*/\r\n.resources-main {\r\n    padding: 50px 0px;\r\n\r\n    .custom-table {\r\n        .rdt_TableBody {\r\n            .rdt_TableRow {\r\n                .rdt_TableCell {\r\n                    div {\r\n                        width: 100%;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .resources-search-field {\r\n        .form-control {\r\n            padding      : 10px 20px 10px 45px;\r\n            border       : none;\r\n            border-radius: 12px;\r\n            box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n            height       : 50px;\r\n            color        : rgba($black-color, 0.70);\r\n        }\r\n\r\n        svg {\r\n            position : absolute;\r\n            top      : 15px;\r\n            left     : 15px;\r\n            opacity  : 0.50;\r\n            font-size: 18px;\r\n            min-width: 18px;\r\n        }\r\n    }\r\n\r\n    .resources-right {\r\n        border-radius: 12px;\r\n        padding      : 15px;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n        position     : sticky;\r\n        top          : 100px;\r\n\r\n        h2 {\r\n            font-size    : 18px;\r\n            color        : $black-color;\r\n            font-weight  : 600;\r\n            margin-bottom: 12px;\r\n        }\r\n\r\n        a {\r\n            display        : block;\r\n            padding-bottom : 10px;\r\n            text-decoration: none;\r\n            color          : $paragraph-color;\r\n            font-size      : 15px;\r\n            line-height    : 1.75;\r\n\r\n            &:hover {\r\n                color: $primary-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    .resources-body {\r\n        .accordion {\r\n            .accordion-item {\r\n                margin-bottom: 10px;\r\n                border       : 1px solid rgba(0, 0, 0, 0.1) !important;\r\n                border-radius: 12px !important;\r\n\r\n                .accordion-header {\r\n                    margin-bottom: 0 !important;\r\n\r\n                    button {\r\n                        &.accordion-button {\r\n                            font-size    : 16px !important;\r\n                            font-weight  : 500 !important;\r\n                            border-radius: 12px !important;\r\n\r\n                            &:after {\r\n                                width              : 24px;\r\n                                height             : 24px;\r\n                                border             : 1px solid $black-color;\r\n                                border-radius      : 50%;\r\n                                display            : inline-flex;\r\n                                align-items        : center;\r\n                                justify-content    : center;\r\n                                background-position: center;\r\n                                background-size    : 13px;\r\n                                background-image   : url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23000000%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e\");\r\n                                opacity            : 0.40;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .accordion-body {\r\n                    padding-left: 16px;\r\n                    font-size   : 14px;\r\n                    line-height : 1.75;\r\n                    color       : $paragraph-color\r\n                }\r\n            }\r\n        }\r\n\r\n        .resources-pagination {\r\n            border-top : 1px solid rgba($black-color, 0.1);\r\n            padding-top: 20px;\r\n\r\n            a {\r\n                display        : flex;\r\n                flex-direction : column;\r\n                font-size      : 16px;\r\n                color          : $primary-color;\r\n                font-weight    : 600;\r\n                text-decoration: none;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n\r\n                &.pagination-prev {\r\n                    span {\r\n                        transform: rotate(-180deg);\r\n                    }\r\n                }\r\n\r\n                &.pagination-next {\r\n                    align-items: flex-end;\r\n                }\r\n\r\n                span {\r\n                    width          : 38px;\r\n                    height         : 38px;\r\n                    background     : $primary-color;\r\n                    display        : inline-flex;\r\n                    align-items    : center;\r\n                    justify-content: center;\r\n                    border-radius  : 50%;\r\n                    margin-bottom  : 5px;\r\n\r\n                    svg {\r\n                        color: $white-color\r\n                    }\r\n                }\r\n\r\n                &:hover {\r\n                    opacity: 0.50;\r\n                }\r\n            }\r\n        }\r\n\r\n        hr {\r\n            opacity      : 0.10;\r\n            margin-bottom: 25px;\r\n        }\r\n\r\n        .searchfield {\r\n\r\n            svg {\r\n                position: absolute;\r\n                top     : 12px;\r\n                left    : 12px;\r\n                opacity : 0.50;\r\n            }\r\n\r\n            .form-control {\r\n                height       : 40px;\r\n                padding-left : 35px;\r\n                font-size    : 14px;\r\n                border       : 1px solid rgba($black-color, 0.1);\r\n                border-radius: 8px;\r\n                color        : rgba($black-color, 0.70);\r\n            }\r\n        }\r\n\r\n        .dropdown {\r\n            button {\r\n                background     : transparent;\r\n                height         : 40px;\r\n                font-size      : 14px;\r\n                border         : 1px solid rgba($black-color, 0.1);\r\n                border-radius  : 8px;\r\n                color          : rgba($black-color, 0.50);\r\n                padding        : 0px 12px;\r\n                min-width      : 200px;\r\n                display        : flex;\r\n                align-items    : center;\r\n                justify-content: space-between;\r\n\r\n                &:after {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        .resources-heading {\r\n            @media only screen and (max-width:991.98px) {\r\n                margin-bottom: 1rem !important;\r\n            }\r\n\r\n            span {\r\n                height         : 34px;\r\n                background     : rgba($primary-color, 0.10);\r\n                color          : $primary-color;\r\n                display        : inline-flex;\r\n                align-items    : center;\r\n                justify-content: center;\r\n                min-width      : 118px;\r\n                padding        : 0px 15px;\r\n                border-radius  : 5px;\r\n                margin-bottom  : 10px;\r\n                font-size      : 16px;\r\n                font-weight    : 600;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n\r\n            h1 {\r\n                font-size  : 32px;\r\n                color      : $black-color;\r\n                font-weight: 700;\r\n\r\n                @media only screen and (max-width:991.98px) {\r\n                    font-size: 28px;\r\n                }\r\n            }\r\n        }\r\n     \r\n        .resources-content {\r\n            \r\n            .table-less-format {\r\n                li {\r\n                        padding-left: 0px !important;\r\n                        padding-bottom: 0px !important;\r\n                    }\r\n            }\r\n           \r\n            .map-resources {\r\n                text-align   : center;\r\n                padding      : 30px;\r\n                box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n                border-radius: 14px;\r\n            }\r\n\r\n            .searchfaq {\r\n                svg {\r\n                    position: absolute;\r\n                    top     : 15px;\r\n                    left    : 15px;\r\n                    opacity : 0.50;\r\n                }\r\n\r\n                .form-control {\r\n                    height       : 45px;\r\n                    border-radius: 8px;\r\n                    border       : 1px solid rgba($black-color, 0.1);\r\n                    padding-left : 40px;\r\n                }\r\n            }\r\n\r\n            h2 {\r\n                font-size     : 22px;\r\n                color         : $black-color;\r\n                font-weight   : 700;\r\n                margin-bottom : 15px;\r\n                text-transform: capitalize;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n\r\n            p {\r\n                font-size  : 16px;\r\n                color      : $paragraph-color;\r\n                line-height: 1.75;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n\r\n                a {\r\n                    color          : $primary-color;\r\n                    text-decoration: none;\r\n                    font-weight    : 600;\r\n                }\r\n            }\r\n            li {\r\n                font-size  : 16px;\r\n                color      : $paragraph-color;\r\n                line-height: 1.75;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 14px;\r\n                }\r\n\r\n                a {\r\n                    color          : $primary-color;\r\n                    text-decoration: none;\r\n                    font-weight    : 600;\r\n                }\r\n            }\r\n\r\n            .resources-alerts {\r\n                background   : rgba($primary-color, 0.07);\r\n                padding      : 11px 15px;\r\n                border-radius: 6px;\r\n\r\n                p {\r\n                    font-size: 13px;\r\n                    color    : rgba($black-color, 0.60);\r\n\r\n                    svg {\r\n                        color       : $primary-color;\r\n                        font-size   : 16px;\r\n                        min-width   : 16px;\r\n                        display     : inline-flex;\r\n                        align-items : flex-start;\r\n                        margin-right: 10px;\r\n                    }\r\n\r\n                    span {\r\n                        color: $black-color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            ul {\r\n                li {\r\n                    font-size   : 16px;\r\n                    color       : $paragraph-color;\r\n                    line-height : 1.75;\r\n                    padding-left: 25px;\r\n                    position    : relative;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 14px;\r\n                    }\r\n\r\n                    svg {\r\n                        color       : $primary-color;\r\n                        font-size   : 18px;\r\n                        min-width   : 18px;\r\n                        margin-right: 10px;\r\n                        position    : absolute;\r\n                        left        : 0px;\r\n                        top         : 5px;\r\n                    }\r\n\r\n                    b {\r\n                        margin-right: 5px;\r\n                    }\r\n\r\n                    &:not(:last-child) {\r\n                        padding-bottom: 10px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .accordion {\r\n        .accordion-item {\r\n            border       : none;\r\n            border-radius: 12px;\r\n            box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n            margin-bottom: 15px;\r\n\r\n            .accordion-header {\r\n                button {\r\n                    &.accordion-button {\r\n                        padding                      : 15px;\r\n                        background                   : $white-color;\r\n                        box-shadow                   : none;\r\n                        font-size                    : 18px;\r\n                        color                        : $black-color;\r\n                        font-weight                  : 600;\r\n                        --bs-accordion-btn-icon-width: 1rem;\r\n\r\n                        &::after {\r\n                            transform       : rotate(-90deg);\r\n                            background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23000000' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M2 5L8 11L14 5'/%3e%3c/svg%3e\");\r\n                        }\r\n\r\n                        &:not(.collapsed) {\r\n                            &:after {\r\n                                transform: rotate(0);\r\n                            }\r\n                        }\r\n\r\n                        .accordion-icon {\r\n                            width          : 38px;\r\n                            height         : 38px;\r\n                            border-radius  : 50%;\r\n                            display        : inline-flex;\r\n                            align-items    : center;\r\n                            justify-content: center;\r\n                            background     : rgba($primary-color, 0.06);\r\n                            border         : 1px solid rgba($primary-color, 0.13);\r\n                            margin-right   : 11px;\r\n\r\n                            svg {\r\n                                color    : $primary-color;\r\n                                font-size: 18px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .accordion-body {\r\n                padding-left: 65px;\r\n                padding-top : 0px;\r\n\r\n                a {\r\n                    display        : flex;\r\n                    padding-bottom : 12px;\r\n                    text-decoration: none;\r\n                    font-size      : 15px;\r\n                    color          : $paragraph-color;\r\n                    align-items    : center;\r\n\r\n                    .maticon {\r\n                        width        : 17px;\r\n                        height       : 17px;\r\n                        border-radius: 4px;\r\n                        margin-right : 10px;\r\n                    }\r\n\r\n                    img {\r\n                        margin-right: 10px;\r\n                        min-width   : 17px;\r\n                    }\r\n\r\n                    svg {\r\n                        margin-right: 10px;\r\n                        font-size   : 18px;\r\n                        min-width   : 18px;\r\n                    }\r\n\r\n                    &.active {\r\n                        font-weight: 500;\r\n                    }\r\n\r\n                    &.active,\r\n                    &:hover {\r\n                        color: $primary-color;\r\n\r\n\r\n\r\n                        img {\r\n\r\n\r\n                            &.defaulticon {\r\n                                display: none;\r\n                            }\r\n\r\n                            &.activeicon {\r\n                                display: inline-flex !important;\r\n                            }\r\n\r\n                        }\r\n\r\n\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-table {\r\n    &::-webkit-scrollbar {\r\n        height: 5px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background: #c5c4c4;\r\n    }\r\n\r\n    .rdt_TableHead {\r\n        .rdt_TableHeadRow {\r\n            background    : #FAFAFA;\r\n            border-radius : 10px;\r\n            margin        : 5px 0;\r\n            padding-bottom: 10px;\r\n            padding-top   : 10px;\r\n            min-height    : 60px;\r\n            border        : 1px solid rgba($black-color, 0.10);\r\n\r\n            .rdt_TableCol {\r\n                padding    : 0px 12px;\r\n                font-weight: 500;\r\n                color      : $black-color;\r\n\r\n                [role=\"columnheader\"] {\r\n                    div {\r\n                        white-space: normal;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .rdt_TableBody {\r\n        .rdt_TableRow {\r\n            background   : $white-color;\r\n            border       : 1px solid rgba($black-color, 0.10);\r\n            border-radius: 10px;\r\n            margin       : 5px 0;\r\n            min-height   : 60px;\r\n\r\n            .rdt_TableCell {\r\n                padding: 10px 12px;\r\n                color  : $paragraph-color;\r\n\r\n                div {\r\n                    white-space: normal;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.custom-table2 {\r\n        .rdt_TableHead {\r\n            .rdt_TableHeadRow {\r\n                .rdt_TableCol {\r\n                    font-size  : 14px;\r\n                    font-weight: 600;\r\n                    color      : $black-color;\r\n                }\r\n            }\r\n\r\n        }\r\n\r\n        .rdt_TableBody {\r\n            .rdt_TableRow {\r\n                .rdt_TableCell {\r\n                    div {\r\n                        .badgestatus {\r\n                            font-weight  : 600;\r\n                            min-width    : 95px;\r\n                            border-radius: 4px;\r\n                            text-align   : center;\r\n                        }\r\n                        .custom_badgess .badgestatus {\r\n                            font-size      : 10px;\r\n                            border-radius  : 30px;\r\n                            min-width      : 62px;\r\n                            display        : inline-flex;\r\n                            align-items    : center;\r\n                            justify-content: center;\r\n                            color          : $white-color;\r\n                            padding: 0 9px;\r\n                            height: 25px;\r\n                            line-height: 25px;\r\n                        }\r\n                    }\r\n\r\n                    &:last-child {\r\n                        div {\r\n                            display    : inline-flex;\r\n                            align-items: center;\r\n\r\n                            .btnpay {\r\n                                height         : 35px;\r\n                                display        : inline-flex;\r\n                                background     : transparent;\r\n                                width          : 50px;\r\n                                align-items    : center;\r\n                                justify-content: center;\r\n                                border-radius  : 40px;\r\n                                color          : $primary-color;\r\n                                text-decoration: none;\r\n                                margin         : 3px;\r\n                                border         : 1px solid $primary-color;\r\n\r\n                                &:hover {\r\n                                    background: $primary-color;\r\n                                    color     : $white-color;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .btnview {\r\n            width          : 35px;\r\n            height         : 35px;\r\n            background     : $primary-color;\r\n            border-radius  : 50%;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            color          : $white-color;\r\n            font-size      : 18px;\r\n            margin         : 3px;\r\n\r\n            &:hover {\r\n                opacity: 0.75;\r\n            }\r\n        }\r\n\r\n        .btnreorder {\r\n            width          : 35px;\r\n            height         : 35px;\r\n            background     : $secondary-color;\r\n            border-radius  : 50%;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            color          : $white-color;\r\n            font-size      : 18px;\r\n            margin         : 3px;\r\n\r\n            &:hover {\r\n                opacity: 0.75;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.badgematerials {\r\n    span {\r\n        width        : 7px;\r\n        height       : 7px;\r\n        border-radius: 50%;\r\n        display      : inline-flex;\r\n        margin-right : 7px;\r\n    }\r\n}\r\n\r\n/*Rescources Css Ends*/\r\n/*Orders Css Start*/\r\n.ptb-50 {\r\n    padding-top   : 50px;\r\n    padding-bottom: 50px;\r\n}\r\n\r\n.card {\r\n    background   : $white-color;\r\n    border-radius: 14px !important;\r\n    box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n    border       : none !important;\r\n\r\n    .card-header {\r\n        background    : $white-color !important;\r\n        padding-top   : 20px;\r\n        padding-bottom: 20px;\r\n        border-bottom : 1px solid rgba($black-color, 0.1);\r\n        border-radius : 14px 14px 0px 0px !important;\r\n\r\n        h5 {\r\n            margin-bottom: 0;\r\n            font-weight  : 600;\r\n            font-size    : 22px;\r\n            color        : $black-color;\r\n        }\r\n    }\r\n\r\n    .card-body {\r\n       \r\n        .tablelist {\r\n            li {\r\n                color          : $paragraph-color;\r\n                display        : inline-flex;\r\n                font-size      : 14px;\r\n                justify-content: space-between;\r\n\r\n                &:not(:last-child) {\r\n                    border-right : 1px solid rgba($black-color, .1);\r\n                    margin-bottom: 10px;\r\n                    margin-right : 15px;\r\n                    padding-right: 15px;\r\n                }\r\n\r\n                span {\r\n                    font-weight: 600;\r\n                    margin-left: 15px;\r\n                }\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 12px;\r\n                }\r\n            }\r\n\r\n            .badge-status {\r\n                background-color: rgba(1, 148, 60, 0.1);\r\n                color           : #01943C;\r\n                padding         : 2px 6px 0;\r\n                font-weight     : 500;\r\n                min-width       : 80px;\r\n                border-radius   : 4px;\r\n                text-align      : center;\r\n                font-size       : 12px;\r\n            }\r\n        }\r\n\r\n        .table-responsive {\r\n            &::-webkit-scrollbar {\r\n                height: 5px;\r\n            }\r\n\r\n            &::-webkit-scrollbar-thumb {\r\n                background: #c5c4c4;\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n.rdt_Pagination {\r\n    border: none !important;\r\n}\r\n\r\n.no-cart {\r\n    img {\r\n        height: 124px;\r\n    }\r\n\r\n    h3 {\r\n        font-size  : 28px;\r\n        color      : $black-color;\r\n        font-weight: bold;\r\n        margin-top : 15px;\r\n    }\r\n}\r\n\r\n.orders-upload-file {\r\n    max-width: 830px;\r\n    margin   : 0 auto;\r\n    width    : 100%;\r\n\r\n    h5 {\r\n        color      : $paragraph-color;\r\n        font-size  : 18px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n\r\n.table {\r\n    &.tablecustom {\r\n        border-collapse: initial;\r\n        border-spacing : 0 .75em;\r\n        margin-bottom  : 0;\r\n\r\n        thead {\r\n            tr {\r\n                th {\r\n                    &:first-child {\r\n                        border-left  : 1px solid rgba($black-color, .1);\r\n                        border-radius: 16px 0 0 16px;\r\n                    }\r\n\r\n                    .form-check-input {\r\n                        width : 22px;\r\n                        height: 22px;\r\n                        border-color:rgba($black-color, .30);\r\n                        box-shadow: none;\r\n                        &:checked {\r\n                            background-color: $black-color;\r\n                            border-color    : $black-color;\r\n                        }\r\n                    }\r\n                    &:last-child {\r\n                        border-radius: 0 16px 16px 0;\r\n                        border-right : 1px solid rgba($black-color, .1);\r\n                    }\r\n\r\n                    background-color:#FAFAFA;\r\n                    border          : 1px solid rgba($black-color, .1);\r\n                    border-left     : none;\r\n                    border-right    : none;\r\n                    color           : $black-color;\r\n                    font-size       : 14px;\r\n                    font-weight     : 600;\r\n                    height          :60px;\r\n                    padding         : 15px 15px;\r\n                    vertical-align  : middle;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 12px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        tbody {\r\n            tr {\r\n                td {\r\n                    &:first-child {\r\n                        border-left  : 1px solid rgba($black-color, .1);\r\n                        border-radius: 16px 0 0 16px;\r\n                    }\r\n\r\n                    &:last-child {\r\n                        border-radius: 0 16px 16px 0;\r\n                        border-right : 1px solid rgba($black-color, .1);\r\n                    }\r\n\r\n                    border         : 1px solid rgba($black-color, .1);\r\n                    border-left    : none;\r\n                    border-right   : none;\r\n                    color          : $paragraph-color;\r\n                    font-size      : 14px;\r\n                    font-weight    : 400;\r\n                    height         :60px;\r\n                    padding        : 15px 15px;\r\n                    vertical-align : middle;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 12px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.totaltable {\r\n    p {\r\n        color          : $paragraph-color;\r\n        display        : flex;\r\n        font-size      : 16px;\r\n        font-weight    : 400;\r\n        justify-content: space-between;\r\n\r\n        @media only screen and (max-width:1199.98px) {\r\n            font-size: 14px;\r\n        }\r\n\r\n        &.grandtotal {\r\n            font-size    : 20px;\r\n            font-weight  : 600;\r\n            margin-bottom: 0;\r\n            border-top   : 1px dashed rgba($black-color, .2);\r\n            padding-top  : 15px;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Orders Css Ends*/\r\n/*My Profile Css Start*/\r\n\r\n.min-width-159 {\r\n    min-width: 159px;\r\n    max-width: 159px;\r\n}\r\n\r\ntextarea.form-control {\r\n    border-radius: 12px;\r\n    border       : 1px solid rgba($black-color, 0.15);\r\n    color        : rgba($black-color, 0.70);\r\n    padding-left : 20px;\r\n    padding-right: 20px;\r\n    padding-top  : 10px;\r\n    font-size    : 14px;\r\n    font-weight  : 400;\r\n    resize       : none;\r\n}\r\n\r\n.accountform {\r\n    .form-group {\r\n        .form-label {\r\n            font-size  : 14px;\r\n            font-weight: 500;\r\n            color      : $black-color;\r\n\r\n            span {\r\n                opacity: 0.30;\r\n            }\r\n        }\r\n        .paymentCard_border {\r\n            border-radius: 12px;\r\n            border: 1px solid rgba($black-color, .15);\r\n            padding-left: 20px;\r\n            padding-top: 10px;\r\n            padding-bottom: 10px;\r\n            padding-right: 20px;\r\n        }\r\n        .react-tel-input {\r\n            .form-control {\r\n                padding-left: 50px !important;\r\n            }\r\n\r\n            .flag-dropdown {\r\n                border       : none;\r\n                background   : transparent;\r\n                border-radius: 0px;\r\n\r\n                .selected-flag {\r\n                    padding      : 0 0 0 15px;\r\n                    border-radius: 0px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .password-input-group {\r\n            svg {\r\n                position: absolute;\r\n                top     : 12px;\r\n                right   : 10px;\r\n                opacity : 0.30;\r\n                color: $black-color;\r\n            }\r\n        }\r\n\r\n        .form-control,\r\n        .form-select {\r\n            height       : 50px;\r\n            border-radius: 12px;\r\n            border       : 1px solid rgba($black-color, 0.15);\r\n            color        : rgba($black-color, 0.70);\r\n            padding-left : 20px;\r\n            padding-right: 20px;\r\n            font-size    : 14px;\r\n            font-weight  : 400;\r\n\r\n            &[type=\"password\"] {\r\n                padding-right: 50px;\r\n            }\r\n\r\n            &:focus {\r\n                box-shadow: none;\r\n            }\r\n\r\n            &::placeholder {\r\n                opacity: 0.50;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n}\r\n\r\n.profile_user_main {\r\n    border-radius: 15px;\r\n    background   : $white-color;\r\n    padding      : 30px 20px;\r\n    border       : 1px solid rgba($black-color, .1);\r\n    box-shadow   : 0px 0px 10px rgba($black-color, 0.08);\r\n\r\n    .user_info {\r\n        display: inline-block;\r\n\r\n        img {\r\n            width     : 124px;\r\n            height    : 124px;\r\n            object-fit: scale-down;\r\n            border    : 5px solid $white-color;\r\n            box-shadow: 0px 0px 10px rgba($black-color, 0.15);\r\n        }\r\n\r\n        margin-bottom: 15px;\r\n\r\n        .form-label {\r\n            width          : 34px;\r\n            height         : 34px;\r\n            margin-bottom  : 0;\r\n            background     : $primary-color;\r\n            color          : $white-color;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            border-radius  : 50%;\r\n            position       : absolute;\r\n            bottom         : 0px;\r\n            right          : 8px;\r\n        }\r\n    }\r\n\r\n    h4 {\r\n        font-size    : 20px;\r\n        color        : $black-color;\r\n        font-weight  : 600;\r\n        margin-bottom: 4px;\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 0;\r\n        font-size    : 16px;\r\n        color        : $paragraph-color;\r\n    }\r\n}\r\n\r\n/*My Profile Css Ends*/\r\n/*Change Password Css Start*/\r\n.modal-custom {\r\n    &.max-width-574 {\r\n        .modal-dialog {\r\n            max-width: 574px;\r\n        }\r\n    }\r\n    .notesmain{\r\n        max-height: 370px;\r\n        overflow-y: auto;\r\n        &::-webkit-scrollbar {\r\n            width: 6px;\r\n          }\r\n          &::-webkit-scrollbar-thumb {\r\n            background: #ccc;\r\n          }\r\n        .notescont {\r\n            box-shadow: 0px 0px 10px rgba($black-color, 0.07);\r\n            padding: 16px;\r\n            font-size: 13px;\r\n            color: rgba($black-color, 0.50);\r\n            display: flex;\r\n            margin-bottom: 14px;\r\n            border-radius: 12px;\r\n            border: 1px solid rgba($black-color, 0.15);\r\n            a{\r\n                color: $black-color;\r\n                font-size: 14px;\r\n                min-width: 23px;\r\n                text-align: end;\r\n            }\r\n        }\r\n    }\r\n    \r\n    .modal-dialog {\r\n        \r\n        .modal-content {\r\n            border-radius: 20px;\r\n            \r\n            .modal-header {\r\n                .modal-title {\r\n                    font-size  : 24px;\r\n                    color      : $black-color;\r\n                    font-weight: bold;\r\n                }\r\n\r\n                .btn-close {\r\n                    width              : 28px;\r\n                    height             : 28px;\r\n                    background-color   : $primary-color;\r\n                    border-radius      : 50%;\r\n                    padding            : 0 !important;\r\n                    background-size    : 10px;\r\n                    background-position: center;\r\n                    opacity            : 1;\r\n                    position           : absolute;\r\n                    top                : -4px;\r\n                    right              : -2px;\r\n                    background-image   : url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Change Password Css Ends*/\r\n/*My Addresses Css Start*/\r\n.addresses-grid {\r\n    border       : 1px solid rgba($black-color, .1);\r\n    border-radius: 15px;\r\n    padding      : 20px;\r\n    background   : $white-color;\r\n    box-shadow   : 0px 0px 10px rgba($black-color, 0.08);\r\n    height       : 100%;\r\n    min-height   : 237px;\r\n\r\n    h2 {\r\n        font-size  : 20px;\r\n        color      : $black-color;\r\n        font-weight: 600;\r\n    }\r\n\r\n    span {\r\n        &.statusdefault {\r\n            min-width    : 80px;\r\n            height       : 35px;\r\n            padding      : 0px 10px;\r\n            background   : $black-color;\r\n            color        : $white-color;\r\n            font-size    : 14px;\r\n            text-align   : center;\r\n            line-height  : 35px;\r\n            border-radius: 30px;\r\n        }\r\n\r\n    }\r\n\r\n    p {\r\n        font-size  : 16px;\r\n        color      : $paragraph-color;\r\n        line-height: 1.75;\r\n    }\r\n\r\n    .btn-bottom {\r\n        display    : flex;\r\n        align-items: center;\r\n        gap        : 10px;\r\n\r\n        a {\r\n            width          : 36px;\r\n            height         : 36px;\r\n            border         : 1px solid $black-color;\r\n            color          : $black-color;\r\n            border-radius  : 6px;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            text-decoration: none;\r\n\r\n            &.btn-set-default {\r\n                min-width: 121px;\r\n                padding  : 0px 10px;\r\n                font-size: 14px;\r\n            }\r\n\r\n            &:hover {\r\n                background: $black-color;\r\n                color     : $white-color\r\n            }\r\n        }\r\n    }\r\n\r\n    &.payment-grids {\r\n        .card-no {\r\n            font-size     : 20px;\r\n            margin        : 15px 0px 15px;\r\n            letter-spacing: 3px;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                letter-spacing: 0;\r\n            }\r\n        }\r\n\r\n        .card-actions {\r\n            display        : flex;\r\n            justify-content: space-between;\r\n            margin-bottom  : 25px;\r\n\r\n            .card-info {\r\n                color    : $paragraph-color;\r\n                font-size: 14px;\r\n\r\n                strong {\r\n                    display    : block;\r\n                    font-weight: 500;\r\n                    color      : $black-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.scroll_cards {\r\n    max-height: 255px;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    scrollbar-width: none;\r\n    &::-webkit-scrollbar {\r\n        display: none;\r\n    }\r\n}\r\n#saveCardCheckbox{\r\n    border: 1px solid #000;\r\n}\r\n.paymentSelectCard {\r\n    cursor: pointer;\r\n    width: 100%;\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\ngap:12px;\r\n    input:checked {\r\n        ~ {\r\n            .paymentSelectbox {\r\n              \r\n                border: 1px solid $primary-color;\r\n                // background: $primary-color;\r\n                // p , .card-info {\r\n                //     color: $white-color;\r\n                // }\r\n            } \r\n        }\r\n    }\r\n    .paymentSelectbox {\r\n        border       : 1px solid rgba($black-color, .1);\r\n        border-radius: 12px;\r\n        padding      : 8px 15px;\r\n        flex-grow: 1;\r\n        background   : $white-color;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.08);\r\n        height       : 100%; \r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        gap: 10px;\r\n        p {\r\n            font-size  : 14px;\r\n            color      : $paragraph-color;\r\n            line-height: 1.75;\r\n            margin-bottom: 0px;\r\n        } \r\n        .card-info {\r\n            color    : $paragraph-color;\r\n            font-size: 14px;\r\n        }             \r\n    }\r\n}\r\n.addresses-grids {\r\n    border       : 1px solid rgba($black-color, .1);\r\n    border-radius: 15px;\r\n    padding      : 20px;\r\n    background   : $white-color;\r\n    box-shadow   : 0px 0px 10px rgba($black-color, 0.08);\r\n    height       : 100%;\r\n    // min-height   : 237px;\r\n\r\n    h2 {\r\n        font-size  : 20px;\r\n        color      : $black-color;\r\n        font-weight: 600;\r\n    }\r\n\r\n    span {\r\n        &.statusdefault {\r\n            min-width    : 80px;\r\n            height       : 35px;\r\n            padding      : 0px 10px;\r\n            background   : $black-color;\r\n            color        : $white-color;\r\n            font-size    : 14px;\r\n            text-align   : center;\r\n            line-height  : 35px;\r\n            border-radius: 30px;\r\n        }\r\n\r\n    }\r\n\r\n    p {\r\n        font-size  : 16px;\r\n        color      : $paragraph-color;\r\n        line-height: 1.75;\r\n    }\r\n\r\n    .btn-bottom {\r\n        display    : flex;\r\n        align-items: center;\r\n        gap        : 10px;\r\n\r\n        a {\r\n            width          : 36px;\r\n            height         : 36px;\r\n            border         : 1px solid $black-color;\r\n            color          : $black-color;\r\n            border-radius  : 6px;\r\n            display        : inline-flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            text-decoration: none;\r\n\r\n            &.btn-set-default {\r\n                min-width: 121px;\r\n                padding  : 0px 10px;\r\n                font-size: 14px;\r\n            }\r\n\r\n            &:hover {\r\n                background: $black-color;\r\n                color     : $white-color\r\n            }\r\n        }\r\n    }\r\n\r\n    &.payment-grids {\r\n        .card-no {\r\n            font-size     : 20px;\r\n            margin        : 15px 0px 15px;\r\n            letter-spacing: 3px;\r\n\r\n            @media only screen and (max-width:991.98px) {\r\n                letter-spacing: 0;\r\n            }\r\n        }\r\n\r\n        .card-actions {\r\n            display        : flex;\r\n            justify-content: space-between;\r\n            margin-bottom  : 25px;\r\n\r\n            .card-info {\r\n                color    : $paragraph-color;\r\n                font-size: 14px;\r\n\r\n                strong {\r\n                    display    : block;\r\n                    font-weight: 500;\r\n                    color      : $black-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*My Addresses Css Ends*/\r\n/*Quotes Css Start*/\r\n.quotes-head {\r\n    margin-bottom: 0;\r\n    font-weight  : bold;\r\n    font-size    : 34px;\r\n    color        : $black-color;\r\n\r\n    @media only screen and (max-width:1199.98px) {\r\n        font-size: 28px;\r\n    }\r\n}\r\n\r\n.quotes-list {\r\n    display       : flex;\r\n    align-items   : center;\r\n    border-bottom : 1px solid rgba($black-color, .1);\r\n    padding-bottom: 25px;\r\n    margin-bottom : 25px;\r\n\r\n    .quotes-img {\r\n        width          : 154px;\r\n        height         : 160px;\r\n        background     : $white-color;\r\n        box-shadow     : 0px 0px 10px rgba($black-color, .1);\r\n        border-radius  : 12px;\r\n        display        : flex;\r\n        align-items    : center;\r\n        justify-content: center;\r\n        flex-shrink    : 0;\r\n\r\n        img {\r\n            object-fit: contain;\r\n            max-width: 100px;\r\n            height: 120px;\r\n        }\r\n    }\r\n\r\n    .quotes-content {\r\n        flex-grow: 1;\r\n\r\n        h2 {\r\n            font-size   : 20px;\r\n            font-weight : bold;\r\n            color       : $black-color;\r\n            margin-right: 9px;\r\n        }\r\n\r\n        .quotes-date {\r\n            font-size: 16px;\r\n            color    : $black-color;\r\n        }\r\n\r\n        p {\r\n            font-size  : 16px;\r\n            color      : rgba($black-color, 0.50);\r\n            font-weight: 500;\r\n\r\n            span {\r\n                color: $black-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Quotes Css Ends*/\r\n/*Quotes Detail Css Start*/\r\n.list-quotes-main {\r\n    border-bottom : 1px solid rgba($black-color, .1);\r\n    padding-bottom: 20px;\r\n    margin-bottom : 20px;\r\n    transition: all 0.3s ease;\r\n\r\n    &.part-focused {\r\n        background-color: rgba(13, 110, 253, 0.1) !important;\r\n        border: 2px solid #0d6efd !important;\r\n        border-radius: 8px;\r\n        padding: 18px;\r\n        margin: 18px 0;\r\n        box-shadow: 0 0 10px rgba(13, 110, 253, 0.2);\r\n    }\r\n.quanityCount_btn {\r\n    b {\r\n        font-size: 14px;\r\n        align-self: center;\r\n        margin-top: 0px !important;\r\n    }\r\n}\r\n    .input-group {\r\n        max-width: 110px;\r\n\r\n        .form-control {\r\n            border     : none;\r\n            font-size  : 14px;\r\n            font-weight: bold;\r\n            padding    : 0px;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        button {\r\n            width        : 32px;\r\n            height       : 32px;\r\n            border       : 1px solid $black-color;\r\n            border-radius: 6px !important;\r\n            padding      : 0px !important;\r\n\r\n            svg {\r\n                font-size: 18px;\r\n                color    : $black-color;\r\n\r\n                @media only screen and (max-width:767.98px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                background: $black-color;\r\n\r\n                svg {\r\n                    color: $white-color\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .list-quotes {        \r\n        .img-quote {\r\n            flex-shrink    : 0;\r\n            width          : 154px;\r\n            height         : 160px;\r\n            border-radius  : 12px;\r\n            background     : $white-color;\r\n            box-shadow     : 0px 0px 10px rgba($black-color, 0.07);\r\n            display        : flex;\r\n            align-items    : center;\r\n            justify-content: center;\r\n            .bublenumber {\r\n                position: absolute;\r\n                top: -10px;\r\n                left: -14px;\r\n                background: #98c1eb;\r\n                display: inline-block;\r\n                border-radius: 10px;\r\n                font-size: 12px;\r\n                font-weight: 400;\r\n                color: #000;\r\n                padding: 2px 7px;\r\n            }\r\n            img {\r\n                width: 154px;\r\n                height: 160px;\r\n                object-fit: scale-down;\r\n                padding: 10px;\r\n            }\r\n\r\n        }\r\n\r\n        .right-quote {\r\n            .quote-off {\r\n                border         : 1px solid #E6E6E6;\r\n                border-radius  : 4px;\r\n                color          : rgba($black-color, .50);\r\n                min-width      : 63px;\r\n                height         : 33px;\r\n                display        : inline-flex;\r\n                align-items    : center;\r\n                justify-content: center;\r\n                font-size      : 12px;\r\n                font-weight    : 600;\r\n                margin-bottom  : 10px;\r\n                padding        : 0px 7px;\r\n                background-color: rgba(1, 148, 60, 0.1);\r\n                color: rgb(1, 148, 60);\r\n            }\r\n\r\n            p {\r\n                font-size    : 12px;\r\n                color        : rgba($black-color, .50);\r\n                margin-bottom: 10px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 11px;\r\n                }\r\n\r\n                &.quotes-date {\r\n                    font-size: 13px;\r\n                    color    : $black-color;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 11px;\r\n                    }\r\n                }\r\n\r\n                .quotes-price {\r\n                    color    : $primary-color;\r\n                    font-size: 14px;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 13px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .content-quotes {\r\n            flex-grow: 1;\r\n            .DragItemPost_div {\r\n                display: inline-flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                .DragItemPostOps_btn {\r\n                    background: #ff8cd3;\r\n                    color: #000;\r\n                    font-size: 14px;\r\n                    font-weight: 600;\r\n                    padding: 8px 12px;\r\n                    line-height: normal;\r\n                    border-radius: 10px;\r\n                    margin-bottom: 10px;\r\n                }\r\n                .DragItemPostPlus_btn {\r\n                    width: 30px;\r\n                    height: 30px;\r\n                    border-radius: 50%;\r\n                    display: inline-flex;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    color: #000;\r\n                    border: 1px solid #000;\r\n                    padding: 0px;\r\n                    font-size: 20px;\r\n                }\r\n                .DragItemPost_box {\r\n                    // Base styles unified in main definition (see .postOpsTagCheckbox_box)\r\n                    // Only close button styling here\r\n                    button.DragItemPostClose_btn.btn {\r\n                        position: absolute;\r\n                        top: -8px;\r\n                        right: -5px;\r\n                        padding: 0;\r\n                        border: 0;\r\n                        font-size: 14px;\r\n                        color: #000;\r\n                    }\r\n                }\r\n            }\r\n            h2 {\r\n                font-size  : 20px;\r\n                color      : $black-color;\r\n                font-weight: bold;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n\r\n            .selectdropdown {\r\n                &>div {\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 11px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .num-dim-main {\r\n                font-size    : 13px;\r\n                font-weight  : 500;\r\n                margin-bottom: 10px;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 11px;\r\n                }\r\n\r\n                .num-dim-indicator {\r\n                    color: rgba($black-color, .50)\r\n                }\r\n\r\n                .num-dim {\r\n                    display    : inline-flex;\r\n                    align-items: center;\r\n                    flex-wrap  : wrap;\r\n\r\n                    span {\r\n                        color       : rgba($black-color, .50);\r\n                        margin-right: 5px;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .quotes-dropdown {\r\n                gap      : 8px;\r\n                flex-wrap: wrap;\r\n            }\r\n\r\n            .quotes-services {\r\n                @media only screen and (max-width:767.98px) {\r\n                    margin-bottom: 10px;\r\n                }\r\n\r\n                label {\r\n                    font-size: 13px;\r\n                    color    : rgba($black-color, 0.5);\r\n                }\r\n\r\n                h4 {\r\n                    font-size: 14px;\r\n                    color    : $black-color;\r\n\r\n                    @media only screen and (max-width:1199.98px) {\r\n                        font-size: 13px;\r\n                    }\r\n                }\r\n\r\n                .form-check {\r\n                    padding-left: 0;\r\n\r\n                    .form-check-input {\r\n                        margin: 0 5px 0 0;\r\n                        border:0.9px solid #000;\r\n\r\n                        &:checked {\r\n                            background-color: $primary-color;\r\n                            border-color    : $primary-color;\r\n                        }\r\n                    }\r\n\r\n                    label {\r\n                        font-size: 13px;\r\n                        color    : rgba($black-color, 0.8);\r\n                        font-weight: 500;\r\n\r\n                        @media only screen and (max-width:1199.98px) {\r\n                            font-size: 11px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.btnsavelater {\r\n    height         : 36px;\r\n    min-width      : 121px;\r\n    border         : 1px solid $black-color;\r\n    background     : $black-color;\r\n    color          : $white-color;\r\n    border-radius  : 6px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n    font-size      : 14px;\r\n    font-weight    : 500;\r\n    text-decoration: none;\r\n\r\n    &:hover {\r\n        background: transparent;\r\n        color     : $black-color\r\n    }\r\n\r\n}\r\n\r\n.btnshare {\r\n    height         : 36px;\r\n    min-width      : 121px;\r\n    border         : 1px solid $black-color;\r\n    border-radius  : 6px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n    color          : $black-color;\r\n    font-size      : 14px;\r\n    font-weight    : 500;\r\n    text-decoration: none;\r\n\r\n    &:hover {\r\n        background: $black-color;\r\n        color     : $white-color\r\n    }\r\n}\r\n.btnicons {\r\n    font-size: 14px;\r\n    color: #000;\r\n    cursor: pointer;\r\n}\r\n.btnicon {\r\n    width          : 36px;\r\n    height         : 36px;\r\n    border         : 1px solid $black-color;\r\n    border-radius  : 6px;\r\n    display        : inline-flex;\r\n    align-items    : center;\r\n    justify-content: center;\r\n\r\n    svg {\r\n        font-size: 20px;\r\n        color    : $black-color;\r\n\r\n        @media only screen and (max-width:767.98px) {\r\n            font-size: 16px;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        background: $black-color;\r\n\r\n        svg {\r\n            color: $white-color\r\n        }\r\n    }\r\n}\r\n\r\n.quotes-sidebar {\r\n    .order-cont-btm {\r\n        font-size    : 13px;\r\n        text-align   : center;\r\n        color        : rgba($black-color, .50);\r\n        margin-bottom: 0;\r\n        font-weight  : 500;\r\n\r\n        b {\r\n            color      : $primary-color;\r\n            font-weight: bold;\r\n        }\r\n    }\r\n\r\n    .quotes-inner {\r\n        border-radius: 16px;\r\n        background   : $white-color;\r\n        box-shadow   : 0px 0px 10px rgba($black-color, 0.07);\r\n        padding      : 20px;\r\n\r\n        .quotes-login {\r\n\r\n            p {\r\n                font-weight: 600;\r\n                font-size  : 13px;\r\n                color      : $black-color;\r\n            }\r\n        }\r\n\r\n        .order-cont {\r\n            font-size    : 13px;\r\n            text-align   : center;\r\n            color        : rgba($black-color, .50);\r\n            margin-bottom: 0;\r\n\r\n            b {\r\n                color: $black-color\r\n            }\r\n        }\r\n\r\n        .head-quotes {\r\n            margin-bottom: 20px;\r\n\r\n            h2 {\r\n                font-size  : 24px;\r\n                color      : $black-color;\r\n                font-weight: bold;\r\n\r\n                @media only screen and (max-width:1199.98px) {\r\n                    font-size: 20px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .quotesitem {\r\n            font-size  : 16px;\r\n            color      : $paragraph-color;\r\n            font-weight: 600;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 14px;\r\n            }\r\n\r\n            &.quotesright {\r\n                font-weight: 400;\r\n            }\r\n        }\r\n\r\n        .quotessubtotal {\r\n            font-size  : 20px;\r\n            color      : $paragraph-color;\r\n            font-weight: 600;\r\n\r\n            @media only screen and (max-width:1199.98px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n\r\n        .quotes-separator {\r\n            border-top: 1px dashed rgba($black-color, 0.20);\r\n            opacity   : 1;\r\n        }\r\n\r\n        .quotesprice {\r\n            font-size  : 20px;\r\n            color      : $primary-color;\r\n            font-weight: 700;\r\n\r\n            @media only screen and (max-width:767.98px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n\r\n        .accountform {\r\n            .form-group {\r\n                .form-label {\r\n                    font-size    : 13px;\r\n                    margin-bottom: 3px;\r\n                }\r\n\r\n                .form-control,\r\n                .form-select {\r\n                    font-size    : 13px;\r\n                    height       : 40px;\r\n                    border-radius: 8px;\r\n                    padding-left : 15px;\r\n                    padding-right: 15px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .accountform {\r\n        small {\r\n            font-size: 12px;\r\n            color    : rgba($black-color, .50);\r\n        }\r\n\r\n        .freeshipping {\r\n            height       : 40px;\r\n            border-radius: 8px;\r\n            border       : 1px solid rgba(0, 0, 0, 0.15);\r\n            padding-left : 15px;\r\n            padding-right: 15px;\r\n            width        : 100%;\r\n\r\n            b {\r\n                font-weight: 500;\r\n                color      : $black-color;\r\n                font-size  : 13px;\r\n            }\r\n\r\n            span {\r\n                color      : rgba($black-color, .50);\r\n                font-size  : 13px;\r\n                font-weight: 400;\r\n\r\n                b {\r\n                    font-weight: 500;\r\n                    color      : $black-color;\r\n                }\r\n            }\r\n        }\r\n\r\n        .form-check {\r\n            padding-left: 0;\r\n\r\n            .form-check-input {\r\n                margin: 0 5px 0 0;\r\n\r\n                &:checked {\r\n                    background-color: $primary-color;\r\n                    border-color    : $primary-color;\r\n                }\r\n            }\r\n\r\n            label {\r\n                font-size: 13px;\r\n                color    : $black-color;\r\n\r\n                span {\r\n                    font-weight: bold;\r\n                    color      : $primary-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .customtabs {\r\n        display       : flex;\r\n        flex-direction: row;\r\n        border        : none;\r\n        gap           : 5px;\r\n\r\n        li {\r\n            &.nav-item {\r\n                flex : 1;\r\n                width: 33.33%;\r\n\r\n                button {\r\n                    &.nav-link {\r\n                        width          : 100%;\r\n                        height         : 100%;\r\n                        display        : flex;\r\n                        flex-direction : column;\r\n                        font-size      : 11px;\r\n                        text-align     : center;\r\n                        line-height    : normal;\r\n                        align-items    : center;\r\n                        justify-content: center;\r\n                        width          : 100%;\r\n                        height         : 100%;\r\n                        border         : 1px solid rgba($primary-color, .13);\r\n                        background     : $white-color;\r\n                        border-radius  : 8px;\r\n                        color          : $black-color;\r\n                        padding        : 6px;\r\n\r\n                        span {\r\n                            width          : 31px;\r\n                            height         : 31px;\r\n                            border-radius  : 50%;\r\n                            border         : 1px solid rgba($primary-color, .13);\r\n                            background     : rgba($primary-color, .06);\r\n                            color          : $primary-color;\r\n                            display        : inline-flex;\r\n                            align-items    : center;\r\n                            justify-content: center;\r\n\r\n                            svg {\r\n                                font-size: 17px;\r\n                            }\r\n\r\n                            margin-bottom: 12px;\r\n                        }\r\n\r\n                        &.active {\r\n                            border    : 1px solid $primary-color;\r\n                            background: $primary-color;\r\n                            color     : $white-color;\r\n\r\n                            span {\r\n                                border    : 1px solid rgba($white-color, .13);\r\n                                background: rgba($white-color, .06);\r\n                                color     : $white-color;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.benddetailsmodal {\r\n    .modal-dialog {\r\n        max-width: 626px;\r\n\r\n        .modal-content {\r\n            .modal-body {\r\n                .bend-img-main {\r\n                    width: 154px;\r\n\r\n                    @media only screen and (max-width:767.98px) {\r\n                        margin: 0 auto;\r\n                    }\r\n\r\n                    .bend-img {\r\n                        width          : 154px;\r\n                        height         : 160px;\r\n                        border-radius  : 12px;\r\n                        background     : $white-color;\r\n                        box-shadow     : 0px 0px 10px rgba($black-color, 0.07);\r\n                        display        : flex;\r\n                        align-items    : center;\r\n                        justify-content: center;\r\n                        padding        : 10px;\r\n                        border         : 1px solid rgba($black-color, .1);\r\n\r\n                        img {\r\n\r\n                            object-fit: contain;\r\n                            height: 130px;\r\n\r\n                        }\r\n                    }\r\n\r\n                    h2 {\r\n                        text-align : center;\r\n                        font-size  : 20px;\r\n                        color      : $black-color;\r\n                        font-weight: 700;\r\n                        white-space: normal;\r\n                        word-break: break-all;\r\n                    }\r\n\r\n                    p {\r\n                        font-size  : 11px;\r\n                        text-align : center;\r\n                        font-weight: 500;\r\n                        color      : rgba($black-color, .5);\r\n                        margin     : 15px 0px 9px;\r\n\r\n                        span {\r\n                            color: $black-color\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .bend-content {\r\n                    .bends-upload-file {\r\n                        background   : rgba($black-color, 0.03);\r\n                        border       : 1px dashed rgba($black-color, 0.25);\r\n                        border-radius: 20px;\r\n                        padding      : 10px;\r\n                        text-align   : center;\r\n\r\n                        svg {\r\n                            font-size: 42px;\r\n                        }\r\n\r\n                        small {\r\n                            font-size  : 12px;\r\n                            font-weight: 500;\r\n                            color      : $black-color;\r\n                        }\r\n\r\n                        p {\r\n                            label {\r\n                                color        : $primary-color;\r\n                                font-weight  : 500;\r\n                                border-bottom: 1px solid $primary-color;\r\n                                line-height  : normal;\r\n                            }\r\n\r\n                            font-size: 13px;\r\n                            opacity  : 1;\r\n                            margin   : 10px 0px 5px;\r\n                        }\r\n                    }\r\n\r\n                    .bend-quantity {\r\n                        display       : flex;\r\n                        flex-direction: row;\r\n                        align-items   : center;\r\n\r\n                        h5 {\r\n                            font-size  : 18px;\r\n                            font-weight: 600;\r\n                            color      : $black-color;\r\n\r\n                            @media only screen and (max-width:1199.98px) {\r\n                                font-size: 16px;\r\n                            }\r\n                        }\r\n\r\n                        .input-group {\r\n                            max-width: 109px;\r\n\r\n                            .form-control {\r\n                                border     : none;\r\n                                padding    : 0px;\r\n                                height     : 30px;\r\n                                font-weight: 700;\r\n                            }\r\n\r\n                            button {\r\n                                width          : 30px;\r\n                                height         : 30px;\r\n                                border         : 1px solid $black-color;\r\n                                border-radius  : 6px;\r\n                                display        : inline-flex;\r\n                                align-items    : center;\r\n                                justify-content: center;\r\n                                background     : transparent;\r\n                                padding        : 0px;\r\n\r\n                                &:hover {\r\n                                    background: $black-color;\r\n\r\n                                    svg {\r\n                                        color: $white-color\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .bend-title {\r\n                        display        : flex;\r\n                        align-items    : center;\r\n                        justify-content: space-between;\r\n\r\n                        .btn-close {\r\n                            width              : 28px;\r\n                            height             : 28px;\r\n                            background-color   : $primary-color;\r\n                            border-radius      : 50%;\r\n                            padding            : 0 !important;\r\n                            background-size    : 10px;\r\n                            background-position: center;\r\n                            opacity            : 1;\r\n                            position           : absolute;\r\n                            top                : -14px;\r\n                            right              : -8px;\r\n                            background-image   : url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\r\n                        }\r\n\r\n                        .btn {\r\n                            height     : 35px;\r\n                            line-height: 13px !important;\r\n                            min-width  : 99px;\r\n                        }\r\n\r\n                        h2 {\r\n                            font-size  : 22px;\r\n                            color      : $black-color;\r\n                            font-weight: bold;\r\n\r\n                            @media only screen and (max-width:1199.98px) {\r\n                                font-size: 18px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n/*Quotes Detail Css Ends*/\r\n@media only screen and (min-width:1200px) {\r\n    .width-258 {\r\n        width: 258px !important\r\n    }\r\n\r\n    .w-calc-100-258 {\r\n        width: calc(100% - 258px) !important\r\n    }\r\n}\r\n.custom_h2{\r\n    font-size: 22px;\r\n    color: #000000;\r\n    font-weight: bold;\r\n}\r\n.toggle-switch-container .container {\r\n    text-align: center;\r\n  }\r\n  .toggle-switch-container p {\r\n    font-size: 12px;\r\n    color: rgba(0, 0, 0, 0.5);\r\n    margin-bottom: 7px;\r\n}\r\n.toggle-switch-container  .toggle-switch {\r\n    position: relative;\r\n    width: 60px;\r\n    display: inline-block;\r\n    text-align: left;    \r\n    top: 0;\r\n    margin-left: 5px;\r\n  }\r\n.toggle-switch-container  .checkbox {\r\n    display: none;\r\n  }\r\n.toggle-switch-container  .label {\r\n    display: block;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    border: 0 solid #bbb;\r\n    border-radius: 20px;\r\n  }\r\n  .toggle-switch-container .inner {\r\n    display: block;\r\n    width: 200%;\r\n    margin-left: -100%;\r\n    transition: margin 0.3s ease-in 0s;\r\n  }\r\n .toggle-switch-container .inner:before,\r\n  .toggle-switch-container .inner:after {\r\n    float: left;\r\n    width: 50%;\r\n    height: 28px;\r\n    padding: 0;\r\n    line-height: 28px;\r\n    color: #fff;\r\n    font-weight: bold;\r\n    box-sizing: border-box;\r\n  }\r\n  .custom_tooltip .tooltip-inner {\r\n    max-width: 305px;\r\n    border: none;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.07);\r\n    border-radius: 12px;\r\n    padding: 10px 10px;\r\n    background-color: white;\r\n    color: #000;\r\n}\r\n  .custom_tooltip {\r\n    padding: 9px 0px;\r\n    opacity: 0.99 !important;\r\n  }\r\n  .custom_tooltip .tooltip-arrow{\r\n    top: 0px !important;\r\n  }\r\n  .custom_tooltip .tooltip-arrow:before {\r\n    border-bottom-color: white !important;\r\n  }\r\n  .toggle-switch-container .inner:before {\r\n    content: \"in\";\r\n    padding-left: 6px;\r\n    background-color:red;\r\n    color: #fff;\r\n  }\r\n .toggle-switch-container .inner:after {\r\n    content: \"mm\";\r\n    padding-right: 6px;\r\n    background-color: $primary-color;\r\n   \r\n    color: #fff;\r\n    text-align: right;\r\n  }\r\n .toggle-switch-container .switch {\r\n    display: block;\r\n    width: 28px;\r\n    margin: 0px;\r\n    background: #fff;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 32px;\r\n    border: 0 solid #bbb;\r\n    border-radius: 20px;\r\n    transition: all 0.3s ease-in 0s;\r\n    box-shadow: 0px 0px 11px 0px rgb(0 0 0 / 20%);\r\n  }\r\n  .toggle-switch-container .checkbox:checked + .label .inner {\r\n    margin-left: 0;\r\n  }\r\n  .toggle-switch-container .checkbox:checked + .label .switch {\r\n    right: 0px;\r\n  }\r\n\r\n  .submenu {\r\n    padding-left: 20px; /* Indent for sub-menu */\r\n  }\r\n  \r\n  .submenu-item {\r\n    font-size: 14px; /* Smaller font for sub-menu items */\r\n    color: #888;\r\n  }\r\n  \r\n  .submenu-item:hover {\r\n    color: #000;\r\n  }\r\n  .quote_div_main_sect {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 5px;\r\n}\r\n.quote_div_main_sect .main_service_clr {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    background-color: $white-color;\r\n    padding: 8px;\r\n}\r\n\r\n.quote_div_main_sect .main_service_clr .form-check {\r\n    min-height: auto;\r\n}\r\n.quote_div_main_sect .custom_bend_div {\r\n    margin-right: 10px;\r\n}\r\n.quote_div_main_sect a.btnicon {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n.quote_div_main_sect .custom_bend_div p {\r\n    margin-bottom: 5px;\r\n    font-size: 13px;\r\n    color: rgba(0, 0, 0, 0.8);\r\n    font-weight: 500;\r\n}\r\n.quote_div_main_sect a.btnicon svg {\r\n    font-size: 14px;\r\n}\r\n\r\n.text-color-shipping{\r\n    text-align: center;\r\n}\r\n.text-color-shipping span{\r\n    font-size: 14px;\r\n    color:rgba($black-color, .50);\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.text-color-shipping p{\r\n    font-size: 14px;\r\n    color: $black-color;\r\n    margin-bottom: 10px;\r\n    font-weight: 600;\r\n}\r\n.text-color-shipping .rfq-reasons-table{\r\n    text-align: left;\r\n}\r\n.proceedCheckout_modal {\r\n    .modal-content {\r\n        .modal-body {\r\n            padding: 20px;\r\n            .shipping_info {\r\n                .shipping_head {\r\n                    font-size: 18px;\r\n                    font-weight: 700;\r\n                    margin-bottom: 10px;\r\n                    color: $black-color;\r\n                }\r\n                .addresses-grid {\r\n                    min-height: 200px;\r\n                    h2 {\r\n                        font-size: 18px;\r\n                    }\r\n                    p {\r\n                        font-size: 14px;\r\n                        margin-bottom: 10px;\r\n                    }\r\n                }\r\n                .bill_addr_name {\r\n                    .form-check {\r\n                        label {\r\n                            font-size: 14px;\r\n                        }\r\n                    }\r\n                    .form-select {\r\n                        height: 50px;\r\n                        border: 1px solid rgba($black-color, 0.1);\r\n                        border-radius: 10px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n                .ship_methods {\r\n                    hr {\r\n                        display: none;\r\n                    }\r\n                    .head-quotes {\r\n                        display: none!important;\r\n                    }\r\n                    .rate-option {\r\n                        label {\r\n                            font-size: 14px;\r\n                        }\r\n                        &.ShippingMethodCheckbox_div {\r\n                            .Edit-price-btn {\r\n                                width: 32px;\r\n                                height: 32px;\r\n                                border: 1px solid $black-color;\r\n                                border-radius: 6px;\r\n                                display: inline-flex;\r\n                                align-items: center;\r\n                                justify-content: center;\r\n                                background-color: transparent;\r\n                                color: $black-color;\r\n                                font-size: 18px;\r\n                                padding: 0px;\r\n                                outline: 0px;\r\n                                box-shadow: none; \r\n                                &:hover {\r\n                                    background: $black-color;\r\n                                    border: 1px solid $black-color;\r\n                                    color: $white-color;\r\n                                }\r\n                            }\r\n                            label {\r\n                                display: inline-flex;\r\n                                align-items: center;  \r\n                                .ShippingMethodCount_div {\r\n                                    display: inline-flex;\r\n                                    align-items: center;  \r\n                                    gap: 10px;\r\n                                    input.addNumber_input {\r\n                                        height: 36px;\r\n                                        border-radius: 5px;\r\n                                        padding: 4px 10px;\r\n                                        box-sizing: border-box;\r\n                                        display: inline-block;\r\n                                        outline: 0px;\r\n                                        border: 1px solid rgba(0, 0, 0, 0.1);\r\n                                        font-size: 14px;\r\n                                        width: auto;\r\n                                        max-width: 110px;\r\n                                    }   \r\n                                    .save-price-btn {\r\n                                        width: 36px;\r\n                                        height: 36px;\r\n                                        border: 1px solid rgb(1, 148, 60);\r\n                                        border-radius: 6px;\r\n                                        display: inline-flex;\r\n                                        align-items: center;\r\n                                        justify-content: center;\r\n                                        background-color: transparent;\r\n                                        color: rgb(1, 148, 60);\r\n                                        font-size: 24px;\r\n                                        padding: 0px;\r\n                                        outline: 0px;\r\n                                        box-shadow: none; \r\n                                        &:hover {\r\n                                            background: rgb(1, 148, 60);\r\n                                            color: $white-color;\r\n                                        }                                   \r\n                                    }   \r\n                                    .cancel-price-btn {\r\n                                        width: 36px;\r\n                                        height: 36px;\r\n                                        border: 1px solid rgba(225, 31, 38, 0.6);\r\n                                        border-radius: 6px;\r\n                                        display: inline-flex;\r\n                                        align-items: center;\r\n                                        justify-content: center;\r\n                                        background-color: transparent;\r\n                                        color: rgba(225, 31, 38, 0.6);\r\n                                        font-size: 24px;\r\n                                        padding: 0px;\r\n                                        outline: 0px;\r\n                                        box-shadow: none;  \r\n                                        &:hover {\r\n                                            background: rgba(225, 31, 38, 1);\r\n                                            color: $white-color;\r\n                                        }                               \r\n                                    }   \r\n                                }                        \r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                .cards_sect {\r\n                    .payment-grids {\r\n                        p.card-no {\r\n                            margin: 0px 0px 10px !important;\r\n                            line-height: normal;\r\n                        }\r\n                        .card-actions {\r\n                            margin-bottom: 0px;\r\n                        }\r\n                    }\r\n                    &.paymentTab_div {\r\n                        .nav-tabs {\r\n                            border: 0px;\r\n                            gap: 10px;\r\n                            li.nav-item {\r\n                                .nav-link {\r\n                                    border: 0px !important;\r\n                                    background: #e8e8e8;\r\n                                    border-radius: 10px;\r\n                                    font-size: 14px;\r\n                                    color: #444;\r\n                                    text-transform: capitalize;\r\n                                    padding: 10px 20px;\r\n                                    &.active {\r\n                                        background: $primary-color;\r\n                                        color: $white-color;\r\n                                    }\r\n                                }                           \r\n                            }\r\n                        }\r\n                        .tab-content {\r\n                            .netTerms_flex {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                \r\n                                label {\r\n                                    font-size: 14px;\r\n                                    flex-shrink: 0;\r\n                                    margin-right: 10px;\r\n                                }\r\n                                input {\r\n                                    max-width: 170px;\r\n                                    padding: 10px;\r\n                                    border: 1px solid rgba($black-color, .1);\r\n                                    border-radius: 10px;\r\n                                    font-size: 14px;\r\n                                    outline: 0px;\r\n                                    box-shadow: none;\r\n                                }\r\n                            }\r\n                            .POupload_field {\r\n                                display: flex;\r\n                                align-items: center;\r\n                                \r\n                                label {\r\n                                    font-size: 14px;\r\n                                    flex-shrink: 0;\r\n                                    margin-right: 10px;\r\n                                }                           \r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                .main_price  {\r\n                    background: rgba($black-color, 0.04);\r\n                    padding: 10px;\r\n                    border-radius: 10px;\r\n                    .quotesitem {\r\n                        font-size: 14px;\r\n                    }\r\n                    .quotessubtotal , .quotesprice {\r\n                        font-size: 14px;\r\n                        font-weight: 600;\r\n                    }\r\n                }\r\n                .footer_btn {\r\n                    text-align: center;\r\n                    margin-top: 15px;\r\n                    .btn {\r\n                        min-width: 120px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.AddBendDtl_Modal {\r\n    .modal-content {\r\n        .modal-body {\r\n            .bend-content {\r\n                .file-previews {\r\n                    .addNumber_input {\r\n                        height: 42px;\r\n                        border-radius: 5px;\r\n                        padding: 4px 10px;\r\n                        box-sizing: border-box;\r\n                        display: inline-block;\r\n                        outline: 0px;\r\n                        border: 1px solid rgba($black-color, 0.1);\r\n                        font-size: 14px;     \r\n                        width: auto;                   \r\n                    }\r\n                   \r\n                    .addbend_flex {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        gap: 10px;\r\n                        margin-bottom: 10px;\r\n                    }\r\n                    .save-price-btn {\r\n                        width: 42px;\r\n                        height: 42px;\r\n                        border: 1px solid rgb(1, 148, 60);\r\n                        border-radius: 6px;\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background-color: transparent;\r\n                        color: rgb(1, 148, 60);\r\n                        font-size: 24px;\r\n                        padding: 0px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        &:hover {\r\n                            border: 1px solid rgb(1, 148, 60);\r\n                            background-color:  rgb(1, 148, 60);\r\n                            color: $white-color;\r\n                        }\r\n                    }\r\n                    .cancel-price-btn {\r\n                        width: 42px;\r\n                        height: 42px;\r\n                        border: 1px solid rgba($danger-color, 0.6);\r\n                        border-radius: 6px;\r\n                        display: inline-flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        background-color: transparent;\r\n                        color: rgba($danger-color, 0.6);\r\n                        font-size: 24px;\r\n                        padding: 0px;\r\n                        outline: 0px;\r\n                        box-shadow: none;\r\n                        &:hover {\r\n                            border: 1px solid $danger-color;\r\n                            background-color: $danger-color;\r\n                            color: $white-color;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.QuoteBillMain_div {\r\n    background: $white-color;\r\n    border: 1px solid #e6e6e6;\r\n    padding: 20px;\r\n    border-radius: 15px;\r\n    margin-bottom: 20px;\r\n    .QuoteBill_box {\r\n        margin-bottom: 15px;\r\n        h4 {\r\n            font-size: 18px;\r\n            font-weight: 600;\r\n            color: $black-color;\r\n            margin-bottom: 10px;\r\n        }\r\n        p {\r\n            font-size: 14px;\r\n            font-weight: 400;\r\n            color: rgba($black-color, 0.7);\r\n            margin-bottom: 0px;\r\n        }\r\n    }\r\n    .QuoteBillInfo_box {\r\n        margin-bottom: 15px;\r\n        p {\r\n            font-size: 14px;\r\n            font-weight: 400;\r\n            color: rgba($black-color, 0.7);\r\n            margin-bottom: 5px;\r\n            b {\r\n                color: $black-color;\r\n                font-weight: 600;\r\n                display: inline-block;\r\n                &.minWidth_110 {\r\n                    min-width: 110px;\r\n                }\r\n            }\r\n            .badge_success {\r\n                display: inline-block;\r\n                background-color: rgba(1, 148, 60, 0.3);\r\n                color: rgb(1, 148, 60);\r\n                font-weight: 500;\r\n                padding: 2px 10px;\r\n                border-radius: 20px;\r\n            }\r\n        }\r\n        .QuoteBillDownload_btn {\r\n            background: #4e8ac8;\r\n            color: #000;\r\n            display: inline-flex;\r\n            padding: 10px 12px;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            line-height: normal;\r\n            border-radius: 10px;\r\n        }\r\n    }\r\n    .ShippingLabelDownload_btn {\r\n        background: #E97278 !important;\r\n        color: #ffffff !important;\r\n        display: inline-flex;\r\n        padding: 10px 12px;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        line-height: normal;\r\n        border-radius: 10px;\r\n        border: none !important;\r\n        text-decoration: none !important;\r\n        &:hover {\r\n            opacity: 0.85;\r\n            color: #ffffff !important;\r\n        }\r\n    }\r\n    .QuoteBillInfo_box {\r\n        .ShippingLabelDownload_btn {\r\n            background: #E97278 !important;\r\n            color: #ffffff !important;\r\n        }\r\n    }\r\n}\r\n.viewCustomerTabs_div {\r\n    border: 0px !important;\r\n    margin-top: 10px;\r\n    gap: 15px;\r\n    margin-bottom: 15px!important;\r\n    .nav-item {\r\n        .nav-link {\r\n            border-radius: 10px;\r\n            background: $white-color;\r\n            color: $black-color;\r\n            font-size: 16px;\r\n            font-weight: 600;\r\n            padding: 10px 20px;\r\n            outline: 0px;\r\n            box-shadow: none;\r\n            border: 0px;\r\n            &.active {\r\n                background: $primary-color;\r\n                color: $white-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n.ModalPostOPS_check {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    .form-check {\r\n        padding: 0px;\r\n        .form-check-label {\r\n            background: rgba(#ff8cd3, 0.4);\r\n            padding: 10px 24px;\r\n            line-height: normal;\r\n            font-size: 14px;\r\n            font-weight: 600;\r\n            border-radius: 10px;\r\n        }\r\n        .form-check-input {\r\n            display: none;\r\n            &:checked {\r\n                ~ {\r\n                    .form-check-label {\r\n                        background: #ff8cd3;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// New Post Ops Modal Styling\r\n.postops-modal {\r\n    .modal-dialog {\r\n        max-width: fit-content;\r\n        width: auto;\r\n        margin: 1.75rem auto;\r\n    }\r\n    \r\n    .modal-content {\r\n        width: fit-content;\r\n        min-width: auto;\r\n    }\r\n    \r\n    .modal-body {\r\n        width: fit-content;\r\n        padding: 1rem;\r\n    }\r\n}\r\n\r\n.postops-section {\r\n    margin-bottom: 7px !important;\r\n}\r\n\r\n.postops-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n    gap: 7px;\r\n}\r\n\r\n.postops-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.postops-checkbox {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    margin-right: 0 !important;\r\n    margin-left: 0 !important;\r\n\r\n    &.form-check {\r\n        padding-left: 0 !important;\r\n        padding-right: 0 !important;\r\n    }\r\n\r\n    .form-check-label {\r\n        padding: 6px 0;\r\n        line-height: normal;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n        border-radius: 6px;\r\n        cursor: pointer;\r\n        transition: all 0.2s ease;\r\n        width: 55px;\r\n        text-align: center;\r\n        display: inline-block;\r\n    }\r\n\r\n    .form-check-input {\r\n        display: none;\r\n    }\r\n}\r\n\r\n// F-series - Pink color\r\n.postops-f-series {\r\n    .form-check-label {\r\n        background: rgba($pink-light, 0.15);\r\n        color: $pink-medium;\r\n        border: 1px solid rgba($pink-light, 0.3);\r\n\r\n        &:hover {\r\n            background: rgba($pink-light, 0.25);\r\n        }\r\n    }\r\n\r\n    .form-check-input:checked ~ .form-check-label {\r\n        background: $pink-light;\r\n        color: $white-color;\r\n        border-color: $pink-light;\r\n    }\r\n}\r\n\r\n// B-series - Green color\r\n.postops-b-series {\r\n    .form-check-label {\r\n        background: rgba($green-light, 0.15);\r\n        color: $green-medium;\r\n        border: 1px solid rgba($green-light, 0.3);\r\n\r\n        &:hover {\r\n            background: rgba($green-light, 0.25);\r\n        }\r\n    }\r\n\r\n    .form-check-input:checked ~ .form-check-label {\r\n        background: $green-light;\r\n        color: $white-color;\r\n        border-color: $green-light;\r\n    }\r\n}\r\n\r\n// S-series - Yellow color\r\n.postops-s-series {\r\n    .form-check-label {\r\n        background: rgba($yellow-color, 0.15);\r\n        color: $yellow-dark;\r\n        border: 1px solid rgba($yellow-color, 0.3);\r\n\r\n        &:hover {\r\n            background: rgba($yellow-color, 0.25);\r\n        }\r\n    }\r\n\r\n    .form-check-input:checked ~ .form-check-label {\r\n        background: $yellow-color;\r\n        color: $white-color;\r\n        border-color: $yellow-color;\r\n    }\r\n}\r\n\r\n// C-series - Red color\r\n.postops-c-series {\r\n    .form-check-label {\r\n        background: rgba($red-light, 0.15);\r\n        color: $red-medium;\r\n        border: 1px solid rgba($red-light, 0.3);\r\n\r\n        &:hover {\r\n            background: rgba($red-light, 0.25);\r\n        }\r\n    }\r\n\r\n    .form-check-input:checked ~ .form-check-label {\r\n        background: $red-light;\r\n        color: $white-color;\r\n        border-color: $red-light;\r\n    }\r\n}\r\n\r\n// Other-series - Magenta color\r\n.postops-other-series {\r\n    .form-check-label {\r\n        background: rgba($magenta-light, 0.15);\r\n        color: $magenta-medium;\r\n        border: 1px solid rgba($magenta-light, 0.3);\r\n\r\n        &:hover {\r\n            background: rgba($magenta-light, 0.25);\r\n        }\r\n    }\r\n\r\n    .form-check-input:checked ~ .form-check-label {\r\n        background: $magenta-light;\r\n        color: $white-color;\r\n        border-color: $magenta-light;\r\n    }\r\n}\r\n\r\n// Grid container with two columns\r\n.postops-grid-container {\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n    gap: 20px;\r\n    align-items: center;\r\n    justify-content: start;\r\n}\r\n\r\n// Column 0: Options\r\n.postops-options-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: fit-content;\r\n}\r\n\r\n// Column 1: Legend - centered in available space\r\n.postops-legend-column {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-width: 140px;\r\n}\r\n\r\n// Vertical legend styling\r\n.postops-legend-vertical {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    gap: 6px;\r\n}\r\n\r\n.postops-legend-item-vertical {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 8px;\r\n    min-height: 28px;\r\n}\r\n\r\n.postops-legend-color {\r\n    display: inline-block;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 4px;\r\n    border: 1px solid;\r\n}\r\n\r\n.postops-legend-column .postops-legend-code {\r\n    width: 30px;\r\n    padding: 0 4px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    text-align: center;\r\n    line-height: 20px;\r\n}\r\n\r\n.postops-legend-b {\r\n    background: rgba($green-light, 0.15);\r\n    border-color: rgba($green-light, 0.3);\r\n}\r\n\r\n.postops-legend-s {\r\n    background: rgba($yellow-color, 0.15);\r\n    border-color: rgba($yellow-color, 0.3);\r\n}\r\n\r\n.postops-legend-c {\r\n    background: rgba($red-light, 0.15);\r\n    border-color: rgba($red-light, 0.3);\r\n}\r\n\r\n.postops-legend-other {\r\n    background: rgba($magenta-light, 0.15);\r\n    border-color: rgba($magenta-light, 0.3);\r\n}\r\n\r\n.postops-legend-label {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: $dark-color;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n// Three columns layout - compact and left-aligned\r\n.postops-three-columns {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n    gap: 7px;\r\n    justify-content: flex-start;\r\n    align-items: flex-start;\r\n}\r\n\r\n// ============================================================================\r\n// UNIFIED POST OPS TAG STYLING\r\n// ============================================================================\r\n// All post ops tags throughout the app use these unified styles.\r\n// Classes: .postOpsTagCheckbox_box (orders-detail), .DragItemPost_box (edit-quote), .tagFilter_btn (orders-list filters)\r\n// ============================================================================\r\n\r\n.postOpsTagCheckbox_box,\r\n.DragItemPost_box,\r\n.tagFilter_btn {\r\n    position: relative;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    padding: 4px 10px;\r\n    margin-bottom: 5px;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    line-height: normal;\r\n    transition: all 0.2s ease;\r\n    min-width: 55px;\r\n    width: 55px;\r\n    \r\n    span {\r\n        background: transparent !important;\r\n        border: none !important;\r\n        padding: 0 !important;\r\n        display: inline !important;\r\n        color: inherit;\r\n    }\r\n    \r\n    // Series-specific colors - F (pink), B (green), S (yellow), C (red)\r\n    &.postops-lineitem-f-series {\r\n        background: rgba($pink-light, 0.15) !important;\r\n        color: $pink-medium !important;\r\n        border: 1px solid rgba($pink-light, 0.3) !important;\r\n\r\n        &:hover {\r\n            background: rgba($pink-light, 0.25) !important;\r\n        }\r\n\r\n        &.active {\r\n            background: $pink-light !important;\r\n            color: $white-color !important;\r\n            border-color: $pink-light !important;\r\n        }\r\n    }\r\n\r\n    &.postops-lineitem-b-series {\r\n        background: rgba($green-light, 0.15) !important;\r\n        color: $green-medium !important;\r\n        border: 1px solid rgba($green-light, 0.3) !important;\r\n\r\n        &:hover {\r\n            background: rgba($green-light, 0.25) !important;\r\n        }\r\n\r\n        &.active {\r\n            background: $green-light !important;\r\n            color: $white-color !important;\r\n            border-color: $green-light !important;\r\n        }\r\n    }\r\n\r\n    &.postops-lineitem-s-series {\r\n        background: rgba($yellow-color, 0.15) !important;\r\n        color: $yellow-dark !important;\r\n        border: 1px solid rgba($yellow-color, 0.3) !important;\r\n\r\n        &:hover {\r\n            background: rgba($yellow-color, 0.25) !important;\r\n        }\r\n\r\n        &.active {\r\n            background: $yellow-color !important;\r\n            color: $white-color !important;\r\n            border-color: $yellow-color !important;\r\n        }\r\n    }\r\n\r\n    &.postops-lineitem-c-series {\r\n        background: rgba($red-light, 0.15) !important;\r\n        color: $red-medium !important;\r\n        border: 1px solid rgba($red-light, 0.3) !important;\r\n\r\n        &:hover {\r\n            background: rgba($red-light, 0.25) !important;\r\n        }\r\n\r\n        &.active {\r\n            background: $red-light !important;\r\n            color: $white-color !important;\r\n            border-color: $red-light !important;\r\n        }\r\n    }\r\n\r\n    &.postops-lineitem-other-series {\r\n        background: rgba($magenta-light, 0.15) !important;\r\n        color: $magenta-medium !important;\r\n        border: 1px solid rgba($magenta-light, 0.3) !important;\r\n\r\n        &:hover {\r\n            background: rgba($magenta-light, 0.25) !important;\r\n        }\r\n\r\n        &.active {\r\n            background: $magenta-light !important;\r\n            color: $white-color !important;\r\n            border-color: $magenta-light !important;\r\n        }\r\n    }\r\n}\r\n\r\n// Cutting operation tag filter buttons - fixed width for consistency\r\n.tagFilter_btn_cutting {\r\n    position: relative;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    padding: 10px 12px;\r\n    margin-bottom: 5px;\r\n    border-radius: 10px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    line-height: normal;\r\n    text-transform: uppercase;\r\n    border: 0px;\r\n    color: #ffffff;\r\n    transition: all 0.2s ease;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n    width: 70px;\r\n    \r\n    &:hover {\r\n        filter: brightness(0.85);\r\n        transform: translateY(-1px);\r\n    }\r\n    \r\n    &.active {\r\n        filter: brightness(0.75);\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    }\r\n}\r\n\r\n// Override margin for nested contexts where wrapper handles spacing\r\n.postOpsCheckbox_div .postOpsTagCheckbox_box {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n// Spacing for tag + checkbox wrapper rows in orders-detail page\r\n.postOpsCheckbox_div > div.d-flex.align-items-center.gap-2 {\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.btncstm {\r\n    color: $black-color;\r\n    border-bottom:none;\r\n    border-radius: 0;\r\n    font-size: 14px;\r\n&:hover{\r\n    opacity: 0.75;\r\n}\r\n}\r\n\r\n.modal_header_blocking {\r\n    .modal-body {\r\n        p {\r\n            color: $black-color;\r\n        }\r\n    }\r\n}\r\n.smalltext{\r\n    font-size: 12px;\r\n    color:$paragraph-color;\r\n    display: block;\r\n    margin-top: -5px;\r\n}.iconinfotext{\r\n    top:-5px;\r\n    right: -5px;\r\n}\r\n.baseratecustom{\r\n    background-color: #F7F7F7;\r\n    border-radius: 12px;\r\n    padding: 12px;\r\n    border: 1px dashed $black-color;\r\n    .react-tooltip__show{\r\n        z-index: 1050;\r\n        opacity: 1 !important;\r\n    }\r\n    // z-index: 1;\r\n    .baseratetitle{\r\n        font-size: 14px;\r\n        color: $black-color;\r\n        font-weight: 500;\r\n    }\r\n    .labeltitle{\r\n        font-size: 14px!important;\r\n        color: $black-color!important;\r\n        font-weight: 500!important;\r\n        text-align: center;  \r\n        line-height: normal;\r\n        small{\r\n            display: block;\r\n            font-size: 10px;\r\n        }\r\n    }\r\n    .closebtn{\r\n        border: none;\r\n        position: absolute;\r\n        top: 3px;\r\n        background: transparent;\r\n        right: 7px;\r\n    }\r\n}\r\n.badgestatus.badgeadded-Aluminium {\r\n    display: none;\r\n}\r\n.badgestatus.badgeadded-Steel {\r\n    display: none;\r\n}\r\n.badgestatus.badgeadded-Stainless {\r\n    display: none;\r\n}\r\n.custom-table .rdt_TableRow.highlight-aluminium:first-child .badgestatus.badgeadded-Aluminium {\r\n    display: block !important;\r\n}\r\n.custom-table .highlight-aluminium + .highlight-steel .badgestatus.badgeadded-Steel {\r\n    display: block !important;\r\n}\r\n.custom-table .highlight-steel + .highlight-stainless .badgestatus.badgeadded-Stainless {\r\n    display: block !important;\r\n}\r\n.shippingbg_box {\r\n    background: rgba($black-color, .04);\r\n    padding: 15px;\r\n    border-radius: 15px;\r\n    .rate-option {\r\n        padding-bottom: 15px;\r\n        &:last-child {\r\n            padding-bottom: 0px;\r\n        }\r\n        input[type=\"checkbox\"] {\r\n            margin-top: 4px;\r\n            flex-shrink: 0;\r\n        }\r\n        label {\r\n            b {\r\n                font-weight: 600;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.draft_default {\r\n    font-size: 14px;\r\n    border-radius: 30px;\r\n    min-width: 62px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: #635252;\r\n    padding: 0 9px;\r\n    height: 25px;\r\n    line-height: 25px;\r\n    margin-bottom: 0px;\r\n    border: 1px solid #ccc;\r\n}\r\n.btncustom {\r\n    background: rgba(78, 138, 200, 0.25)!important;\r\n    padding: 4px 10px!important;\r\n    color:$black-color;\r\n    border-radius: 30px!important;\r\n    &:hover{\r\n        background: $primary-color!important;\r\n        color:$white-color!important\r\n    }\r\n}\r\n.quote_scroll_cls{\r\n    scrollbar-width: none;\r\n        height: auto !important;\r\n        overflow: visible!important;\r\n        > div{\r\n                height: auto !important;\r\n        }\r\n      .quotelist {\r\n    position: initial !important;\r\n    height: auto !important;\r\n}\r\n}\r\n\r\n// Markup Badge for Shipping Methods\r\n.markup-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 10px;\r\n  margin-top: 2px;\r\n  margin-bottom: 10px;\r\n  background-color: #e8f5e9;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #2e7d32;\r\n  border: 1px solid #c8e6c9;\r\n  transition: all 0.2s ease-in-out;\r\n\r\n  svg {\r\n    font-size: 14px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  .markup-percentage {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .markup-amount {\r\n    font-size: 11px;\r\n    color: #388e3c;\r\n    opacity: 0.8;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n\r\n// Bulk Update Panel Styles\r\n.bulk-update-panel {\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  padding: 16px 14px;\r\n  margin-bottom: 20px;\r\n\r\n  .form-check {\r\n    margin-bottom: 0;\r\n\r\n    .form-check-label {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      color: #495057;\r\n      cursor: pointer;\r\n      user-select: none;\r\n    }\r\n\r\n    .form-check-input {\r\n      cursor: pointer;\r\n      margin-top: 0.15em;\r\n    }\r\n  }\r\n\r\n  // Compact quantity selector for bulk update\r\n  .input-group {\r\n    max-width: 110px;\r\n\r\n    .form-control {\r\n      max-width: 46px;\r\n      padding: 0.375rem 0.25rem;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .btn {\r\n      padding: 0.375rem 0.5rem;\r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n  .bulk-update-btn {\r\n    height: 38px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n\r\n    &:disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.65;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 14px 12px;\r\n\r\n    .bulk-update-btn {\r\n      height: 40px;\r\n    }\r\n  }\r\n}\r\n","// ============================================\n// SHARED VARIABLES - Single Source of Truth\n// ============================================\n// Used by: Customer Portal, Admin Portal, Employee Portal\n//\n// DO NOT create duplicate variable files!\n// Import this file in all stylesheets:\n// @import \"../styles/variables\"\n// ============================================\n\n// ============================================\n// PRIMARY BRAND COLORS\n// ============================================\n// $primary-color:#4F8CCA; // Old blue (commented out)\n$primary-color: #3c5b8a;      // Main brand blue\n$secondary-color: #1F2E60;    // Dark navy\n$darkblue-color: #324b74;     // Medium blue\n\n// ============================================\n// STATUS & SEMANTIC COLORS\n// ============================================\n$danger-color: #E11F26;       // Red (errors, delete actions)\n$green-color: #2A5C17;        // Green (success states)\n$yellow-color: #FFBA16;       // Yellow (warnings)\n$yellow-color2: #ffda3f;      // Light yellow (highlights)\n$yellow-dark: #b38200;        // Dark yellow (text on yellow backgrounds)\n$purple-color: #7367F0;       // Purple (accent)\n\n// ============================================\n// POST OPS TAG COLORS\n// ============================================\n$pink-light: #ff8cd3;         // Pink (F-series tags)\n$pink-medium: #d65ba8;        // Dark pink (F-series text)\n$green-light: #4caf50;        // Green (B-series tags)\n$green-medium: #2e7d32;       // Dark green (B-series text)\n$red-light: #ef5350;          // Red (C-series tags)\n$red-medium: #c62828;         // Dark red (C-series text)\n$magenta-light: #d946ef;      // Magenta (Other-series tags)\n$magenta-medium: #a21caf;     // Dark magenta (Other-series text)\n\n// ============================================\n// NEUTRAL COLORS\n// ============================================\n$paragraph-color: #6C6A72;    // Body text gray\n$light-color: #bfbfbf;        // Light gray (borders, disabled states)\n$black-color: #000000;        // True black\n$dark-color: #212121;         // Dark gray (headings)\n$white-color: #ffffff;        // True white\n\n// ============================================\n// TYPOGRAPHY\n// ============================================\n$font-family: \"Inter\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
